<div
  [ngClass]="
    !fromSummary
      ? 'card p-4 border-0 container-fluid shadow rounded-4 w-100 step-body-scroll'
      : ''
  "
  *ngIf="orderDetailsNew"
  style="max-width: none"
  #pdfContent
  id="pdfContent"
>
  <div class="row mx-2">
    <div class="col p-0">
      <div style="display: flex; align-items: left; margin-left: -20px">
        <button
          *ngIf="!fromSummary"
          class="btn back-btn"
          (click)="closePopup()"
          aria-label="Back"
        >
          <mat-icon class="back-icon">arrow_back</mat-icon>
        </button>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          padding-left: 21px;
          padding-right: 12px;
        "
      >
        <div>
          <div>
            <h5 class="mb-0">Order Details</h5>
          </div>
          <span style="font-size: 14px; color: #707070"
            >Task ID: #{{
              orderDetailsNew.taskId ? orderDetailsNew.taskId : taskId
            }}
            - {{ statusMap.get(taskDetails?.status) || "Draft" }}</span
          >

          <div #sectionToPdf>
            <div
              class="d-flex flex-wrap justify-content-between align-items-center"
            >
              <div
                class="d-flex align-items-center justify-content-center gap-2"
                *ngIf="dataService.role == 'designer'"
              >
                <div *ngIf="notifictionsState == 'NOTIFIED'">
                  <button
                    class="notificationButtonDecline"
                    (click)="updateTask(taskId, 'decline')"
                  >
                    Decline order
                  </button>
                  <button
                    class="notificationButtonAccept"
                    (click)="updateTask(taskId, 'accept')"
                  >
                    Accept order
                  </button>
                </div>
              </div>
              <div
                class="d-flex align-items-center justify-content-center gap-2"
                *ngIf="dataService.role == 'designer'"
              >
                <div *ngIf="notifictionsState === 'CANCELED'">
                  <button
                    class="notificationButtonAccept"
                    (click)="submitReview(taskId)"
                  >
                    Submit Review
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mx-2">
        <div class="col p-0">
          <div
            style="
              background: #faf9f9;
              margin-top: 0.5rem;
              padding-top: 10px;
              padding-bottom: 10px;
            "
            class="row m-2 border rounded d-flex"
          >
            <div
              class="left"
              style="
                display: flex;
                width: 220px;
                align-items: center;
                gap: 12px;
              "
            >
              <div style="padding-top: 6px">
                <img src="icons/{{ orderDetailsNew.tier }}-star.png" />
              </div>
              <div>
                <div
                  class="tier-card-title"
                  style="
                    font-style: normal;
                    font-weight: 400;
                    font-size: 20px;
                    line-height: 130%;
                    color: #000000;
                  "
                >
                  {{ orderDetailsNew.tier }}
                </div>
                <div
                  class="tier-card-subtitle"
                  style="
                    font-style: normal;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 130%;
                    color: #707070;
                  "
                >
                  {{ getPlanSubTitleFromTier }}
                </div>
              </div>
            </div>
            <div class="separator" style="width: 1px; padding: 0px"></div>

            <div
              class="left"
              style="
                display: flex;
                width: 150px;
                align-items: center;
                gap: 12px;
                padding: 0px;
                justify-content: center;
              "
            >
              <div class="orderDetails-svg">
                <img src="icons/refresh.png" />
              </div>
              <div>
                <div class="order-details">
                  {{ orderDetailsNew.remainingCorrections }} revision
                </div>
              </div>
            </div>
            <div class="separator" style="width: 1px; padding: 0px"></div>

            <div
              class="left"
              style="
                display: flex;
                width: 220px;
                align-items: center;
                gap: 10px;
                padding: 0px;
                justify-content: center;
              "
            >
              <div class="orderDetails-svg">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_728_9838)">
                    <path
                      d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34872 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99076 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27289 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7118 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333Z"
                      fill="black"
                    />
                    <path
                      d="M9.99998 5.22595C9.77896 5.22595 9.567 5.31375 9.41072 5.47003C9.25444 5.62631 9.16664 5.83827 9.16664 6.05929V9.66345L6.35748 11.4235C6.16961 11.5408 6.03607 11.728 5.98621 11.9438C5.93636 12.1596 5.97428 12.3864 6.09164 12.5743C6.209 12.7621 6.39618 12.8957 6.612 12.9455C6.82783 12.9954 7.05461 12.9575 7.24248 12.8401L10.4425 10.8401C10.5634 10.7644 10.6628 10.6588 10.7312 10.5336C10.7997 10.4085 10.8348 10.2678 10.8333 10.1251V6.05929C10.8333 5.83827 10.7455 5.62631 10.5892 5.47003C10.433 5.31375 10.221 5.22595 9.99998 5.22595Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_728_9838">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div>
                <div class="order-details">
                  {{ orderDetailsNew.deliveryTime }} hours delivery
                </div>
              </div>
            </div>
            <div class="separator" style="width: 1px; padding: 0px"></div>

            <div
              class="left"
              style="
                display: flex;
                width: 150px;
                align-items: center;
                gap: 10px;
                padding: 0px;
                justify-content: center;
              "
            >
              <div class="orderDetails-svg">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_728_9849)">
                    <path
                      d="M15 20H8.6975L8.94 18.975C9.06471 18.4922 9.14065 17.998 9.16667 17.5C9.16667 17.058 8.99107 16.634 8.67851 16.3215C8.36595 16.0089 7.94203 15.8333 7.5 15.8333C7.05797 15.8333 6.63405 16.0089 6.32149 16.3215C6.00893 16.634 5.83333 17.058 5.83333 17.5C5.85935 17.998 5.93529 18.4922 6.06 18.975L6.3025 20H0V7.5C0 6.83696 0.263392 6.20107 0.732233 5.73223C1.20107 5.26339 1.83696 5 2.5 5H4.39333C4.26136 4.45359 4.18541 3.89515 4.16667 3.33333C4.16667 2.44928 4.51786 1.60143 5.14298 0.976311C5.7681 0.35119 6.61594 0 7.5 0C8.38406 0 9.2319 0.35119 9.85702 0.976311C10.4821 1.60143 10.8333 2.44928 10.8333 3.33333C10.8146 3.89515 10.7386 4.45359 10.6067 5H12.5C13.163 5 13.7989 5.26339 14.2678 5.73223C14.7366 6.20107 15 6.83696 15 7.5V8.97667C15.5465 8.84521 16.1049 8.76927 16.6667 8.75C17.5507 8.75 18.3986 9.10119 19.0237 9.72631C19.6488 10.3514 20 11.1993 20 12.0833C20 12.9674 19.6488 13.8152 19.0237 14.4404C18.3986 15.0655 17.5507 15.4167 16.6667 15.4167C16.1049 15.3974 15.5465 15.3215 15 15.19V20ZM10.7617 18.3333H13.3333V12.985L14.4092 13.3117C15.1408 13.5501 15.899 13.6973 16.6667 13.75C17.1087 13.75 17.5326 13.5744 17.8452 13.2618C18.1577 12.9493 18.3333 12.5254 18.3333 12.0833C18.3333 11.6413 18.1577 11.2174 17.8452 10.9048C17.5326 10.5923 17.1087 10.4167 16.6667 10.4167C15.899 10.4694 15.1408 10.6166 14.4092 10.855L13.3333 11.1817V7.5C13.3333 7.27899 13.2455 7.06702 13.0893 6.91074C12.933 6.75446 12.721 6.66667 12.5 6.66667H8.40167L8.72833 5.59083C8.96694 4.85928 9.11417 4.10103 9.16667 3.33333C9.16667 2.89131 8.99107 2.46738 8.67851 2.15482C8.36595 1.84226 7.94203 1.66667 7.5 1.66667C7.05797 1.66667 6.63405 1.84226 6.32149 2.15482C6.00893 2.46738 5.83333 2.89131 5.83333 3.33333C5.88583 4.10103 6.03305 4.85928 6.27167 5.59083L6.59833 6.66667H2.5C2.27899 6.66667 2.06702 6.75446 1.91074 6.91074C1.75446 7.06702 1.66667 7.27899 1.66667 7.5V18.3333H4.23833C4.19495 18.0576 4.171 17.7791 4.16667 17.5C4.16667 16.6159 4.51786 15.7681 5.14298 15.143C5.7681 14.5179 6.61594 14.1667 7.5 14.1667C8.38406 14.1667 9.2319 14.5179 9.85702 15.143C10.4821 15.7681 10.8333 16.6159 10.8333 17.5C10.829 17.7791 10.805 18.0576 10.7617 18.3333Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_728_9849">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div>
                <div class="order-details">
                  {{ getAllToothCountFromOrderDetails }} unit
                </div>
              </div>
            </div>
            <!-- <i class="fa-light fa-circle-dollar"></i> -->
            <div class="separator" style="width: 1px; padding: 0px"></div>

            <div
              class="left"
              style="
                display: flex;
                width: 220px;
                align-items: center;
                gap: 10px;
              "
            >
              <div class="orderDetails-svg">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_728_9859)">
                    <path
                      d="M10 0C4.48583 0 0 4.48583 0 10C0 15.5142 4.48583 20 10 20C15.5142 20 20 15.5142 20 10C20 4.48583 15.5142 0 10 0ZM10 18.3333C5.405 18.3333 1.66667 14.595 1.66667 10C1.66667 5.405 5.405 1.66667 10 1.66667C14.595 1.66667 18.3333 5.405 18.3333 10C18.3333 14.595 14.595 18.3333 10 18.3333ZM8.33333 8.33333C8.33333 8.64833 8.55917 8.915 8.87 8.96667L11.4042 9.38917C12.5225 9.575 13.3333 10.5333 13.3333 11.6667C13.3333 13.045 12.2117 14.1667 10.8333 14.1667V15.8333H9.16667V14.1667C7.78833 14.1667 6.66667 13.045 6.66667 11.6667H8.33333C8.33333 12.1267 8.70667 12.5 9.16667 12.5H10.8333C11.2933 12.5 11.6667 12.1267 11.6667 11.6667C11.6667 11.3517 11.4408 11.085 11.13 11.0333L8.59583 10.6108C7.4775 10.425 6.66667 9.46667 6.66667 8.33333C6.66667 6.955 7.78833 5.83333 9.16667 5.83333V4.16667H10.8333V5.83333C12.2117 5.83333 13.3333 6.955 13.3333 8.33333H11.6667C11.6667 7.87417 11.2933 7.5 10.8333 7.5H9.16667C8.70667 7.5 8.33333 7.87417 8.33333 8.33333Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_728_9859">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div>
                <div class="order-details">
                  <span
                    >{{ getOrderAmount.toFixed(2).replace(".", ",") }}€</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-overlay" *ngIf="showPreviewModal">
        <div class="modal-content">
          <button class="close-btn" (click)="closePreview()">
            <mat-icon style="margin: 0; padding: 0">close</mat-icon>
          </button>

          <img
            *ngIf="selectedFileType === 'image'"
            [src]="previewUrl"
            class="image-preview"
          />
          <iframe
            *ngIf="selectedFileType === 'pdf' && safePdfUrl"
            [src]="safePdfUrl"
            width="100%"
            height="600px"
            style="border: none"
          >
          </iframe>
          <iframe
            *ngIf="selectedFile?.type === 'html'"
            [src]="selectedFile.url"
            width="100%"
            height="600px"
            style="border: none"
          >
          </iframe>
          <div
            *ngIf="selectedFileType === 'stl'"
            #stlContainer
            class="stl-viewer"
          ></div>
        </div>
      </div>

      <div *ngIf="fileDetailsScan.length > 0 || previewData.length > 0">
        <div class="row mx-2">
          <div class="col p-0">
            <h6 style="margin-top: 25px">Scan Files</h6>
          </div>
        </div>

        <div class="row mx-2 mb-3">
          <div
            class="col-4 text-center px4"
            *ngFor="let file of fileDetailsScan"
            style="padding-left: 0px"
          >
            <div class="fileDownload-card">
              <div style="text-align: left">
                <div class="file-name" [title]="file.fileName">
                  {{ file.fileName }}
                </div>
                <div class="file-size">File</div>
              </div>

              <div style="display: flex; gap: 6px">
                <button
                  *ngIf="!file.fileName.toLowerCase().endsWith('.zip')"
                  class="action-btn"
                  (click)="openPreview(file)"
                >
                  <mat-icon>visibility</mat-icon>
                </button>

                <button
                  class="action-btn"
                  (click)="downloadFile(file.fileId, file.fileName)"
                >
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div
            class="col-4 text-center px4"
            *ngFor="let file of previewData"
            style="padding-left: 0px"
          >
            <div class="fileDownload-card">
              <div style="text-align: left">
                <div class="file-name" [title]="file.name">
                  {{ file.name }}
                </div>
              </div>

              <div style="display: flex; gap: 6px">
                <button class="action-btn" (click)="openPreviewFromBlob(file)">
                  <mat-icon>visibility</mat-icon>
                </button>

                <button class="action-btn" (click)="downloadPreviewFile(file)">
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div *ngIf="showElements" class="col-4 text-center px4">
            <div class="spinner-grow" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mx-2">
      <div class="col p-0 d-flex gap-3" style="justify-content: flex-start">
        <div>
          <button
            *ngIf="taskDetails && (taskDetails.status !== 'PP' || taskId === 0)"
            style="
              background-image: none;
              background-color: #000000;
              border-radius: 6px;
              height: 50px;
            "
            class="customPreCreateTaskButtons"
            (click)="downloadAllFiles()"
          >
            Download all files
          </button>
        </div>
        <div>
          <button
            *ngIf="taskDetails && (taskDetails.status !== 'PP' || taskId === 0)"
            style="
              background-image: none;
              background-color: #000000;
              border-radius: 6px;
              height: 50px;
            "
            class="customPreCreateTaskButtons"
            (click)="openCommentModal()"
          >
            Dentist/Designer Messages
          </button>
        </div>
        <!-- <div *ngIf="dataService.role == 'doctor'">
  <div *ngFor="let file of fileDetailsVisual">
    <button 
      *ngIf="file.fileType === 'visual' 
          || file.fileType === 'correctedvisual'"
      (click)="previewZip(file)"
      style="background-image: none; background-color: #000000; border-radius: 6px; height: 50px;"
      class="customPreCreateTaskButtons">
      <i class="fa-solid fa-eye"></i> Preview
    </button>
  </div>
</div> -->
      </div>
    </div>
  </div>

  <!-- <div class="modal-overlay" *ngIf="showPreviewModal">

  <div class="modal-content">

    <div class="modal-header">
      <h5>File Preview</h5>
       <button class="customPreActivatedButtons1 p-1"  style="background-color: #000000;" (click)="showPreviewModal = false">
        <mat-icon >close</mat-icon>
      </button>
    </div>

    <div class="modal-body">

      <div *ngIf="previewData.length === 0" style="text-align:center;">
        <p>No preview available for this file.</p>
        <p>Download to view in external software.</p>
      </div>
<div *ngFor="let file of previewData">

  <p>{{file.name}}</p>

  <div *ngIf="file.type === 'stl'" 
       style="width:100%; height:400px; border:1px solid #ccc;"
       #stlContainer>
  </div>
 </div>

    </div>

  </div>
</div>

  

</div> -->
  <br />
  <!-- <div class="preview-container" *ngIf="showPreviewModal">
      <div class="file-list">
        <div *ngFor="let file of previewData" class="file-item" [class.active]="selectedFile?.name === file.name"
          (click)="selectFile(file)">
          <mat-icon class="file-icon">
            {{ getFileIcon(file.type) }}
          </mat-icon>

          <span class="file-name">{{ file.name }}</span>
        </div>
      </div>
      <div class="preview-area">
        <div *ngIf="!selectedFile" class="empty-preview">
          <mat-icon>folder_open</mat-icon>
          <p>Select a file to preview</p>
        </div>

        <div *ngIf="selectedFile?.type === 'stl'" #stlContainer class="stl-viewer">
        </div>

      </div>

    </div> -->
  <div class="row mx-2">
    <div class="col p-0 mt-4">
      <h6 class="mb-1">Task Details</h6>
    </div>
  </div>
  <div class="row m-2 border rounded">
    <div class="col-12" *ngIf="!fromSummary">
      <div class="d-flex gap-3" style="justify-content: flex-end">
        <!-- <div class="row">
          <div class="col">
            <button matTooltipPosition="left" matTooltip="Complete" *ngIf="dataService.role == 'designer' && taskDetails.status == 'IP'" mat-icon-button (click)="completeTask(taskId, orderDetailsNew.refNum)"><mat-icon>check_circle</mat-icon></button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <button matTooltipPosition="left" matTooltip="Feedback" *ngIf="dataService.role == 'doctor' && taskDetails.status == 'PF'" mat-icon-button (click)="openFeedbackModal(taskId, orderDetailsNew.refNum)"><mat-icon>feedback</mat-icon></button>
          </div>
        </div> -->

        <div
          class="row mb-2 d-none"
          *ngIf="
            taskDetails.status != 'IP' &&
            taskDetails.status != 'PP' &&
            dataService.role == 'doctor'
          "
        >
          <div class="col d-flex justify-content-end">
            <!-- <button *ngIf="taskDetails.status != 'PP'" matTooltipPosition="left" matTooltip="Scan Files {{fileCountsScan[taskId]}}, Design Files {{fileCountsDesign[taskId]}}" mat-icon-button (click)="showSliderFile.value = !showSliderFile.value">
              <mat-icon aria-hidden="false" style="color:#205567;--mat-badge-background-color: {{fileCountsNew[taskId] > 0 ? '#005cbb;' : 'grey'}}" matBadge="{{fileCountsTotal[taskId]}}">attach_file</mat-icon>
            </button> -->

            <!-- showSliderFile.value = !showSliderFile.value -->
            <div class="toolbar" data-html2canvas-ignore>
              <!-- <button class="selected-chip  hoverExtendedButtons" (click)="openFeedbackDialog()">
              <img src="icons/check-icon.png"/>Design Feedback
            </button> -->
            </div>

            <!-- <div class="show-slider-background" *ngIf="showSliderFile.value" ></div>
            <div class="slider" [ngClass]="{ 'show': showSliderFile.value }" style="border-start-start-radius: 10px; border-bottom-left-radius: 10px;">
              <div class="slider-content">
                <app-files [taskId]="taskId" [showSlider]="showSliderFile" (fileCounts)="updateFileCounts($event)"></app-files>
              </div>
            </div> -->
          </div>
        </div>
        <!-- class="no-pdf" -->
        <div class="toolbar d-none" data-html2canvas-ignore>
          <div class="row mb-2">
            <div class="col d-flex justify-content-end">
              <!-- <button *ngIf="taskDetails.status != 'PP'" matTooltipPosition="left" matTooltip="Scan Files {{fileCountsScan[taskId]}}, Design Files {{fileCountsDesign[taskId]}}" mat-icon-button (click)="showSliderFile.value = !showSliderFile.value">
              <mat-icon aria-hidden="false" style="color:#205567;--mat-badge-background-color: {{fileCountsNew[taskId] > 0 ? '#005cbb;' : 'grey'}}" matBadge="{{fileCountsTotal[taskId]}}">attach_file</mat-icon>
            </button> -->

              <!-- showSliderFile.value = !showSliderFile.value -->
              <!-- <button class="selected-chip hoverExtendedButtons" (click)="openFilesModalForDownload(orderDetailsNew.taskId)">
              <img src="icons/download-icon.png"/>Download Scan Files
            </button> -->

              <!-- <div class="show-slider-background" *ngIf="showSliderFile.value" ></div>
            <div class="slider" [ngClass]="{ 'show': showSliderFile.value }" style="border-start-start-radius: 10px; border-bottom-left-radius: 10px;">
              <div class="slider-content">
                <app-files [taskId]="taskId" [showSlider]="showSliderFile" (fileCounts)="updateFileCounts($event)"></app-files>
              </div>
            </div> -->
            </div>
          </div>
        </div>
        <!-- <div class="row mb-2">
          <div class="col d-flex justify-content-end gap-2">
            <button mat-flat-button color="primary" class="selected-chip" (click)="updateTaskacceptance('AC')">Accept</button>
            <button mat-flat-button color="warn" class="selected-chip" (click)="updateTaskacceptance('RE')">Reject</button>
          </div>
        </div>
         -->

        <div class="row mb-2 d-none" *ngIf="dataService.role == 'designer'">
          <div class="col d-flex justify-content-end">
            <!-- <button *ngIf="taskDetails.status != 'PP'" matTooltipPosition="left" matTooltip="Scan Files {{fileCountsScan[taskId]}}, Design Files {{fileCountsDesign[taskId]}}" mat-icon-button (click)="showSliderFile.value = !showSliderFile.value">
              <mat-icon aria-hidden="false" style="color:#205567;--mat-badge-background-color: {{fileCountsNew[taskId] > 0 ? '#005cbb;' : 'grey'}}" matBadge="{{fileCountsTotal[taskId]}}">attach_file</mat-icon>
            </button> -->
            <div class="toolbar" data-html2canvas-ignore>
              <!-- <button  class="selected-chip hoverExtendedButtons" (click)="openFilesModal()">
              <img src="icons/check-icon.png"/>Deliver Design
            </button> -->
            </div>
            <!-- <div class="show-slider-background" *ngIf="showSliderFile.value" ></div>
            <div class="slider" [ngClass]="{ 'show': showSliderFile.value }" style="border-start-start-radius: 10px; border-bottom-left-radius: 10px;">
              <div class="slider-content">
                <app-files [taskId]="taskId" [showSlider]="showSliderFile" (fileCounts)="updateFileCounts($event)"></app-files>
              </div>
            </div> -->
          </div>
        </div>

        <div class="row">
          <div class="col d-flex justify-content-end">
            <!-- <button *ngIf="taskDetails.status != 'PP'" matTooltipPosition="left" matTooltip="Comments" mat-icon-button (click)="showSliderComments.value = !showSliderComments.value">
              <mat-icon aria-hidden="false" style="--mat-badge-background-color: {{commentCountsNew[taskId] > 0 ? '#005cbb;' : 'grey'}}" matBadge="{{commentCountsTotal[taskId]}}">chat</mat-icon>
            </button> -->
            <!-- showSliderComments.value = !showSliderComments.value -->

            <!-- </div> -->
            <!-- <div class="show-slider-background" *ngIf="showSliderComments.value" ></div>
            <div class="slider" [ngClass]="{ 'show': showSliderComments.value }" style="border-start-start-radius: 10px; border-bottom-left-radius: 10px;">
              <div class="slider-content align-content-end">
                <app-comments [taskId]="taskId" [showSlider]="showSliderComments" (fileCounts)="updateFileCounts($event)"></app-comments>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="col-4 text-center px-4">
      <div class="info-card">
        <div class="mb-0">
          <div class="col text-center" style="color: #205567">
            <svg
              width="auto"
              height="120"
              viewBox="0 -4 137.90352 43.070606"
              version="1.1"
              id="svg1"
            >
              <g id="layer1" transform="translate(-47.003152,-118.35056)">
                <g id="g92">
                  <path
                    [attr.fill]="getTextColorForVisual('11')"
                    d="m 115.09069,127.72105 c -0.0529,-0.50006 -0.1561,-0.98425 -0.43656,-1.41552 -0.0238,-0.037 -0.037,-0.0847 -0.045,-0.13494 -0.0847,-0.0556 -0.16404,-0.11906 -0.23548,-0.18785 -0.003,-0.003 -0.005,-0.005 -0.005,-0.008 -0.0106,-0.005 -0.0212,-0.0132 -0.0344,-0.0185 -0.003,0.003 -0.003,0.008 -0.005,0.0106 -0.0873,-0.0556 -0.17727,-0.12171 -0.25135,-0.19579 0.003,0.0318 0.003,0.0635 0.005,0.0979 -1.19856,-0.59267 -2.38654,-0.82021 -3.62215,-0.0926 0.003,-0.0106 0.003,-0.0212 0.005,-0.0318 -0.1217,0.0953 -0.25135,0.17992 -0.38893,0.25136 -0.0212,0.0106 -0.0423,0.0238 -0.0635,0.0344 0,0 0,0 0,0.003 -0.0661,0.13494 -0.1614,0.23019 -0.26988,0.30692 -0.25135,0.31485 -0.38364,0.68527 -0.47096,1.07685 -0.13229,0.6006 -0.15345,1.21179 -0.13493,1.82298 0,0.23283 -0.005,0.46302 0,0.69585 0.0185,0.61384 0.11906,1.21444 0.30427,1.80182 0.20637,0.64822 0.78581,1.02922 1.43668,0.95514 0.15611,-0.0185 0.30428,0.003 0.45509,0.0582 0.49212,0.17992 1.00277,0.20637 1.51606,0.11906 0.19579,-0.0344 0.38365,-0.0529 0.57944,0.0185 0.0953,0.0344 0.20902,0.0238 0.31221,0.0238 0.41804,-0.005 0.69056,-0.20373 0.8255,-0.59267 0.0238,-0.0662 0.0423,-0.13494 0.0635,-0.20108 0.16139,-0.51065 0.23018,-1.03982 0.32014,-1.56634 0.15081,-0.93662 0.24077,-1.87854 0.14023,-2.83104 z m -0.52123,1.92881 c -0.0873,0.66146 -0.21166,1.31763 -0.32808,1.97379 -0.0291,0.15875 -0.0926,0.30957 -0.127,0.46832 -0.0503,0.23812 -0.20638,0.38629 -0.56356,0.32279 -0.0265,-0.005 -0.0556,-0.0132 -0.11113,-0.0291 0.0212,-0.19843 0.0397,-0.38629 0.0609,-0.5715 0.0503,-0.47625 0.0503,-0.9525 0.0159,-1.43139 -0.003,-0.0423 -0.008,-0.0847 -0.0185,-0.12436 -0.0344,-0.16668 -0.12435,-0.23812 -0.27781,-0.22225 -0.13494,0.0159 -0.21167,0.10848 -0.20638,0.26723 0.005,0.15346 0.0238,0.30692 0.0318,0.46302 0.0238,0.52917 -0.0344,1.0504 -0.10848,1.58221 -0.59531,0.15346 -1.15887,0.0794 -1.73831,-0.16933 -0.0106,-0.39952 -0.0265,-0.81227 -0.0318,-1.22502 -0.003,-0.17463 0.0212,-0.34925 0.0291,-0.52652 0.003,-0.0635 0.0106,-0.127 0.003,-0.18786 -0.0132,-0.11377 -0.10054,-0.1905 -0.20902,-0.20373 -0.12171,-0.0132 -0.21167,0.0291 -0.254,0.14023 -0.0238,0.0635 -0.0318,0.13494 -0.037,0.20638 -0.0344,0.50535 -0.037,1.01071 -0.005,1.51606 0.005,0.0979 0,0.19315 0,0.29104 -0.3175,0.0212 -0.61648,-0.16139 -0.74084,-0.48948 -0.0979,-0.254 -0.17198,-0.52123 -0.21696,-0.7911 -0.18785,-1.09008 -0.18256,-2.18017 -0.008,-3.2729 0.0423,-0.27252 0.11641,-0.5371 0.25664,-0.77523 0.0688,-0.11906 0.14817,-0.25135 0.254,-0.33072 0.43657,-0.3228 0.89165,-0.60855 1.44992,-0.68528 0.48419,-0.0661 0.95515,-0.005 1.41023,0.15611 0.3175,0.11112 0.61912,0.26458 0.92339,0.40481 0.16934,0.0767 0.26194,0.23019 0.33603,0.39423 0.12435,0.26988 0.1852,0.55827 0.2196,0.85196 0.0873,0.66675 0.082,1.33614 -0.008,1.9976 z"
                    id="path730"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('11')"
                    d="m 113.44234,132.38301 c 0.0212,-0.19844 0.0397,-0.38629 0.0609,-0.5715 0.0503,-0.47625 0.0503,-0.9525 0.0159,-1.4314 -0.003,-0.0423 -0.008,-0.0847 -0.0185,-0.12435 -0.0344,-0.16669 -0.12436,-0.23813 -0.27782,-0.22225 -0.13493,0.0159 -0.21166,0.10848 -0.20637,0.26723 0.005,0.15346 0.0238,0.30691 0.0317,0.46302 0.0238,0.52917 -0.0344,1.05039 -0.10848,1.58221 -0.59531,0.15346 -1.15888,0.0794 -1.73831,-0.16934 -0.0106,-0.39952 -0.0265,-0.81227 -0.0318,-1.22502 -0.003,-0.17462 0.0212,-0.34925 0.0291,-0.52652 0.003,-0.0635 0.0106,-0.127 0.003,-0.18785 -0.0132,-0.11377 -0.10055,-0.1905 -0.20902,-0.20373 -0.12171,-0.0132 -0.21167,0.0291 -0.254,0.14023 -0.0238,0.0635 -0.0318,0.13494 -0.037,0.20637 -0.0344,0.50536 -0.037,1.01071 -0.005,1.51607 0.005,0.0979 0,0.19314 0,0.29104 -0.3175,0.0212 -0.61648,-0.1614 -0.74083,-0.48948 -0.0979,-0.254 -0.17198,-0.52123 -0.21696,-0.79111 -0.18785,-1.09008 -0.18256,-2.18016 -0.008,-3.27289 0.0423,-0.27252 0.11642,-0.53711 0.25665,-0.77523 0.0688,-0.11906 0.14817,-0.25136 0.254,-0.33073 0.43656,-0.32279 0.89164,-0.60854 1.44992,-0.68527 0.48418,-0.0662 0.95514,-0.005 1.41022,0.1561 0.3175,0.11113 0.61913,0.26459 0.9234,0.40482 0.16933,0.0767 0.26194,0.23018 0.33602,0.39422 0.12436,0.26988 0.18521,0.55828 0.21961,0.85196 0.082,0.66675 0.0767,1.3335 -0.0132,1.99761 -0.0873,0.66146 -0.21167,1.31762 -0.32809,1.97379 -0.0291,0.15875 -0.0926,0.30956 -0.127,0.46831 -0.0503,0.23813 -0.20637,0.38629 -0.56356,0.32279 -0.0212,-0.003 -0.0503,-0.0132 -0.10583,-0.0291 z"
                    id="path763"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('11')"
                    id="text789"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="110.10896"
                    y="122"
                  >
                    11
                  </text>
                </g>
                <g id="g91">
                  <path
                    [attr.fill]="getTextColorForVisual('12')"
                    d="m 107.53684,129.97001 c -0.0767,-0.73025 -0.21961,-1.44198 -0.49477,-2.12725 -0.0106,-0.0265 -0.0132,-0.0582 -0.0185,-0.09 -0.005,-0.008 -0.0132,-0.0159 -0.0212,-0.0265 -0.13758,-0.20637 -0.17727,-0.46566 -0.30956,-0.66939 -0.003,-0.005 -0.005,-0.008 -0.008,-0.0106 0.0132,0.0238 0.0159,0.0423 -0.0529,-0.0265 -0.082,-0.0847 -0.15875,-0.18256 -0.22489,-0.2831 0.003,0.0212 0.003,0.0423 0.005,0.0635 -0.17727,-0.16404 -0.30692,-0.29369 -0.4445,-0.4101 -0.28046,-0.23284 -0.59531,-0.40217 -0.96309,-0.43921 -0.43127,-0.0423 -0.79904,0.11377 -1.12977,0.37306 -0.0688,0.0529 -0.13758,0.11377 -0.21166,0.17727 -0.0185,0.0397 -0.037,0.0794 -0.0582,0.11642 -0.11377,0.1905 -0.26988,0.31485 -0.45244,0.43656 -0.0476,0.0635 -0.0873,0.12965 -0.12435,0.20108 -0.0423,0.0926 -0.0952,0.17463 -0.1614,0.24871 -0.037,0.13759 -0.082,0.27517 -0.14023,0.41275 -0.39952,0.92869 -0.63235,1.905 -0.70644,2.91571 -0.0185,0.25665 -0.0132,0.52388 0.0344,0.77523 0.11377,0.59796 0.54504,1.16152 1.31233,1.28058 0.29634,0.045 0.59002,0.11907 0.88371,0.17992 0.10319,0.0212 0.20638,0.037 0.31221,0.0529 0.51329,0.082 1.02394,0.0291 1.52929,-0.0767 0.25136,-0.0529 0.50536,-0.12436 0.73819,-0.23548 0.39423,-0.18521 0.635,-0.50536 0.67733,-0.94986 0.0344,-0.37041 0.0609,-0.74083 0.0847,-1.0742 -0.0185,-0.29634 -0.0291,-0.55563 -0.0556,-0.81492 z m -0.46567,1.26471 c -0.0106,0.1905 -0.0265,0.37835 -0.0476,0.56621 -0.0397,0.3466 -0.2884,0.58737 -0.70115,0.66939 0.0106,-0.13494 0.0238,-0.26723 0.0265,-0.39952 0.0106,-0.52917 -0.0344,-1.05304 -0.12171,-1.57427 -0.0291,-0.17198 -0.14023,-0.26458 -0.28575,-0.24342 -0.15346,0.0212 -0.23283,0.15082 -0.20108,0.33338 0.0979,0.55033 0.13229,1.10066 0.10583,1.65894 -0.005,0.11112 -0.0212,0.22225 -0.0344,0.3466 -0.61912,0.11906 -1.21973,0.0979 -1.83091,-0.12435 -0.0185,-0.20109 -0.0476,-0.40746 -0.0582,-0.61648 -0.0238,-0.47096 -0.003,-0.94192 0.0609,-1.41023 0.008,-0.0635 0.0185,-0.127 0.0185,-0.18786 0,-0.13758 -0.0794,-0.23548 -0.20108,-0.254 -0.13229,-0.0212 -0.24871,0.0503 -0.27781,0.19579 -0.0344,0.19315 -0.0662,0.38894 -0.0714,0.58473 -0.008,0.47625 0,0.95515 0,1.4314 0,0.0556 0,0.10848 0,0.17727 -0.30956,-0.0291 -0.53446,-0.17992 -0.70644,-0.4154 -0.18256,-0.254 -0.25929,-0.54504 -0.24606,-0.8546 0.045,-1.02129 0.2831,-2.00025 0.65617,-2.94746 0.16933,-0.42862 0.40216,-0.82021 0.71966,-1.15623 0.13494,-0.14287 0.28311,-0.27516 0.4445,-0.38629 0.3519,-0.24077 0.72232,-0.24077 1.09009,-0.0238 0.31485,0.18521 0.55827,0.44714 0.77523,0.73554 0.35454,0.46831 0.54239,1.01071 0.67733,1.57427 0.18256,0.762 0.25135,1.53723 0.20902,2.3204 z"
                    id="path728"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('12')"
                    d="m 106.31975,132.47032 c 0.0106,-0.13494 0.0238,-0.26723 0.0265,-0.39952 0.0106,-0.52917 -0.0344,-1.05304 -0.12171,-1.57427 -0.0291,-0.17198 -0.14023,-0.26458 -0.28575,-0.24342 -0.15345,0.0212 -0.23283,0.15082 -0.20108,0.33338 0.0979,0.55033 0.13229,1.10066 0.10583,1.65894 -0.005,0.11112 -0.0212,0.22225 -0.0344,0.3466 -0.61913,0.11906 -1.21973,0.0979 -1.83092,-0.12435 -0.0185,-0.20109 -0.0476,-0.40746 -0.0582,-0.61648 -0.0238,-0.47096 -0.003,-0.94192 0.0609,-1.41023 0.008,-0.0635 0.0185,-0.127 0.0185,-0.18786 0,-0.13758 -0.0794,-0.23548 -0.20109,-0.254 -0.13229,-0.0212 -0.2487,0.0503 -0.27781,0.19579 -0.0344,0.19315 -0.0661,0.38894 -0.0714,0.58473 -0.008,0.47625 0,0.95515 0,1.4314 0,0.0556 0,0.10848 0,0.17727 -0.30956,-0.0291 -0.53445,-0.17992 -0.70643,-0.4154 -0.18257,-0.254 -0.25929,-0.54504 -0.24607,-0.8546 0.045,-1.02129 0.28311,-2.00025 0.65617,-2.94746 0.16933,-0.42862 0.40217,-0.82021 0.71967,-1.15623 0.13494,-0.14287 0.2831,-0.27516 0.4445,-0.38629 0.35189,-0.24077 0.72231,-0.24077 1.09008,-0.0238 0.31486,0.18521 0.55827,0.44714 0.77523,0.73554 0.35454,0.46831 0.5424,1.01071 0.67733,1.57427 0.18521,0.76465 0.254,1.53723 0.20902,2.3204 -0.0106,0.1905 -0.0265,0.37835 -0.0476,0.56621 -0.0397,0.34925 -0.2884,0.58737 -0.70115,0.66939 z"
                    id="path760"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('12')"
                    id="text790"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="102.79056"
                    y="122"
                  >
                    12
                  </text>
                </g>
                <g id="g90">
                  <path
                    [attr.fill]="getTextColorForVisual('13')"
                    d="m 100.46188,130.01499 c -0.0344,-0.79375 -0.16669,-1.51077 -0.33073,-2.2225 -0.09,-0.38894 -0.156105,-0.78846 -0.338667,-1.14829 -0.08731,-0.17198 -0.129646,-0.34925 -0.150813,-0.53446 -0.0291,-0.0318 -0.05821,-0.0609 -0.08731,-0.0953 -0.103188,-0.11906 -0.227542,-0.21696 -0.330729,-0.33602 -0.04498,-0.0529 -0.08731,-0.10584 -0.129646,-0.1614 0.0026,0.0476 0.0053,0.10319 0.01058,0.17198 -1.063625,-0.82815 -2.119312,-0.88635 -3.225271,-0.0794 0.0053,-0.0318 0.0079,-0.0582 0.01323,-0.0873 -0.03439,0.0265 -0.06614,0.0582 -0.103187,0.0794 -0.08467,0.16669 -0.198438,0.32544 -0.346604,0.4736 -0.06085,0.0609 -0.132292,0.11642 -0.203729,0.16934 -0.04233,0.11641 -0.0926,0.23283 -0.174625,0.33602 -0.03704,0.0476 -0.05821,0.11112 -0.08467,0.16933 -0.386292,0.88371 -0.693208,1.79387 -0.886354,2.74108 -0.07144,0.34661 -0.05821,0.69057 0.108479,1.00542 0.423333,0.79375 0.986896,1.46579 1.783292,1.91823 0.15875,0.09 0.312208,0.1905 0.460375,0.29633 0.402166,0.28575 0.820208,0.53975 1.277937,0.72761 0.22225,0.0926 0.418042,0.0635 0.605896,-0.0926 0.674687,-0.56091 1.262062,-1.19591 1.740966,-1.9341 0.28839,-0.44715 0.4445,-0.92075 0.39158,-1.397 z m -0.695856,0.92869 c -0.46302,0.79904 -1.087437,1.4605 -1.804458,2.05581 -0.460375,-0.17992 -0.85725,-0.42863 -1.243542,-0.70115 -0.153458,-0.10848 -0.312208,-0.21166 -0.478895,-0.30691 -0.714375,-0.40746 -1.214438,-1.00807 -1.598084,-1.7198 -0.103187,-0.1905 -0.121708,-0.39687 -0.07937,-0.61383 0.185209,-0.95515 0.484188,-1.8759 0.894292,-2.75696 0.333375,-0.71702 0.907521,-1.16416 1.680104,-1.34673 0.338667,-0.0794 0.672042,-0.0185 0.986896,0.11642 0.695854,0.29898 1.148292,0.82285 1.349375,1.54781 0.248708,0.90752 0.436562,1.82827 0.494771,2.77284 0.02381,0.33866 -0.0291,0.65616 -0.201084,0.9525 z"
                    id="path739"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('13')"
                    d="m 97.961566,132.99684 c -0.460375,-0.17991 -0.85725,-0.42862 -1.243542,-0.70114 -0.153458,-0.10848 -0.314854,-0.21167 -0.478895,-0.30692 -0.714375,-0.40746 -1.214438,-1.00806 -1.598084,-1.71979 -0.103187,-0.1905 -0.121708,-0.39688 -0.07937,-0.61384 0.185209,-0.95514 0.484188,-1.87589 0.894292,-2.75695 0.333375,-0.71702 0.907521,-1.16417 1.680104,-1.34673 0.338667,-0.0794 0.672042,-0.0185 0.986896,0.11641 0.695854,0.29898 1.148292,0.82286 1.349375,1.54782 0.248708,0.90752 0.436562,1.82827 0.494771,2.77283 0.02117,0.33867 -0.0344,0.65881 -0.203729,0.9525 -0.460375,0.80169 -1.084792,1.46315 -1.801813,2.05581 z m 0.804333,-3.9661 c 0,-0.19579 0.0026,-0.41275 0,-0.63236 -0.0026,-0.1905 -0.01323,-0.37835 -0.02646,-0.56885 -0.0053,-0.10583 -0.05292,-0.1905 -0.15875,-0.22754 -0.164042,-0.0609 -0.328083,0.0529 -0.328083,0.24077 0,0.19579 0.01852,0.39158 0.02381,0.59002 0.01852,1.11919 -0.08467,2.23044 -0.259291,3.3364 -0.01323,0.082 -0.02911,0.16668 -0.03175,0.25135 -0.0053,0.14287 0.07144,0.23548 0.198437,0.25665 0.137583,0.0238 0.246063,-0.045 0.283104,-0.18786 0.01323,-0.0529 0.02381,-0.11112 0.03175,-0.16669 0.137584,-0.94985 0.248709,-1.905 0.267229,-2.89189 z"
                    id="path772"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('13')"
                    d="m 98.765899,129.03074 c -0.01852,0.98689 -0.129645,1.94204 -0.269875,2.89454 -0.0079,0.0556 -0.01852,0.11112 -0.03175,0.16669 -0.03704,0.14287 -0.14552,0.21166 -0.283104,0.18785 -0.127,-0.0212 -0.201083,-0.11377 -0.198437,-0.25664 0.0026,-0.0847 0.01852,-0.16669 0.03175,-0.25136 0.174625,-1.10596 0.277812,-2.21456 0.259291,-3.33639 -0.0026,-0.1958 -0.02381,-0.39159 -0.02381,-0.59003 0,-0.18785 0.164042,-0.30427 0.328083,-0.24077 0.105834,0.0397 0.150813,0.12171 0.15875,0.22755 0.01058,0.18785 0.02117,0.37835 0.02646,0.56885 0.0079,0.21696 0.0026,0.43392 0.0026,0.62971 z"
                    id="path788"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('13')"
                    id="text791"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="95.248901"
                    y="122"
                  >
                    13
                  </text>
                </g>
                <g id="g89">
                  <path
                    [attr.fill]="getTextColorForVisual('14')"
                    d="m 92.159254,127.98034 c -0.113771,-0.45508 -0.259292,-0.90487 -0.391584,-1.35466 -0.03704,-0.12436 -0.08731,-0.24871 -0.111125,-0.37307 -0.195791,-0.10848 -0.388937,-0.28575 -0.542395,-0.4736 0.0026,0.0318 0,0.0635 0,0.12171 -1.11125,-0.49213 -2.201334,-0.53711 -3.31523,-0.0291 0.0026,-0.0238 0.0053,-0.045 0.0053,-0.0661 -0.07938,0.082 -0.206375,0.20108 -0.240771,0.23812 -0.105833,0.11906 -0.22225,0.21431 -0.34925,0.29369 -0.0344,0.15081 -0.07408,0.29898 -0.134937,0.44715 -0.169334,0.41275 -0.259292,0.85989 -0.365125,1.29645 -0.216959,0.91282 -0.338667,1.83621 -0.328084,2.77548 0.0026,0.21432 0.05821,0.39952 0.214313,0.55298 0.124354,0.12436 0.240771,0.254 0.367771,0.37571 0.709083,0.67733 1.521354,1.19592 2.420937,1.58221 0.357188,0.15346 0.682625,0.10054 0.981604,-0.14817 0.42598,-0.35454 0.788459,-0.762 1.06098,-1.24354 0.06879,-0.11906 0.15875,-0.20637 0.277812,-0.28046 0.148167,-0.0926 0.291042,-0.19314 0.428625,-0.30427 0.272521,-0.22225 0.396875,-0.50535 0.375708,-0.86783 -0.04233,-0.85725 -0.145521,-1.70656 -0.354541,-2.54265 z m -0.537104,3.18823 c -0.05556,-0.35189 -0.105834,-0.67469 -0.15875,-1.00012 -0.01058,-0.0688 -0.02646,-0.13759 -0.04762,-0.20373 -0.05027,-0.15346 -0.161396,-0.21167 -0.309563,-0.17463 -0.124354,0.0318 -0.187854,0.14552 -0.164042,0.29634 0.05556,0.36777 0.10848,0.73554 0.166688,1.10331 0.0344,0.22489 -0.0079,0.42069 -0.134938,0.61648 -0.251354,0.38629 -0.552979,0.72496 -0.899583,1.02658 -0.156104,0.13494 -0.3175,0.15875 -0.505354,0.0741 -0.410104,-0.1852 -0.809625,-0.38364 -1.201208,-0.65087 0.05292,-0.29633 0.105833,-0.59002 0.164041,-0.88636 0.03175,-0.16668 0.07937,-0.32808 0.103188,-0.49477 0.0291,-0.20637 -0.137584,-0.3466 -0.325438,-0.28045 -0.105833,0.037 -0.145521,0.127 -0.166687,0.22489 -0.06085,0.29633 -0.119063,0.59267 -0.179917,0.88636 -0.01323,0.0661 -0.0291,0.13493 -0.05292,0.23018 -0.09525,-0.0767 -0.174625,-0.13229 -0.246062,-0.19843 -0.216958,-0.20109 -0.428625,-0.40746 -0.645583,-0.6059 -0.100542,-0.0926 -0.134938,-0.20108 -0.134938,-0.33867 0,-0.84666 0.105833,-1.68275 0.298979,-2.5056 0.105834,-0.44979 0.238125,-0.89429 0.359834,-1.34144 0.08996,-0.33602 0.301625,-0.55827 0.624416,-0.69056 0.92075,-0.37571 1.822979,-0.31486 2.717271,0.09 0.230188,0.10583 0.375708,0.29104 0.452438,0.52916 0.381,1.16682 0.62177,2.36009 0.687916,3.5904 0.01587,0.33867 -0.137583,0.53181 -0.402166,0.70379 z"
                    id="path724"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('14')"
                    d="m 91.62215,131.16857 c -0.05556,-0.35189 -0.105834,-0.67469 -0.15875,-1.00012 -0.01058,-0.0688 -0.02646,-0.13759 -0.04762,-0.20373 -0.05027,-0.15346 -0.161396,-0.21167 -0.309563,-0.17463 -0.124354,0.0318 -0.187854,0.14552 -0.164042,0.29634 0.05556,0.36777 0.10848,0.73554 0.166688,1.10331 0.0344,0.22489 -0.0079,0.42069 -0.134938,0.61648 -0.251354,0.38629 -0.552979,0.72496 -0.899583,1.02658 -0.156104,0.13494 -0.3175,0.15875 -0.505354,0.0741 -0.410104,-0.1852 -0.809625,-0.38364 -1.201208,-0.65087 0.05292,-0.29633 0.105833,-0.59002 0.164041,-0.88636 0.03175,-0.16668 0.07937,-0.32808 0.103188,-0.49477 0.0291,-0.20637 -0.137584,-0.3466 -0.325438,-0.28045 -0.105833,0.037 -0.145521,0.12435 -0.166687,0.22489 -0.06085,0.29633 -0.119063,0.59267 -0.179917,0.88636 -0.01323,0.0661 -0.0291,0.13493 -0.05292,0.23018 -0.09525,-0.0767 -0.174625,-0.13229 -0.246062,-0.19843 -0.216958,-0.20109 -0.428625,-0.40746 -0.645583,-0.6059 -0.100542,-0.0926 -0.134938,-0.20108 -0.134938,-0.33867 0,-0.84666 0.105833,-1.68275 0.298979,-2.5056 0.105834,-0.44979 0.238125,-0.89429 0.359834,-1.34144 0.08996,-0.33602 0.301625,-0.55827 0.624416,-0.69056 0.92075,-0.37571 1.822979,-0.31486 2.717271,0.09 0.230188,0.10583 0.375708,0.29104 0.452438,0.52916 0.381,1.16682 0.62177,2.36009 0.687916,3.5904 0.01587,0.33867 -0.137583,0.53181 -0.402166,0.70379 z"
                    id="path756"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('14')"
                    id="text792"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="87.441498"
                    y="122"
                  >
                    14
                  </text>
                </g>
                <g id="g88">
                  <path
                    [attr.fill]="getTextColorForVisual('15')"
                    d="m 84.848816,130.33778 c -0.0344,-0.96044 -0.148166,-1.82298 -0.328083,-2.67758 -0.06879,-0.3228 -0.111125,-0.65088 -0.277813,-0.94457 -0.01852,-0.0318 -0.01587,-0.0794 -0.01852,-0.1217 0,-0.008 -0.0026,-0.0159 -0.0026,-0.0238 -0.216959,-0.12435 -0.394229,-0.29104 -0.531813,-0.48418 0.0026,0.0344 0.0053,0.0741 0.0079,0.1217 -1.190625,-0.71702 -2.360084,-0.73554 -3.550709,0.0291 0.0026,-0.0212 0.0026,-0.0344 0.0053,-0.0556 -0.111125,0.0979 -0.235479,0.17991 -0.375708,0.2487 -0.01058,0.008 -0.02117,0.0132 -0.03175,0.0212 -0.04762,0.0503 -0.0979,0.0979 -0.150813,0.14288 -0.0291,0.20902 -0.0635,0.41804 -0.127,0.62706 -0.166687,0.55033 -0.283104,1.11654 -0.388937,1.6801 -0.08731,0.46302 -0.137584,0.93398 -0.0979,1.40494 0.05292,0.66146 0.330729,1.18269 0.968375,1.46579 0.111125,0.0503 0.214312,0.13494 0.301625,0.22225 0.478896,0.49477 1.026583,0.89165 1.640417,1.20121 0.182562,0.0926 0.375708,0.13229 0.5715,0.0741 0.402166,-0.11906 0.775229,-0.30427 1.076854,-0.59796 0.381,-0.3757 0.717021,-0.7911 1.000125,-1.24618 0.219604,-0.35984 0.373062,-0.73819 0.309562,-1.08744 z m -0.656166,0.68262 c -0.05292,0.0873 -0.105834,0.17728 -0.198438,0.26194 -0.01323,-0.10054 -0.02646,-0.19844 -0.03969,-0.29898 -0.02646,-0.17462 -0.134938,-0.26987 -0.277813,-0.254 -0.150812,0.0185 -0.224896,0.14817 -0.216958,0.32809 0.01323,0.28045 0.01587,0.56091 0.01058,0.84137 -0.0026,0.0688 -0.03969,0.14817 -0.08467,0.20638 -0.251354,0.3175 -0.584729,0.51858 -0.960437,0.65881 -0.111125,0.0423 -0.211667,0.0423 -0.322792,-0.0132 -0.508,-0.254 -0.965729,-0.5715 -1.370541,-0.96838 -0.08202,-0.0794 -0.127,-0.16139 -0.121709,-0.27516 0.01852,-0.40746 0.03175,-0.81227 0.04762,-1.21973 0.0026,-0.0344 0.01588,-0.0688 0.01588,-0.10319 0.0026,-0.13229 -0.07937,-0.23019 -0.206375,-0.25135 -0.108479,-0.0185 -0.230187,0.0476 -0.267229,0.15875 -0.0291,0.0847 -0.04498,0.17727 -0.05027,0.26723 -0.01852,0.25929 -0.0291,0.51858 -0.04233,0.77787 -0.0026,0.0397 -0.0053,0.0794 -0.01323,0.15346 -0.325438,-0.1561 -0.489479,-0.39688 -0.576792,-0.6985 -0.100542,-0.35454 -0.0635,-0.71173 -0.0291,-1.06627 0.06879,-0.74348 0.232833,-1.46844 0.441854,-2.18281 0.09525,-0.32809 0.28575,-0.56886 0.576792,-0.74613 1.055687,-0.64294 2.071687,-0.53975 3.077104,0.14552 0.169333,0.11642 0.280458,0.28046 0.320146,0.4789 0.116416,0.59796 0.243416,1.19591 0.330729,1.79916 0.06615,0.4445 0.07144,0.8943 0.113771,1.34144 0.03175,0.24077 -0.03175,0.45509 -0.156104,0.65881 z"
                    id="path733"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('15')"
                    d="m 80.099545,131.28763 c -0.325437,-0.1561 -0.489479,-0.39687 -0.576791,-0.6985 -0.100542,-0.35454 -0.0635,-0.71173 -0.0291,-1.06627 0.06879,-0.74348 0.232833,-1.46843 0.441854,-2.18281 0.09525,-0.32808 0.28575,-0.56885 0.576791,-0.74612 1.055688,-0.64294 2.071688,-0.53975 3.077105,0.14552 0.169333,0.11641 0.280458,0.28045 0.320145,0.47889 0.116417,0.59796 0.243417,1.19592 0.33073,1.79917 0.06615,0.4445 0.07144,0.89429 0.11377,1.34144 0.02381,0.24341 -0.03969,0.45773 -0.161395,0.66145 -0.05292,0.0873 -0.105834,0.17728 -0.198438,0.26194 -0.01323,-0.10054 -0.02646,-0.19844 -0.03969,-0.29898 -0.02646,-0.17462 -0.134938,-0.26987 -0.277813,-0.254 -0.150812,0.0185 -0.224896,0.14817 -0.216958,0.32809 0.01323,0.28045 0.01587,0.56091 0.01058,0.84137 -0.0026,0.0688 -0.03969,0.14817 -0.08467,0.20638 -0.251354,0.3175 -0.584729,0.51858 -0.960437,0.65881 -0.111125,0.0423 -0.211667,0.0423 -0.322792,-0.0132 -0.508,-0.254 -0.965729,-0.5715 -1.370541,-0.96838 -0.08202,-0.0794 -0.127,-0.16139 -0.121709,-0.27516 0.01852,-0.40746 0.03175,-0.81227 0.04762,-1.21973 0.0026,-0.0344 0.01588,-0.0688 0.01588,-0.10319 0.0026,-0.13229 -0.07937,-0.23019 -0.206375,-0.25135 -0.108479,-0.0185 -0.230187,0.0476 -0.267229,0.15875 -0.0291,0.0847 -0.04498,0.17727 -0.05027,0.26723 -0.01852,0.25929 -0.0291,0.51858 -0.04233,0.77787 0.0053,0.037 0,0.0767 -0.0079,0.15081 z"
                    id="path766"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('15')"
                    id="text793"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="79.898781"
                    y="122"
                  >
                    15
                  </text>
                </g>
                <g id="g87">
                  <path
                    [attr.fill]="getTextColorForVisual('16')"
                    d="m 77.400796,130.14993 c -0.145521,-0.93134 -0.359834,-1.8468 -0.658813,-2.74109 -0.193146,-0.57414 -0.306917,-1.18798 -0.735542,-1.65364 0.0026,-0.005 0.0026,-0.008 0.0026,-0.0132 -0.0979,-0.0635 -0.185208,-0.14023 -0.267229,-0.21961 -0.0635,-0.0318 -0.124354,-0.0688 -0.182562,-0.10583 -1.648355,-0.38894 -3.288771,-0.48683 -4.947709,0.008 0,0 0,0 0,-0.003 -0.06085,0.0212 -0.124354,0.0344 -0.1905,0.0476 -0.08202,0.10848 -0.179916,0.20902 -0.288396,0.29633 -0.0079,0.0159 -0.02117,0.0317 -0.03969,0.045 -0.256646,0.20637 -0.428625,0.48154 -0.605896,0.75406 -0.587375,0.89958 -1.058333,1.85208 -1.328208,2.89719 -0.124354,0.48154 -0.08996,0.94721 0.113771,1.39964 0.354541,0.78582 0.899583,1.39965 1.640416,1.8415 0.420688,0.25136 0.838729,0.26988 1.254125,0.0185 0.3175,-0.19315 0.635,-0.39159 0.926042,-0.61913 0.235479,-0.18256 0.481542,-0.16669 0.677333,0.0212 0.460375,0.43656 1.016,0.72496 1.608667,0.93398 0.322792,0.11377 0.640292,0.0899 0.936625,-0.0767 0.558271,-0.31486 1.0795,-0.68263 1.539875,-1.13507 0.484187,-0.4736 0.645583,-1.04245 0.545042,-1.69597 z m -0.809625,1.25147 c -0.439209,0.47361 -0.968375,0.83344 -1.526646,1.15094 -0.161396,0.0926 -0.336021,0.0979 -0.510646,0.037 -0.515938,-0.17991 -0.992188,-0.42862 -1.402292,-0.7911 -0.07938,-0.0688 -0.153458,-0.15081 -0.246062,-0.19315 -0.121709,-0.0582 -0.153459,-0.14552 -0.164042,-0.26458 -0.03704,-0.4789 0.0079,-0.95515 0.0926,-1.4261 0.01323,-0.0767 0.03175,-0.15082 0.03704,-0.22755 0.0053,-0.12964 -0.07937,-0.23283 -0.201083,-0.25929 -0.119063,-0.0238 -0.243417,0.045 -0.272521,0.17463 -0.05027,0.24077 -0.09525,0.48154 -0.121709,0.7276 -0.03969,0.34131 -0.06615,0.68527 -0.01852,1.02923 0.0053,0.0344 0,0.0688 0,0.11642 -0.243417,0.0503 -0.41275,0.21166 -0.600605,0.34396 -0.24077,0.16933 -0.492125,0.32279 -0.743479,0.47889 -0.238125,0.14552 -0.473604,0.13759 -0.714375,-0.003 -0.677333,-0.39688 -1.172104,-0.94986 -1.484312,-1.67217 -0.140229,-0.32015 -0.166688,-0.64823 -0.08202,-0.9869 0.248708,-1.00012 0.701146,-1.90764 1.256771,-2.76754 0.06879,-0.10583 0.140229,-0.21166 0.211666,-0.31485 0.343959,-0.50006 0.833438,-0.75142 1.420813,-0.84931 1.180042,-0.1958 2.352146,-0.13494 3.518958,0.0979 0.441854,0.0873 0.743479,0.35454 0.896938,0.77523 0.447146,1.22238 0.809625,2.46856 0.989541,3.75973 0.05292,0.40217 -0.05821,0.76465 -0.33602,1.06362 z"
                    id="path716"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('16')"
                    d="m 72.257296,131.47284 c -0.243417,0.0503 -0.41275,0.21167 -0.600605,0.34396 -0.24077,0.16933 -0.492125,0.32279 -0.743479,0.4789 -0.238125,0.14552 -0.473604,0.13758 -0.714375,-0.003 -0.677333,-0.39687 -1.172104,-0.94985 -1.484312,-1.67217 -0.140229,-0.32014 -0.166688,-0.64823 -0.08202,-0.98689 0.248708,-1.00013 0.701146,-1.90765 1.256771,-2.76754 0.06879,-0.10584 0.140229,-0.21167 0.211666,-0.31486 0.343959,-0.50006 0.833438,-0.75141 1.420813,-0.84931 1.180042,-0.19579 2.352146,-0.13494 3.518958,0.0979 0.441854,0.0873 0.743479,0.35454 0.896938,0.77522 0.447146,1.22238 0.809625,2.46857 0.989541,3.75973 0.05821,0.40746 -0.05292,0.76994 -0.330729,1.06892 -0.439208,0.4736 -0.968375,0.83344 -1.526646,1.15094 -0.161395,0.0926 -0.33602,0.0979 -0.510645,0.037 -0.515938,-0.17992 -0.992188,-0.42863 -1.402292,-0.7911 -0.07937,-0.0688 -0.153458,-0.15082 -0.246063,-0.19315 -0.121708,-0.0582 -0.153458,-0.14552 -0.164041,-0.26458 -0.03704,-0.4789 0.0079,-0.95515 0.0926,-1.42611 0.01323,-0.0767 0.03175,-0.15081 0.03704,-0.22754 0.0053,-0.12965 -0.07937,-0.23283 -0.201084,-0.25929 -0.119062,-0.0238 -0.243416,0.045 -0.272521,0.17462 -0.05027,0.24077 -0.09525,0.48155 -0.121708,0.72761 -0.03969,0.34131 -0.06615,0.68527 -0.01852,1.02923 -0.0026,0.0291 -0.0053,0.0635 -0.0053,0.11112 z"
                    id="path748"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('16')"
                    id="text794"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="70.746895"
                    y="122"
                  >
                    16
                  </text>
                </g>
                <g id="g86">
                  <path
                    [attr.fill]="getTextColorForVisual('17')"
                    d="m 66.521129,130.69761 c -0.211667,-1.28323 -0.510646,-2.54793 -0.891646,-3.79148 -0.06615,-0.21695 -0.142875,-0.42862 -0.288396,-0.60589 -0.04498,-0.0529 -0.05821,-0.10848 -0.0635,-0.16404 -0.05556,-0.045 -0.108479,-0.0953 -0.15875,-0.14552 -0.124354,-0.0529 -0.24077,-0.11642 -0.343958,-0.19315 -0.722312,-0.24077 -1.4605,-0.28046 -2.193396,-0.30692 -0.566208,-0.0212 -1.137708,0.0212 -1.706562,0.0265 -0.298979,0.003 -0.574146,0.0847 -0.862542,0.21696 -0.07673,0.0397 -0.15875,0.0767 -0.243417,0.10583 -0.05292,0.0423 -0.11377,0.0794 -0.174625,0.11642 -0.03175,0.0661 -0.06879,0.13229 -0.105833,0.19579 -0.01058,0.0397 -0.02381,0.0767 -0.03704,0.11377 -0.07673,0.17992 -0.17727,0.3519 -0.246062,0.53446 -0.465667,1.20915 -0.833438,2.44475 -1.034521,3.72798 -0.0926,0.59796 0.119063,1.07685 0.611188,1.4261 0.4445,0.3175 0.93927,0.53182 1.457854,0.6985 0.280458,0.09 0.545041,0.0556 0.780521,-0.1217 0.174625,-0.12965 0.341312,-0.27253 0.505354,-0.4154 0.185208,-0.1614 0.306916,-0.17198 0.508,-0.0344 0.05821,0.0397 0.113771,0.082 0.171979,0.12171 0.545042,0.37836 1.124479,0.69056 1.738312,0.93927 0.224896,0.0926 0.460375,0.11113 0.674688,0.005 0.552979,-0.26987 1.063625,-0.59795 1.489604,-1.05304 0.373062,-0.39687 0.500062,-0.86254 0.41275,-1.397 z m -0.701146,0.96573 c -0.216958,0.27252 -0.489479,0.48419 -0.777875,0.67204 -0.171979,0.11113 -0.34925,0.20902 -0.523875,0.31221 -0.137583,0.082 -0.272521,0.0847 -0.420687,0.0238 -0.605896,-0.2487 -1.17475,-0.56356 -1.711854,-0.94191 -0.0926,-0.0635 -0.185209,-0.12436 -0.3175,-0.21431 0.01852,-0.3519 0.03175,-0.71703 0.05556,-1.0795 0.0079,-0.14023 0.03704,-0.27782 0.05292,-0.41805 0.02117,-0.16933 -0.06085,-0.29368 -0.206375,-0.3122 -0.153459,-0.0212 -0.267229,0.0608 -0.28575,0.23812 -0.03969,0.39688 -0.06879,0.7964 -0.0979,1.19592 -0.0079,0.11906 0,0.23812 0,0.31485 -0.264583,0.21167 -0.510646,0.39423 -0.743479,0.59531 -0.179917,0.15611 -0.359834,0.18257 -0.582084,0.0952 -0.394229,-0.15081 -0.777875,-0.3175 -1.132416,-0.55033 -0.396875,-0.26194 -0.542396,-0.61383 -0.460375,-1.08479 0.224896,-1.27 0.587375,-2.49767 1.063625,-3.69623 0.187854,-0.47625 0.534458,-0.74348 1.045104,-0.78846 1.04775,-0.0952 2.090208,-0.0688 3.130021,0.082 0.103187,0.0159 0.209021,0.0291 0.312208,0.0476 0.455083,0.0873 0.767292,0.35454 0.894292,0.79375 0.216958,0.74877 0.423333,1.50018 0.605895,2.25689 0.129646,0.53711 0.209021,1.08744 0.314855,1.63248 0.0635,0.30956 -0.02117,0.58209 -0.214313,0.8255 z"
                    id="path717"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('17')"
                    d="m 62.065546,131.51518 c 0.01852,-0.3519 0.03175,-0.71703 0.05556,-1.0795 0.0079,-0.14023 0.03704,-0.27782 0.05292,-0.41805 0.02117,-0.16933 -0.06085,-0.29368 -0.206375,-0.3122 -0.153458,-0.0212 -0.267229,0.0608 -0.28575,0.23812 -0.03969,0.39688 -0.06879,0.7964 -0.0979,1.19592 -0.0079,0.11906 0,0.23812 0,0.31485 -0.264583,0.21167 -0.510646,0.39423 -0.743479,0.59531 -0.179917,0.15611 -0.359833,0.18257 -0.582083,0.0952 -0.39423,-0.15081 -0.777875,-0.3175 -1.132417,-0.55033 -0.396875,-0.26194 -0.542396,-0.61383 -0.460375,-1.08479 0.224896,-1.27 0.587375,-2.49767 1.063625,-3.69623 0.187854,-0.47625 0.534458,-0.74348 1.045104,-0.78846 1.04775,-0.0952 2.090208,-0.0688 3.130021,0.082 0.103187,0.0159 0.209021,0.0291 0.312208,0.0476 0.455084,0.0873 0.767292,0.35454 0.894292,0.79375 0.216958,0.74877 0.423333,1.50018 0.605896,2.25689 0.129645,0.53711 0.20902,1.08744 0.314854,1.63248 0.06085,0.31221 -0.02381,0.58209 -0.216959,0.8255 -0.216958,0.27252 -0.489479,0.48419 -0.777874,0.67204 -0.17198,0.11113 -0.34925,0.20902 -0.523875,0.31221 -0.137584,0.082 -0.272521,0.0847 -0.420688,0.0238 -0.605896,-0.2487 -1.17475,-0.56356 -1.711854,-0.94191 -0.08731,-0.0661 -0.179917,-0.127 -0.314854,-0.21431 z"
                    id="path749"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('17')"
                    id="text795"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="60.110592"
                    y="122"
                  >
                    17
                  </text>
                </g>
                <g id="g85">
                  <path
                    [attr.fill]="getTextColorForVisual('18')"
                    d="m 56.596608,130.83255 c -0.203729,-1.3626 -0.523875,-2.7014 -0.941916,-4.01373 -0.05292,-0.16404 -0.134938,-0.32544 -0.224896,-0.4736 -0.03969,-0.0635 -0.06615,-0.12436 -0.08202,-0.1905 -0.05821,-0.0503 -0.111125,-0.10054 -0.161396,-0.15611 -0.02117,-0.0159 -0.04763,-0.0318 -0.06879,-0.0503 -0.103187,-0.045 -0.203729,-0.0953 -0.301625,-0.15081 -0.01852,-0.0106 -0.03439,-0.0238 -0.05292,-0.0344 -0.1905,-0.045 -0.375709,-0.0953 -0.560917,-0.12435 -0.828146,-0.13758 -1.661583,-0.18256 -2.497666,-0.1614 -0.309563,0.008 -0.619125,0.0132 -0.926042,0.0529 -0.232833,0.0291 -0.460375,0.10583 -0.719667,0.16933 0,-0.005 0,-0.0132 -0.0026,-0.0185 -0.04763,0.0318 -0.100541,0.0582 -0.150812,0.0873 -0.0979,0.15345 -0.219604,0.29104 -0.362479,0.4101 -0.01852,0.0714 -0.04762,0.14023 -0.100542,0.20373 -0.04233,0.0529 -0.06615,0.12435 -0.0926,0.18785 -0.508,1.27 -0.899583,2.57175 -1.121833,3.92113 -0.100542,0.61383 0.111125,1.11919 0.635,1.47902 0.43127,0.29633 0.90752,0.50535 1.399645,0.67204 0.309563,0.10319 0.597959,0.0608 0.854605,-0.14287 0.164041,-0.1323 0.325437,-0.26723 0.486833,-0.40482 0.161396,-0.13493 0.280458,-0.14552 0.457729,-0.0317 0.04762,0.0291 0.0926,0.0635 0.137583,0.0979 0.547688,0.38894 1.132417,0.70114 1.751542,0.96044 0.298979,0.127 0.587375,0.12435 0.867833,-0.045 0.216959,-0.12965 0.436563,-0.25665 0.648229,-0.39159 0.296334,-0.19314 0.560917,-0.42333 0.788459,-0.69585 0.280458,-0.33338 0.407458,-0.72231 0.341312,-1.15623 z m -0.743479,0.86783 c -0.378354,0.43127 -0.854604,0.72496 -1.354667,0.98425 -0.124354,0.0635 -0.243416,0.0238 -0.365125,-0.0265 -0.587375,-0.24078 -1.137708,-0.54769 -1.658937,-0.91282 -0.103188,-0.0714 -0.209021,-0.14023 -0.330729,-0.22225 -0.02117,-0.44185 0.0079,-0.87577 0.06085,-1.30968 0.0079,-0.0688 0.02117,-0.14023 0.02646,-0.20903 0.01058,-0.17727 -0.05556,-0.28045 -0.1905,-0.30162 -0.15875,-0.0265 -0.259291,0.0582 -0.298979,0.24871 -0.01058,0.0476 -0.01588,0.0979 -0.02117,0.14552 -0.02646,0.42862 -0.05292,0.8546 -0.07673,1.28323 -0.0026,0.0423 -0.0053,0.082 -0.0053,0.0794 -0.214313,0.16934 -0.399521,0.3175 -0.584729,0.46302 -0.06615,0.0529 -0.134938,0.10055 -0.198438,0.15611 -0.148167,0.13229 -0.304271,0.14287 -0.489479,0.0767 -0.425979,-0.15082 -0.833438,-0.33073 -1.209146,-0.58473 -0.346604,-0.23548 -0.502708,-0.55827 -0.439208,-0.97631 0.127,-0.80698 0.322791,-1.59544 0.574146,-2.37332 0.150812,-0.46831 0.320145,-0.92868 0.492125,-1.38906 0.185208,-0.49477 0.542395,-0.76729 1.074208,-0.81227 0.926042,-0.082 1.852083,-0.0714 2.775479,0.0423 0.209021,0.0265 0.418042,0.0503 0.627062,0.0873 0.465667,0.082 0.777875,0.35189 0.915459,0.79904 0.161396,0.52916 0.325437,1.06098 0.452437,1.60073 0.174625,0.75141 0.320146,1.51077 0.468313,2.26748 0.06615,0.33337 -0.02117,0.6297 -0.243417,0.8837 z"
                    id="path720"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('18')"
                    d="m 52.143671,131.52576 c -0.02117,-0.44186 0.0079,-0.87577 0.06085,-1.30969 0.0079,-0.0688 0.02117,-0.14023 0.02646,-0.20902 0.01058,-0.17727 -0.05556,-0.28046 -0.1905,-0.30162 -0.15875,-0.0265 -0.259291,0.0582 -0.298979,0.2487 -0.01058,0.0476 -0.01588,0.0979 -0.02117,0.14552 -0.02646,0.42863 -0.05292,0.85461 -0.07673,1.28323 -0.0026,0.0423 -0.0053,0.082 -0.0053,0.0794 -0.214313,0.16933 -0.399521,0.3175 -0.584729,0.46302 -0.06615,0.0529 -0.134938,0.10054 -0.198438,0.1561 -0.148167,0.1323 -0.304271,0.14288 -0.489479,0.0767 -0.425979,-0.15081 -0.833438,-0.33073 -1.209146,-0.58473 -0.346604,-0.23548 -0.502708,-0.55827 -0.439208,-0.97631 0.127,-0.80698 0.322791,-1.59544 0.574146,-2.37331 0.150812,-0.46831 0.320145,-0.92869 0.492125,-1.38906 0.185208,-0.49477 0.542395,-0.7673 1.074208,-0.81227 0.926042,-0.082 1.852083,-0.0714 2.775479,0.0423 0.209021,0.0265 0.418042,0.0503 0.627062,0.0873 0.465667,0.082 0.777875,0.3519 0.915459,0.79904 0.161396,0.52917 0.325437,1.06098 0.452437,1.60073 0.174625,0.75142 0.320146,1.51077 0.468313,2.26748 0.06615,0.33073 -0.02117,0.62706 -0.246063,0.88106 -0.378354,0.43127 -0.854604,0.72496 -1.354666,0.98425 -0.124355,0.0635 -0.243417,0.0238 -0.365125,-0.0265 -0.587375,-0.24078 -1.137709,-0.54769 -1.658938,-0.91282 -0.100542,-0.0688 -0.206375,-0.13758 -0.328083,-0.2196 z"
                    id="path752"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('18')"
                    id="text796"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="49.999832"
                    y="122"
                  >
                    18
                  </text>
                </g>
                <g id="g109">
                  <path
                    [attr.fill]="getTextColorForVisual('41')"
                    d="m 113.95827,147.52776 c 0.0318,-0.10848 0.0873,-0.20638 0.15346,-0.29634 0.0132,-0.0529 0.0291,-0.10583 0.045,-0.1561 0.0952,-0.29104 0.22225,-0.57415 0.35984,-0.84931 0.0106,-0.17463 0.0318,-0.34396 0.0688,-0.51329 0.1905,-0.88636 0.34131,-1.78065 0.40746,-2.68552 0.037,-0.51065 0.0688,-1.02394 0.082,-1.53459 0.0132,-0.46566 -0.28046,-0.79639 -0.73025,-0.85989 -0.78052,-0.10848 -1.56634,-0.14817 -2.50825,-0.16934 -0.35719,0.0212 -0.87048,0.0503 -1.38113,0.0794 -0.40746,0.0238 -0.70644,0.29898 -0.762,0.70644 -0.0238,0.17991 -0.037,0.36247 -0.045,0.54504 -0.0476,1.37318 0.20638,2.69875 0.63236,3.99521 0.0582,0.17462 0.11641,0.3466 0.127,0.52916 0.0952,0.10054 0.17462,0.23019 0.22489,0.39159 0.082,0.26987 0.23813,0.51593 0.36513,0.77258 0.18521,0.2196 0.33337,0.43921 0.52123,0.60854 0.66145,0.59796 1.53193,0.51329 2.08491,-0.1905 0.11377,-0.14552 0.20902,-0.30692 0.35454,-0.45244 0.003,0.0291 0.003,0.0556 0,0.0794 z m -0.64029,-0.0661 c -0.10848,0.16669 -0.24077,0.31221 -0.41275,0.41275 -0.26193,0.15611 -0.52652,0.16669 -0.80168,0.0212 -0.23813,-0.12436 -0.41805,-0.30427 -0.55298,-0.53181 -0.4154,-0.69586 -0.72761,-1.43934 -0.94986,-2.21986 -0.31221,-1.10596 -0.50271,-2.23044 -0.44714,-3.38666 0.005,-0.1323 0.0185,-0.26723 0.0344,-0.39953 0.0265,-0.21431 0.10319,-0.30427 0.32015,-0.32014 0.49741,-0.037 0.99483,-0.0609 1.26206,-0.0767 0.9816,0.008 1.73038,0.0529 2.47385,0.1614 0.25665,0.037 0.34132,0.13493 0.33603,0.39422 -0.0212,0.83609 -0.0661,1.66953 -0.1958,2.49503 -0.0899,0.57414 -0.1905,1.14829 -0.3175,1.71714 -0.13758,0.62442 -0.40216,1.19856 -0.74877,1.73302 z"
                    id="path735"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('41')"
                    d="m 111.77017,140.96345 c 0.9816,0.008 1.73038,0.0529 2.47385,0.16139 0.25665,0.037 0.34132,0.13494 0.33603,0.39423 -0.0212,0.83608 -0.0661,1.66952 -0.1958,2.49502 -0.0899,0.57415 -0.1905,1.14829 -0.3175,1.71715 -0.14023,0.62177 -0.40216,1.19591 -0.75141,1.73037 -0.10848,0.16669 -0.24077,0.31221 -0.41275,0.41275 -0.26194,0.15611 -0.52652,0.16669 -0.80169,0.0212 -0.23813,-0.12436 -0.41804,-0.30427 -0.55298,-0.53181 -0.4154,-0.69586 -0.7276,-1.43934 -0.94985,-2.21986 -0.31221,-1.10596 -0.50271,-2.23044 -0.44715,-3.38666 0.005,-0.1323 0.0185,-0.26723 0.0344,-0.39953 0.0264,-0.21431 0.10318,-0.30427 0.32014,-0.32014 0.49742,-0.037 0.99484,-0.0582 1.26471,-0.0741 z m 1.97115,1.33879 c -0.0159,-0.26988 -0.0238,-0.49213 -0.045,-0.71702 -0.0132,-0.14288 -0.12436,-0.2249 -0.26194,-0.21432 -0.127,0.008 -0.21167,0.0979 -0.22225,0.23548 -0.003,0.0423 0.005,0.0847 0.005,0.12436 -0.005,0.32808 -0.005,0.65881 -0.0185,0.98689 -0.008,0.18786 -0.0503,0.37571 -0.0688,0.56357 -0.0159,0.18256 0.11377,0.3175 0.27252,0.28839 0.12435,-0.0238 0.19844,-0.10054 0.21167,-0.22754 0.045,-0.36248 0.0873,-0.72231 0.127,-1.03981 z m -2.58498,0.45508 c -0.005,0.43921 0.0688,0.86519 0.17727,1.28852 0.0159,0.0609 0.0318,0.12436 0.0635,0.17727 0.0556,0.0926 0.14816,0.127 0.254,0.10584 0.10319,-0.0212 0.17991,-0.0979 0.18521,-0.20109 0.005,-0.0608 -0.008,-0.12435 -0.0212,-0.18785 -0.0344,-0.16404 -0.0873,-0.32809 -0.10319,-0.49213 -0.0344,-0.34131 -0.0503,-0.68262 -0.0688,-1.02658 -0.008,-0.17463 -0.0873,-0.2831 -0.23812,-0.2884 -0.15346,-0.005 -0.24607,0.09 -0.254,0.26988 0.003,0.11642 0.005,0.23548 0.005,0.35454 z"
                    id="path768"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('41')"
                    d="m 113.74132,142.30224 c -0.0371,0.3175 -0.082,0.67998 -0.127,1.03981 -0.0159,0.127 -0.09,0.20637 -0.21167,0.22754 -0.15875,0.0291 -0.2884,-0.10583 -0.27252,-0.28839 0.0185,-0.18786 0.0582,-0.37571 0.0688,-0.56357 0.0159,-0.32808 0.0159,-0.65616 0.0185,-0.98689 0,-0.0423 -0.008,-0.0847 -0.005,-0.12436 0.0106,-0.13758 0.0953,-0.22754 0.22225,-0.23548 0.13758,-0.0106 0.24871,0.0714 0.26194,0.21432 0.0185,0.22225 0.0265,0.44714 0.045,0.71702 z"
                    id="path781"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('41')"
                    d="m 111.15634,142.75732 c 0,-0.11906 -0.005,-0.23812 0,-0.35719 0.008,-0.17991 0.10054,-0.27516 0.254,-0.26987 0.14816,0.005 0.23018,0.11377 0.23812,0.28839 0.0159,0.34132 0.0344,0.68527 0.0688,1.02659 0.0159,0.16668 0.0688,0.32808 0.10319,0.49212 0.0132,0.0609 0.0238,0.12436 0.0212,0.18786 -0.008,0.10318 -0.082,0.17991 -0.18521,0.20108 -0.10848,0.0212 -0.19844,-0.0132 -0.254,-0.10583 -0.0318,-0.0529 -0.0503,-0.11642 -0.0635,-0.17727 -0.11113,-0.42069 -0.18785,-0.84932 -0.18256,-1.28588 z"
                    id="path782"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('41')"
                    id="text797"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="110.3937"
                    y="153.5"
                  >
                    41
                  </text>
                </g>
                <g id="g110">
                  <path
                    [attr.fill]="getTextColorForVisual('42')"
                    d="m 106.59227,147.82674 c 0.0476,-0.0661 0.0926,-0.13494 0.14023,-0.20373 0.28311,-0.43656 0.47096,-0.87048 0.60061,-1.26736 0.12964,-0.52387 0.23548,-0.97102 0.31485,-1.31498 0,0 0.32544,-1.8362 0.35454,-3.55864 0.008,-0.45508 -0.27516,-0.78052 -0.71966,-0.84138 -0.78052,-0.10848 -1.56634,-0.15081 -2.50825,-0.16933 -0.33602,0.0185 -0.8255,0.0423 -1.31763,0.0741 -0.52123,0.0344 -0.79904,0.29634 -0.84137,0.81492 -0.0265,0.32808 -0.037,0.65881 -0.0318,0.9869 0.0344,2.06639 0.40746,2.67229 0.61383,3.40783 0.0476,0.16933 0.13494,0.46567 0.28575,0.83079 0.0847,0.20373 0.17463,0.42333 0.33073,0.69056 0.15875,0.27252 0.30692,0.52388 0.58737,0.77259 0.15346,0.13493 0.4154,0.35983 0.76994,0.42598 0.12965,0.0238 0.26723,0.0264 0.41275,0.008 0.29369,-0.0397 0.53711,-0.16668 0.74348,-0.35189 0.0767,-0.10848 0.16933,-0.20902 0.26458,-0.30427 z m -2.03729,-0.34661 c -0.14287,-0.18785 -0.24871,-0.40746 -0.35718,-0.61912 -0.48419,-0.93663 -0.77788,-1.93675 -0.96573,-2.97127 -0.12171,-0.67204 -0.19315,-1.34673 -0.1614,-2.032 0.008,-0.16934 0.0212,-0.33602 0.037,-0.50271 0.0212,-0.19579 0.10848,-0.29633 0.30692,-0.30956 0.50271,-0.0397 1.00806,-0.0635 1.28323,-0.0794 0.9816,0.0106 1.73037,0.0529 2.4765,0.16404 0.25135,0.037 0.32808,0.127 0.32544,0.37571 -0.0132,1.11919 -0.11378,2.22779 -0.32015,3.32846 -0.0926,0.49742 -0.17992,0.99483 -0.35719,1.47108 -0.15081,0.40217 -0.33602,0.78582 -0.5715,1.14565 -0.48154,0.73025 -1.1721,0.71967 -1.69598,0.0291 z"
                    id="path736"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('42')"
                    d="m 104.7005,140.9608 c 0.98161,0.0106 1.73038,0.0529 2.4765,0.16404 0.25136,0.037 0.32809,0.127 0.32544,0.37571 -0.0132,1.11919 -0.11377,2.22779 -0.32014,3.32846 -0.0926,0.49741 -0.17992,0.99483 -0.35719,1.47108 -0.15081,0.40217 -0.33602,0.78581 -0.5715,1.14565 -0.4789,0.73554 -1.17211,0.72231 -1.69598,0.0317 -0.14288,-0.18786 -0.24871,-0.40746 -0.35719,-0.61913 -0.48419,-0.93662 -0.77787,-1.93675 -0.96573,-2.97127 -0.12171,-0.67204 -0.19314,-1.34673 -0.16139,-2.032 0.008,-0.16933 0.0212,-0.33602 0.037,-0.50271 0.0212,-0.19579 0.10848,-0.29633 0.30691,-0.30956 0.50271,-0.0397 1.00807,-0.0635 1.28323,-0.082 z m -0.37041,1.16946 c -0.14817,-0.003 -0.24607,0.10054 -0.254,0.27516 -0.0212,0.57944 0.0423,1.1483 0.20373,1.70657 0.008,0.0265 0.0132,0.0556 0.0264,0.0794 0.0529,0.10848 0.16934,0.16404 0.28046,0.13759 0.11377,-0.0265 0.18786,-0.12171 0.18257,-0.24871 -0.003,-0.0635 -0.0185,-0.12436 -0.0344,-0.18521 -0.11113,-0.42333 -0.17198,-0.85196 -0.15875,-1.29117 0.003,-0.0847 0.005,-0.16933 -0.003,-0.25135 -0.0185,-0.13494 -0.11641,-0.21961 -0.24341,-0.22225 z m 2.33362,0.11641 c -0.0159,-0.27516 -0.0212,-0.46566 -0.0423,-0.65087 -0.0185,-0.1614 -0.127,-0.24077 -0.27517,-0.22225 -0.13229,0.0159 -0.20637,0.10848 -0.20902,0.26723 0,0.0423 0.005,0.0847 0.005,0.127 -0.0106,0.38364 -0.0212,0.76994 -0.0397,1.15358 -0.005,0.14023 -0.0423,0.27781 -0.0476,0.4154 -0.005,0.12171 0.0847,0.21431 0.20108,0.23283 0.10584,0.0185 0.2249,-0.0476 0.26723,-0.15875 0.0185,-0.045 0.0291,-0.0953 0.0344,-0.14287 0.0397,-0.36777 0.0767,-0.73555 0.10583,-1.0213 z"
                    id="path769"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('42')"
                    d="m 104.33009,142.13026 c 0.12435,0.003 0.22489,0.0873 0.24077,0.22225 0.0106,0.082 0.005,0.16933 0.003,0.25135 -0.0132,0.43921 0.0476,0.86784 0.15875,1.29117 0.0159,0.0609 0.0318,0.12435 0.0344,0.18521 0.005,0.127 -0.0688,0.22225 -0.18256,0.24871 -0.11113,0.0265 -0.22754,-0.0291 -0.28046,-0.13759 -0.0132,-0.0238 -0.0185,-0.0529 -0.0265,-0.0794 -0.15875,-0.55827 -0.22225,-1.12713 -0.20373,-1.70657 0.0106,-0.17462 0.11113,-0.27781 0.25665,-0.27516 z"
                    id="path783"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('42')"
                    d="m 106.66371,142.24667 c -0.0291,0.28575 -0.0661,0.65353 -0.10583,1.0213 -0.005,0.0476 -0.0159,0.0979 -0.0344,0.14287 -0.0423,0.11113 -0.15875,0.17727 -0.26723,0.15875 -0.11641,-0.0212 -0.20637,-0.11112 -0.20108,-0.23283 0.005,-0.14023 0.0423,-0.27781 0.0476,-0.4154 0.0185,-0.38364 0.0264,-0.76994 0.0397,-1.15358 0,-0.0423 -0.005,-0.0847 -0.005,-0.127 0.003,-0.15875 0.0767,-0.25136 0.20902,-0.26723 0.14552,-0.0185 0.254,0.0582 0.27517,0.22225 0.0212,0.18521 0.0265,0.37571 0.0423,0.65087 z"
                    id="path784"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('42')"
                    id="text798"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="103.07527"
                    y="153.5"
                  >
                    42
                  </text>
                </g>
                <g id="g111">
                  <path
                    [attr.fill]="getTextColorForVisual('43')"
                    d="m 96.122712,147.04357 c 0.179917,0.28575 0.701146,1.12448 1.616604,1.21708 0.714375,0.0741 1.27,-0.34925 1.444625,-0.49212 0.420688,-0.62971 0.703792,-1.19063 0.891649,-1.60073 0,0 0.41539,-0.91281 0.8255,-3.175 0.0503,-0.27781 0,-0.52388 -0.16934,-0.75406 -0.20902,-0.28575 -0.47095,-0.51859 -0.71966,-0.76465 -0.521232,-0.51064 -1.108607,-0.92604 -1.730378,-1.30175 -0.264583,-0.16139 -0.508,-0.14552 -0.764646,0.0265 -0.865187,0.58473 -1.598083,1.30704 -2.233083,2.1299 -0.134938,0.17462 -0.182563,0.37041 -0.166688,0.59266 0.05027,0.6985 0.150813,1.38906 0.298979,2.07169 0.100542,0.45773 0.161396,0.68792 0.224896,0.889 0.132292,0.4101 0.254,0.7964 0.481542,1.16152 z m -0.447146,-4.40531 c 0.621771,-0.80698 1.336146,-1.51606 2.196042,-2.07434 0.01058,-0.008 0.02646,-0.0106 0.0635,-0.0212 0.568854,0.32808 1.108604,0.69321 1.584854,1.14564 0.164042,0.15346 0.328083,0.30692 0.492128,0.46038 0.0265,0.0238 0.0503,0.0503 0.0741,0.0741 0.26458,0.25929 0.37835,0.53711 0.29369,0.93663 -0.24077,1.143 -0.497419,2.27806 -0.981606,3.34698 -0.07144,0.15875 -0.142875,0.32279 -0.23548,0.47095 -0.296333,0.47625 -0.714375,0.76994 -1.291166,0.78582 -0.502709,0.0159 -0.865188,-0.25136 -1.158875,-0.62442 -0.105834,-0.13494 -0.193146,-0.29633 -0.259292,-0.45508 -0.367771,-0.89429 -0.592667,-1.82827 -0.73025,-2.78342 -0.04762,-0.32544 -0.07408,-0.65617 -0.113771,-0.98425 -0.01058,-0.10319 0.0026,-0.19579 0.06615,-0.27781 z"
                    id="path713"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('43')"
                    d="m 97.932462,140.54276 c 0.568854,0.32808 1.108604,0.69321 1.584854,1.14564 0.164042,0.15346 0.328083,0.30692 0.492124,0.46038 0.0265,0.0238 0.0503,0.0503 0.0741,0.0741 0.26459,0.25929 0.37836,0.53711 0.29369,0.93663 -0.24077,1.143 -0.497415,2.27806 -0.981602,3.34698 -0.07144,0.15875 -0.142875,0.32279 -0.235479,0.47095 -0.296334,0.47625 -0.714375,0.76994 -1.291167,0.78582 -0.502708,0.0159 -0.865188,-0.25136 -1.158875,-0.62442 -0.105833,-0.13494 -0.193146,-0.29633 -0.259292,-0.45508 -0.367771,-0.89429 -0.592666,-1.82827 -0.73025,-2.78342 -0.04762,-0.32544 -0.07408,-0.65617 -0.113771,-0.98425 -0.01323,-0.10319 0,-0.19315 0.0635,-0.27781 0.621771,-0.80698 1.336146,-1.51606 2.196042,-2.07434 0.01588,-0.008 0.03175,-0.008 0.06615,-0.0212 z m 0.867833,2.55587 c -0.02646,-0.33602 -0.07408,-0.93662 -0.127,-1.53723 -0.01587,-0.18785 -0.127,-0.28045 -0.28575,-0.26193 -0.142875,0.0185 -0.224896,0.13758 -0.209021,0.3122 0.01323,0.12436 0.02911,0.25136 0.04233,0.37571 0.127,1.12977 0.103187,2.25425 -0.08467,3.37609 -0.03704,0.21431 -0.08467,0.42598 -0.119062,0.64029 -0.02381,0.14287 0.05292,0.25929 0.182562,0.28575 0.137583,0.0317 0.248708,-0.0318 0.296333,-0.16934 0.01852,-0.0529 0.02646,-0.10847 0.03704,-0.16404 0.177271,-0.85196 0.256646,-1.7145 0.267229,-2.8575 z"
                    id="path745"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('43')"
                    d="m 98.800295,143.09863 c -0.01058,1.14036 -0.08996,2.00554 -0.267229,2.86015 -0.01058,0.0556 -0.01852,0.11112 -0.03704,0.16404 -0.04763,0.13758 -0.15875,0.20108 -0.296333,0.16933 -0.129646,-0.0291 -0.206375,-0.14287 -0.182562,-0.28575 0.03704,-0.21431 0.08467,-0.42598 0.119062,-0.64029 0.187854,-1.12183 0.211667,-2.24631 0.08467,-3.37608 -0.01323,-0.12436 -0.0291,-0.25136 -0.04233,-0.37571 -0.01587,-0.17198 0.06615,-0.29369 0.209021,-0.31221 0.15875,-0.0212 0.269875,0.0741 0.28575,0.26194 0.05292,0.6006 0.0979,1.20121 0.127,1.53458 z"
                    id="path774"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('43')"
                    id="text799"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="95.533615"
                    y="153.5"
                  >
                    43
                  </text>
                </g>
                <g id="g112">
                  <path
                    [attr.fill]="getTextColorForVisual('44')"
                    d="m 87.380879,144.80784 c 0.07673,0.44186 0.150812,0.88636 0.322791,1.30704 0.02646,0.0661 0.04233,0.13494 0.05556,0.20373 0.06085,0.12171 0.15875,0.27781 0.306917,0.43656 0.119062,0.127 0.235479,0.21961 0.33602,0.28575 1.031875,0.77523 2.026709,0.66411 3.032125,-0.0423 0.182563,-0.14023 0.447146,-0.37042 0.690563,-0.71173 0.198437,-0.28046 0.301625,-0.52123 0.375708,-0.69585 0.486833,-1.15623 0.724958,-2.02671 0.941917,-2.96598 0.129646,-0.56092 -0.127,-1.07686 -0.650875,-1.32821 -0.3175,-0.15346 -0.616479,-0.32808 -0.899583,-0.5424 -0.404813,-0.30956 -0.862542,-0.49477 -1.404938,-0.49741 -0.425979,0.008 -0.833437,0.14287 -1.209146,0.381 -0.174625,0.11112 -0.357187,0.18256 -0.563562,0.21166 -0.420688,0.0582 -0.817563,0.20109 -1.182688,0.42069 -0.272521,0.16404 -0.428625,0.39688 -0.418041,0.72761 0.0026,0.0635 0,0.127 0.0026,0.1905 0.03704,0.87841 0.116417,1.75154 0.264584,2.61937 z m 0.433916,-3.13002 c 0.33073,-0.18256 0.674688,-0.30956 1.066271,-0.34396 0.01587,0.24606 0.01587,0.48419 0.04762,0.71702 0.04498,0.34661 0.111125,0.69321 0.169334,1.03717 0.0079,0.0397 0.02117,0.082 0.03704,0.11906 0.05556,0.11377 0.156104,0.15875 0.280459,0.12965 0.116416,-0.0265 0.1905,-0.12171 0.185208,-0.24606 -0.0026,-0.0476 -0.01852,-0.0952 -0.03175,-0.14288 -0.132292,-0.56356 -0.195792,-1.13506 -0.177271,-1.7145 0,-0.0265 0.0053,-0.0556 0.0079,-0.0847 0.201083,-0.15081 0.418041,-0.26458 0.65352,-0.33602 0.42598,-0.12964 0.83873,-0.082 1.21973,0.14288 0.264583,0.1561 0.510645,0.34396 0.793749,0.53446 -0.235479,0.0741 -0.251354,0.25135 -0.261937,0.43391 -0.01852,0.39423 -0.105833,0.77788 -0.22225,1.15623 -0.01323,0.0476 -0.03175,0.0926 -0.03969,0.14288 -0.01323,0.11641 0.0635,0.23018 0.169333,0.26458 0.111125,0.0344 0.230187,-0.008 0.288396,-0.11642 0.03175,-0.0608 0.05556,-0.12964 0.07408,-0.19579 0.140229,-0.49477 0.243417,-0.99483 0.230187,-1.56104 0.148167,0.0767 0.275167,0.12171 0.378355,0.19844 0.227541,0.16933 0.333375,0.40216 0.267229,0.68262 -0.243417,1.03982 -0.534459,2.0664 -0.98425,3.04007 -0.288396,0.62177 -0.743479,1.08479 -1.367896,1.37318 -0.820208,0.381 -1.743604,0.10319 -2.270125,-0.68262 -0.134937,-0.20109 -0.230187,-0.41804 -0.288396,-0.65088 -0.164041,-0.65616 -0.264583,-1.32291 -0.330729,-1.99496 -0.04762,-0.49741 -0.07144,-0.99483 -0.116417,-1.49225 -0.01058,-0.18785 0.05292,-0.3175 0.22225,-0.4101 z"
                    id="path727"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('44')"
                    d="m 92.310066,141.61697 c 0.148167,0.0767 0.275167,0.1217 0.378354,0.19843 0.227542,0.16934 0.333375,0.40217 0.267229,0.68263 -0.243416,1.03981 -0.534458,2.06639 -0.98425,3.04006 -0.288395,0.62177 -0.743479,1.08479 -1.367895,1.37319 -0.820209,0.381 -1.743604,0.10319 -2.270125,-0.68263 -0.134938,-0.20108 -0.230188,-0.41804 -0.288396,-0.65087 -0.164042,-0.65617 -0.264583,-1.32292 -0.330729,-1.99496 -0.04762,-0.49742 -0.07144,-0.99483 -0.116417,-1.49225 -0.01587,-0.19315 0.04762,-0.32279 0.216958,-0.4154 0.33073,-0.18256 0.674688,-0.30956 1.066271,-0.34395 0.01587,0.24606 0.01587,0.48418 0.04762,0.71702 0.04498,0.3466 0.111125,0.69321 0.169334,1.03716 0.0079,0.0423 0.02117,0.082 0.03704,0.11907 0.05556,0.11377 0.156104,0.15875 0.280459,0.12964 0.116416,-0.0265 0.1905,-0.12171 0.185208,-0.24606 -0.0026,-0.0476 -0.01852,-0.0953 -0.03175,-0.14288 -0.132292,-0.56356 -0.195792,-1.13506 -0.177271,-1.7145 0,-0.0265 0.0053,-0.0556 0.0079,-0.0847 0.201083,-0.15081 0.418041,-0.26459 0.65352,-0.33602 0.42598,-0.12965 0.83873,-0.082 1.21973,0.14287 0.264583,0.15611 0.510645,0.34396 0.793749,0.53446 -0.235479,0.0741 -0.251354,0.25135 -0.261937,0.43392 -0.01852,0.39423 -0.105833,0.77787 -0.22225,1.15623 -0.01323,0.0476 -0.03175,0.0926 -0.03969,0.14287 -0.01323,0.11642 0.0635,0.23019 0.169333,0.26458 0.111125,0.0344 0.230187,-0.008 0.288396,-0.11641 0.03175,-0.0609 0.05556,-0.12965 0.07408,-0.19579 0.145521,-0.49213 0.248708,-0.99219 0.235479,-1.55575 z"
                    id="path759"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('44')"
                    id="text800"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="87.726212"
                    y="153.5"
                  >
                    44
                  </text>
                </g>
                <g id="g113">
                  <path
                    [attr.fill]="getTextColorForVisual('45')"
                    d="m 80.239775,146.81603 c 0.14552,0.24606 0.510645,0.87048 1.219729,1.11125 0.232833,0.0794 0.41275,0.0847 0.650875,0.0952 0.534458,0.0238 1.058333,-0.09 1.571625,-0.31221 0.05821,-0.0238 0.116416,-0.0503 0.174625,-0.0741 0.0026,0 0.0079,0 0.01323,0 0.05292,-0.0503 0.113771,-0.0979 0.185208,-0.13759 0.06085,-0.0344 0.129646,-0.0741 0.201084,-0.10848 0.03439,-0.0476 0.06879,-0.0953 0.09789,-0.14816 0.03969,-0.0688 0.08731,-0.127 0.137584,-0.17992 0.01323,-0.082 0.03175,-0.16404 0.05821,-0.24606 0.410104,-1.29381 0.6985,-2.61673 0.891646,-3.96081 0.06085,-0.42069 -0.06615,-0.77523 -0.354542,-1.07686 -0.132291,-0.13758 -0.267229,-0.26987 -0.402166,-0.40216 -0.433917,-0.42069 -0.896938,-0.80963 -1.407584,-1.13771 -0.404812,-0.25929 -0.8255,-0.26723 -1.230312,-0.008 -0.235479,0.15081 -0.460375,0.32279 -0.669396,0.51065 -0.256646,0.23018 -0.53975,0.39422 -0.867833,0.49477 -0.259292,0.0794 -0.513292,0.1905 -0.756709,0.30956 -0.383646,0.1905 -0.53975,0.51594 -0.497416,0.93662 0.05556,0.55563 0.09525,0.92075 0.09525,0.92075 0.322791,1.31498 0.1905,1.58486 0.582083,2.68817 0.116417,0.33338 0.177271,0.50271 0.306917,0.72496 z m -0.230188,-4.85246 c 0.267229,-0.14552 0.550333,-0.24342 0.846667,-0.31221 0.0926,0.32809 0.179916,0.63765 0.272521,0.94456 0.03439,0.11378 0.07937,0.2249 0.132291,0.33338 0.06879,0.14287 0.201084,0.19315 0.330729,0.14023 0.124355,-0.0503 0.169334,-0.18256 0.121709,-0.33867 -0.0979,-0.31485 -0.198438,-0.62971 -0.291042,-0.94456 -0.0344,-0.11906 -0.05292,-0.24606 -0.08202,-0.38629 0.304271,-0.24077 0.60325,-0.48419 0.910167,-0.71702 0.261937,-0.19579 0.529167,-0.18521 0.801687,-0.003 0.635,0.42598 1.193271,0.93398 1.717146,1.48696 0.164042,0.17198 0.22225,0.38629 0.185209,0.62442 -0.193146,1.27264 -0.470959,2.52412 -0.833438,3.75973 -0.09525,0.32808 -0.28575,0.54768 -0.597958,0.68527 -0.60325,0.26193 -1.219729,0.36248 -1.870604,0.22754 -0.423334,-0.09 -0.722313,-0.32809 -0.899584,-0.71967 -0.298979,-0.66939 -0.518583,-1.36525 -0.679979,-2.07698 -0.166687,-0.7276 -0.259292,-1.46579 -0.330729,-2.20662 -0.02381,-0.23019 0.0635,-0.38629 0.267229,-0.49742 z"
                    id="path711"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('45')"
                    d="m 80.856254,141.65136 c 0.0926,0.32809 0.179916,0.63765 0.272521,0.94456 0.03439,0.11378 0.07937,0.2249 0.132291,0.33338 0.06879,0.14287 0.201084,0.19315 0.330729,0.14023 0.124355,-0.0503 0.169334,-0.18256 0.121709,-0.33867 -0.0979,-0.31485 -0.198438,-0.62971 -0.291042,-0.94456 -0.0344,-0.11906 -0.05292,-0.24606 -0.08202,-0.38629 0.304271,-0.24077 0.60325,-0.48419 0.910167,-0.71702 0.261937,-0.19579 0.529167,-0.18521 0.801687,-0.003 0.635,0.42598 1.193271,0.93398 1.717146,1.48696 0.164042,0.17198 0.22225,0.38629 0.185209,0.62442 -0.193146,1.27264 -0.470959,2.52412 -0.833438,3.75973 -0.09525,0.32808 -0.28575,0.54768 -0.597958,0.68527 -0.60325,0.26193 -1.219729,0.36512 -1.870604,0.22754 -0.423334,-0.09 -0.722313,-0.32809 -0.899584,-0.71967 -0.298979,-0.66939 -0.518583,-1.3626 -0.679979,-2.07698 -0.166687,-0.7276 -0.259292,-1.46579 -0.330729,-2.20662 -0.02117,-0.23284 0.0635,-0.38629 0.269875,-0.49742 0.264583,-0.14552 0.547687,-0.24342 0.844021,-0.31221 z"
                    id="path743"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('45')"
                    id="text801"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="80.183525"
                    y="153.5"
                  >
                    45
                  </text>
                </g>
                <g id="g114">
                  <path
                    [attr.fill]="getTextColorForVisual('46')"
                    d="m 69.58765,145.06713 c 0.259291,0.65617 0.301625,1.06627 0.664104,1.47902 0.127,0.14288 0.246062,0.24607 0.328083,0.30957 0.166688,0.09 0.330729,0.17991 0.497417,0.26987 0.574146,0.12171 1.291167,0.2249 2.121958,0.22754 0.971021,0.003 1.799167,-0.13229 2.431521,-0.2831 0.08996,-0.09 0.198438,-0.16404 0.320146,-0.21696 0.0026,-0.005 0.0079,-0.0106 0.01323,-0.0159 0.03969,-0.0609 0.08996,-0.11378 0.140229,-0.16405 -0.0026,-0.037 -0.0079,-0.0741 -0.0026,-0.10848 0.03969,-0.19314 0.08731,-0.38364 0.132292,-0.57414 0.145521,-0.62442 0.325438,-1.23296 0.635,-1.80181 0.367771,-0.67205 0.582083,-1.39965 0.703792,-2.15371 0.05292,-0.33073 0.03704,-0.65881 -0.0979,-0.97102 -0.277813,-0.64559 -0.941917,-1.04775 -1.653646,-1.01336 -0.455083,0.0212 -0.865187,0.17727 -1.246187,0.41011 -0.22225,0.13493 -0.439209,0.14816 -0.67998,0.0476 -0.224895,-0.0953 -0.457729,-0.17727 -0.695854,-0.24077 -0.624416,-0.16933 -1.240896,-0.15081 -1.822979,0.15346 -0.269875,0.14023 -0.523875,0.16404 -0.806979,0.0529 -0.243417,-0.0953 -0.500063,-0.13759 -0.764646,-0.0873 -0.677333,0.1323 -1.156229,0.80963 -1.058333,1.50548 0.153458,1.09538 0.436562,2.15371 0.841375,3.175 z m -0.240771,-3.77296 c 0.185208,-0.33072 0.500062,-0.48418 0.867833,-0.39952 0.148167,0.0344 0.291042,0.0952 0.439209,0.14288 -0.01852,0.16933 -0.0344,0.32014 -0.04762,0.4736 -0.04762,0.51594 0.01852,1.02129 0.14552,1.524 0.02646,0.10054 0.06879,0.18521 0.174625,0.21961 0.198438,0.0635 0.354542,-0.0952 0.314855,-0.31221 -0.04498,-0.24077 -0.103188,-0.48154 -0.132292,-0.72496 -0.05027,-0.39158 -0.01852,-0.78317 0.05821,-1.15358 0.171979,-0.0767 0.325438,-0.14288 0.47625,-0.21432 0.439209,-0.20637 0.894292,-0.22225 1.357313,-0.10847 0.1905,0.045 0.375708,0.11377 0.560916,0.17727 0.145521,0.0503 0.288396,0.10848 0.433917,0.16404 0.08467,0.39952 0.15875,0.80698 0.129646,1.22237 -0.0079,0.10584 -0.02117,0.20902 -0.0344,0.31486 -0.02381,0.20108 0.04233,0.31485 0.193146,0.34131 0.164042,0.0265 0.272521,-0.0688 0.301625,-0.26988 0.06879,-0.48418 0.04762,-0.96572 -0.05292,-1.44462 -0.01323,-0.0609 -0.02381,-0.12171 -0.0344,-0.18521 0.26723,-0.13229 0.52123,-0.26987 0.785813,-0.381 0.383646,-0.16139 0.777875,-0.17727 1.164167,0 0.457729,0.20902 0.719666,0.69586 0.648229,1.19063 -0.116417,0.81491 -0.373063,1.5822 -0.769938,2.30452 -0.251354,0.46037 -0.386291,0.96308 -0.513291,1.46579 -0.05027,0.19579 -0.0926,0.39687 -0.129646,0.59531 -0.04233,0.23548 -0.177271,0.37306 -0.410104,0.42069 -0.85725,0.16669 -1.722438,0.26987 -2.595563,0.18785 -0.473604,-0.0423 -0.947208,-0.11906 -1.418167,-0.17991 -0.301625,-0.0397 -0.508,-0.20109 -0.642937,-0.4789 -0.66675,-1.35996 -1.129771,-2.78077 -1.370542,-4.27567 -0.03969,-0.2196 -0.0079,-0.42598 0.100542,-0.61648 z"
                    id="path709"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('46')"
                    d="m 70.653921,141.03753 c -0.01852,0.16933 -0.0344,0.32014 -0.04762,0.4736 -0.04762,0.51594 0.01852,1.02129 0.14552,1.524 0.02646,0.10054 0.06879,0.18521 0.174625,0.21961 0.198438,0.0635 0.354542,-0.0952 0.314855,-0.31221 -0.04498,-0.24077 -0.103188,-0.48154 -0.132292,-0.72496 -0.05027,-0.39158 -0.01852,-0.78317 0.05821,-1.15358 0.171979,-0.0767 0.325438,-0.14288 0.47625,-0.21432 0.439209,-0.20637 0.894292,-0.22225 1.357313,-0.10847 0.1905,0.045 0.375708,0.11377 0.560916,0.17727 0.145521,0.0503 0.288396,0.10848 0.433917,0.16404 0.08467,0.39952 0.15875,0.80698 0.129646,1.22237 -0.0079,0.10584 -0.02117,0.20902 -0.0344,0.31486 -0.02381,0.20108 0.04233,0.31485 0.193146,0.34131 0.164042,0.0265 0.272521,-0.0688 0.301625,-0.26988 0.06879,-0.48418 0.04762,-0.96572 -0.05292,-1.44462 -0.01323,-0.0609 -0.02381,-0.12171 -0.0344,-0.18521 0.26723,-0.13229 0.52123,-0.26987 0.785813,-0.381 0.383646,-0.16139 0.777875,-0.17727 1.164167,0 0.457729,0.20902 0.719666,0.69586 0.648229,1.19063 -0.116417,0.81491 -0.373063,1.5822 -0.769938,2.30452 -0.251354,0.46037 -0.386291,0.96308 -0.513291,1.46579 -0.05027,0.19579 -0.0926,0.39687 -0.129646,0.59531 -0.02117,0.11906 -0.06615,0.21431 -0.134938,0.28311 -0.100541,0.10054 -0.227541,0.127 -0.275166,0.13493 -1.317625,0.25929 -0.947209,0.254 -1.399646,0.27517 -1.695979,0.0873 -2.243667,-0.0714 -2.413,-0.12965 -0.296334,-0.10054 -0.526521,-0.2487 -0.545042,-0.26193 0,0 -0.232833,-0.15346 -0.431271,-0.37042 -0.796396,-0.87048 -1.156229,-3.74385 -1.23825,-4.26244 -0.0079,-0.045 -0.0291,-0.17462 0.0053,-0.33866 0.01852,-0.0926 0.05292,-0.18521 0.100542,-0.27253 0.185208,-0.33072 0.500062,-0.48418 0.867833,-0.39952 0.142875,0.0317 0.28575,0.0926 0.433917,0.14288 z"
                    id="path741"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('46')"
                    id="text802"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="71.031639"
                    y="153.5"
                  >
                    46
                  </text>
                </g>
                <g id="g115">
                  <path
                    [attr.fill]="getTextColorForVisual('47')"
                    d="m 58.842921,145.88205 c 0.04498,0.13758 0.105833,0.27781 0.187854,0.39687 0.04498,0.0661 0.06085,0.12965 0.06879,0.1958 0.153458,0.0847 0.293687,0.1852 0.460375,0.27516 0.0053,0.003 0.01058,0.008 0.01852,0.0106 0,-0.0106 0.0026,-0.0185 0.0026,-0.0291 0.92075,0.28311 1.8415,0.48419 2.791354,0.52123 0.93398,0.0344 1.857375,-0.0185 2.780771,-0.29104 0.06879,-0.0635 0.142875,-0.11906 0.238125,-0.1614 0.05821,-0.0661 0.119063,-0.13229 0.179917,-0.20108 0.03704,-0.0423 0.07673,-0.0767 0.116416,-0.10848 0.0053,-0.0106 0.01058,-0.0212 0.01587,-0.0317 0.0635,-0.09 0.111125,-0.19579 0.153459,-0.29898 0.404812,-1.01335 0.679979,-2.06639 0.878416,-3.13796 0.111125,-0.6006 -0.03439,-1.14035 -0.492125,-1.55575 -0.629708,-0.5715 -1.378479,-0.84931 -2.235729,-0.81227 -0.375708,0.0159 -0.735541,0.0953 -1.090083,0.21696 -0.261937,0.09 -0.526521,0.0873 -0.777875,-0.037 -0.489479,-0.24342 -0.997479,-0.26194 -1.518708,-0.14023 -0.645584,0.15081 -1.211792,0.4736 -1.762125,0.83079 -0.394229,0.25665 -0.590021,0.61119 -0.555625,1.08215 0.02646,0.34925 0.05027,0.70114 0.08731,1.05039 0.07408,0.75936 0.214313,1.50284 0.452438,2.22515 z m 0.304271,-3.95552 c 0.470958,-0.29633 0.947208,-0.57679 1.486958,-0.72496 0.447146,-0.12171 0.883708,-0.11642 1.309687,0.0952 0.34925,0.17198 0.714375,0.17198 1.087438,0.0635 0.267229,-0.0794 0.542396,-0.15081 0.817562,-0.18521 0.751417,-0.0979 1.415521,0.13494 1.994959,0.61119 0.351895,0.29104 0.486833,0.67469 0.402166,1.12977 -0.185208,1.01071 -0.455083,1.9976 -0.809625,2.96069 -0.153458,0.41804 -0.423333,0.65881 -0.859895,0.73554 -0.574146,0.10319 -1.153584,0.1561 -1.680105,0.16933 -1.074208,-0.0132 -2.069041,-0.17462 -3.037416,-0.48418 -0.277813,-0.0873 -0.452438,-0.26723 -0.542396,-0.53975 -0.209021,-0.64294 -0.343958,-1.30175 -0.423333,-1.9738 -0.04498,-0.3757 -0.06615,-0.75406 -0.105834,-1.13241 -0.0291,-0.32015 0.08467,-0.55298 0.359834,-0.72496 z"
                    id="path723"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('47')"
                    d="m 62.898983,146.78163 c -1.074208,-0.0132 -2.069041,-0.17462 -3.037416,-0.48418 -0.277813,-0.0873 -0.452438,-0.26723 -0.542396,-0.53975 -0.209021,-0.64294 -0.343959,-1.30175 -0.423334,-1.9738 -0.04498,-0.3757 -0.06614,-0.75406 -0.105833,-1.13241 -0.0344,-0.32015 0.07937,-0.55298 0.354542,-0.72496 0.470958,-0.29633 0.947208,-0.57679 1.486958,-0.72496 0.447146,-0.12171 0.883708,-0.11642 1.309688,0.0952 0.34925,0.17198 0.714375,0.17198 1.087437,0.0635 0.267229,-0.0794 0.542396,-0.15081 0.817563,-0.18521 0.751416,-0.0979 1.41552,0.13494 1.994958,0.61119 0.351896,0.29104 0.486833,0.67469 0.402166,1.12977 -0.185208,1.01071 -0.455083,1.9976 -0.809624,2.96069 -0.153459,0.41804 -0.423334,0.65881 -0.859896,0.73554 -0.568854,0.10054 -1.148292,0.1561 -1.674813,0.16933 z m -0.103187,-4.15925 c -0.0079,0 -0.01588,-0.003 -0.02646,-0.003 0,-0.0979 0.01588,-0.19844 -0.0026,-0.29369 -0.04233,-0.2249 -0.09525,-0.44979 -0.150813,-0.67204 -0.02381,-0.0926 -0.08467,-0.17463 -0.185208,-0.17727 -0.07673,-0.003 -0.171979,0.0159 -0.230188,0.0608 -0.0926,0.0714 -0.0926,0.18786 -0.04498,0.2884 0.108479,0.24341 0.137583,0.50006 0.121708,0.762 -0.01588,0.27252 -0.04762,0.54239 -0.07144,0.81491 -0.0026,0.0344 -0.01323,0.0688 -0.01588,0.10319 -0.01058,0.16404 0.06615,0.27517 0.203729,0.29104 0.145521,0.0185 0.256646,-0.0529 0.283104,-0.21696 0.04498,-0.3175 0.07937,-0.63764 0.119063,-0.95779 z"
                    id="path755"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('47')"
                    d="m 62.795796,142.62238 c -0.03969,0.32015 -0.07144,0.64029 -0.121709,0.95779 -0.02646,0.16405 -0.134937,0.23548 -0.283104,0.21696 -0.137583,-0.0185 -0.214312,-0.127 -0.203729,-0.29104 0.0026,-0.0344 0.01323,-0.0688 0.01587,-0.10319 0.02381,-0.27252 0.05556,-0.54239 0.07144,-0.81491 0.01588,-0.26194 -0.01058,-0.51859 -0.121709,-0.762 -0.04498,-0.10319 -0.04763,-0.21961 0.04498,-0.2884 0.05821,-0.045 0.153459,-0.0635 0.230188,-0.0608 0.100542,0.003 0.161396,0.0847 0.185208,0.17727 0.05556,0.22225 0.108479,0.44714 0.150813,0.67204 0.01852,0.0952 0.0026,0.19579 0.0026,0.29369 0.01058,0 0.01852,0.003 0.0291,0.003 z"
                    id="path778"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('47')"
                    id="text803"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="60.395336"
                    y="153.5"
                  >
                    47
                  </text>
                </g>
                <g id="g116">
                  <path
                    [attr.fill]="getTextColorForVisual('48')"
                    d="m 56.146817,141.49261 c -0.508,-0.48154 -1.121834,-0.762 -1.828271,-0.8255 -0.518584,-0.0476 -1.021292,0.0317 -1.513417,0.20109 -0.269875,0.0952 -0.53975,0.0952 -0.799041,-0.0344 -0.48948,-0.24342 -0.99748,-0.26194 -1.518709,-0.13758 -0.709083,0.16933 -1.328208,0.52652 -1.912937,0.94456 -0.177271,0.127 -0.277813,0.31221 -0.354542,0.51329 -0.02117,0.0556 -0.05556,0.10848 -0.08467,0.1614 v 0.42068 c 0.02646,0.15082 0.06615,0.29898 0.07937,0.4498 0.07937,0.92604 0.224896,1.83885 0.515938,2.7252 0.03969,0.12436 0.0979,0.24871 0.174625,0.35719 0.0291,0.0423 0.04762,0.0873 0.05821,0.12965 0.0979,0.0847 0.193146,0.17991 0.28575,0.27516 0.01058,0.0106 0.01587,0.0185 0.02117,0.0265 0.01323,0.003 0.03175,0.005 0.06085,0.0185 0.03969,0.0132 0.07937,0.0397 0.119063,0.0635 0.0026,-0.0159 0.0026,-0.0318 0.0053,-0.0476 0.619125,0.18256 1.225021,0.34131 1.846792,0.43127 0.627062,0.0926 1.259416,0.11642 1.891771,0.0873 0.632354,-0.0291 1.259416,-0.10054 1.886479,-0.30692 0.0026,0.008 0.0026,0.0159 0.0053,0.0238 0.06086,-0.037 0.127,-0.0688 0.1905,-0.10319 0.0079,-0.003 0.01323,-0.008 0.02117,-0.0132 0.04762,-0.0582 0.09525,-0.11906 0.156104,-0.16669 0.02646,-0.0238 0.05292,-0.0423 0.07937,-0.0609 0,-0.0582 0.01323,-0.11377 0.05292,-0.16933 0.06085,-0.0847 0.105833,-0.18257 0.142875,-0.28046 0.404812,-1.016 0.677333,-2.0664 0.883708,-3.13796 0.111125,-0.59267 -0.02646,-1.12713 -0.465666,-1.54517 z m -0.01058,1.37584 c -0.1905,1.05833 -0.463021,2.0955 -0.85725,3.09827 -0.137583,0.35189 -0.381,0.56356 -0.754062,0.62441 -0.193146,0.0318 -0.386292,0.082 -0.579438,0.10319 -0.404812,0.0423 -0.809625,0.0688 -1.04775,0.09 -1.19327,-0.0159 -2.193395,-0.17727 -3.169708,-0.48948 -0.269875,-0.0873 -0.439208,-0.26723 -0.526521,-0.53181 -0.179916,-0.55563 -0.312208,-1.12184 -0.386291,-1.70127 -0.06085,-0.49477 -0.0979,-0.99219 -0.145521,-1.48696 -0.02117,-0.21696 0.04233,-0.4154 0.219604,-0.5424 0.563562,-0.40216 1.158875,-0.74612 1.849437,-0.88106 0.351896,-0.0688 0.701146,-0.045 1.026584,0.11906 0.399521,0.19844 0.806979,0.20902 1.22502,0.0635 0.449792,-0.1561 0.910167,-0.22754 1.386417,-0.15875 0.537104,0.0794 1.010708,0.29898 1.407583,0.66146 0.301625,0.27252 0.423334,0.63235 0.351896,1.03188 z"
                    id="path710"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('48')"
                    d="m 52.895087,146.78163 c -1.19327,-0.0159 -2.193395,-0.17727 -3.169708,-0.48948 -0.269875,-0.0873 -0.439208,-0.26723 -0.526521,-0.53181 -0.179916,-0.55562 -0.312208,-1.12183 -0.386291,-1.70127 -0.06085,-0.49477 -0.0979,-0.99219 -0.145521,-1.48696 -0.02117,-0.21696 0.04233,-0.41539 0.219604,-0.54239 0.563563,-0.40217 1.158875,-0.74613 1.849438,-0.88107 0.351895,-0.0688 0.701145,-0.045 1.026583,0.11907 0.399521,0.19843 0.806979,0.20902 1.225021,0.0635 0.449791,-0.15611 0.910166,-0.22755 1.386416,-0.15875 0.537104,0.0794 1.010709,0.29898 1.407584,0.66145 0.301625,0.27517 0.423333,0.635 0.351895,1.03188 -0.1905,1.05833 -0.46302,2.0955 -0.85725,3.09827 -0.137583,0.3519 -0.381,0.56356 -0.754062,0.62442 -0.193146,0.0317 -0.386292,0.082 -0.579438,0.10318 -0.404812,0.0423 -0.809625,0.0714 -1.04775,0.09 z m -0.22225,-4.16189 c -0.0079,0 -0.01588,-0.003 -0.02381,-0.003 0,-0.10583 0.0053,-0.21167 -0.0026,-0.31485 -0.01852,-0.23284 -0.06085,-0.45773 -0.15875,-0.67204 -0.03704,-0.0794 -0.08731,-0.14288 -0.179917,-0.15875 -0.219604,-0.0397 -0.346604,0.127 -0.277812,0.35718 0.04233,0.14023 0.103188,0.28311 0.108479,0.42598 0.01058,0.29898 -0.0079,0.60061 -0.02381,0.90223 -0.0079,0.13229 -0.04498,0.26194 -0.05292,0.39688 -0.0079,0.12435 0.07673,0.22225 0.187854,0.24341 0.129646,0.0265 0.238125,-0.0318 0.28575,-0.1561 0.01588,-0.0397 0.02381,-0.082 0.0291,-0.12171 0.03704,-0.30162 0.07144,-0.6006 0.108479,-0.89958 z"
                    id="path742"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('48')"
                    d="m 52.672837,142.61974 c -0.0344,0.29898 -0.07144,0.59796 -0.105833,0.89693 -0.0053,0.0423 -0.01323,0.0847 -0.0291,0.12171 -0.04763,0.12436 -0.156104,0.18257 -0.28575,0.15611 -0.111125,-0.0238 -0.195792,-0.11907 -0.187854,-0.24342 0.0079,-0.13229 0.04498,-0.26194 0.05292,-0.39687 0.01588,-0.29898 0.03175,-0.60061 0.02381,-0.90223 -0.0053,-0.14288 -0.06615,-0.28575 -0.108479,-0.42598 -0.07144,-0.23019 0.05556,-0.39952 0.277812,-0.35719 0.09525,0.0159 0.142875,0.0794 0.179917,0.15875 0.0979,0.21431 0.140229,0.43921 0.15875,0.67204 0.0079,0.10583 0.0026,0.20902 0.0026,0.31486 0.0026,0.003 0.01058,0.003 0.02117,0.005 z"
                    id="path773"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('48')"
                    id="text804"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="50.284576"
                    y="153.5"
                  >
                    48
                  </text>
                </g>
                <g id="g97">
                  <path
                    [attr.fill]="getTextColorForVisual('25')"
                    d="m 152.21702,126.84528 c -0.0185,-0.0265 -0.0397,-0.0503 -0.0608,-0.0767 -0.0741,-0.10319 -0.14288,-0.20902 -0.21696,-0.31221 -0.0238,-0.0265 -0.0476,-0.0529 -0.0741,-0.0767 -0.0767,-0.0423 -0.14817,-0.0952 -0.21167,-0.15875 -0.005,-0.005 -0.0106,-0.0132 -0.0159,-0.0185 0,0.0106 0,0.0159 0,0.0265 -1.16946,-0.75142 -2.33892,-0.74348 -3.53484,-0.0238 0,-0.0106 0,-0.0159 0,-0.0265 -0.037,0.0318 -0.0714,0.0635 -0.11641,0.0926 -0.0529,0.037 -0.10848,0.0714 -0.16405,0.10584 -0.0344,0.0265 -0.0688,0.0423 -0.10583,0.0635 -0.0423,0.11377 -0.10583,0.21166 -0.18521,0.29368 -0.0212,0.082 -0.0476,0.16405 -0.0952,0.24078 -0.0291,0.045 -0.0344,0.10583 -0.0476,0.16139 -0.23813,0.97896 -0.38629,1.97115 -0.43656,2.99508 0,0.0106 -0.003,0.037 -0.005,0.0661 -0.0476,0.40481 0.0397,0.77788 0.25136,1.12713 0.25664,0.42333 0.55827,0.80697 0.889,1.17475 0.30956,0.34395 0.69056,0.56885 1.11654,0.73025 0.24342,0.0926 0.47625,0.0794 0.71173,-0.0397 0.57414,-0.29369 1.10067,-0.65088 1.54781,-1.11919 0.14288,-0.15081 0.29898,-0.26987 0.48948,-0.35719 0.29633,-0.13758 0.51594,-0.35983 0.6641,-0.65087 0.15611,-0.30692 0.22755,-0.64029 0.21432,-0.97896 -0.0397,-1.08744 -0.24077,-2.14577 -0.60061,-3.175 -0.005,-0.0185 -0.008,-0.0423 -0.0132,-0.0635 z m -0.0503,4.01108 c -0.10054,0.1905 -0.24871,0.33073 -0.4736,0.43127 -0.0106,-0.2487 -0.0159,-0.46566 -0.0318,-0.67998 -0.0106,-0.15345 -0.0212,-0.30956 -0.0529,-0.46037 -0.0397,-0.1905 -0.20902,-0.27252 -0.36512,-0.19315 -0.10319,0.0529 -0.13494,0.14552 -0.12436,0.28575 0.0291,0.37836 0.0476,0.75407 0.0714,1.13242 0.0132,0.19579 -0.0582,0.34396 -0.20637,0.4789 -0.39159,0.35718 -0.82286,0.65616 -1.29646,0.89164 -0.10319,0.0503 -0.19844,0.0609 -0.30427,0.0212 -0.39159,-0.14023 -0.7329,-0.35454 -0.99484,-0.68263 -0.037,-0.045 -0.0608,-0.11112 -0.0635,-0.16933 -0.005,-0.27252 -0.003,-0.54769 -0.003,-0.82021 0,-0.0423 0.0106,-0.0847 0.008,-0.127 -0.005,-0.13494 -0.0926,-0.23019 -0.21695,-0.24606 -0.11113,-0.0132 -0.2249,0.0556 -0.25665,0.17462 -0.0317,0.11907 -0.0397,0.24607 -0.0608,0.37042 -0.21167,-0.26194 -0.37836,-0.52917 -0.36513,-0.889 0.0397,-1.06362 0.19579,-2.10873 0.43921,-3.14325 0.045,-0.1905 0.13229,-0.35983 0.29369,-0.4736 0.508,-0.36248 1.06362,-0.60061 1.69862,-0.60325 0.6059,-0.003 1.13771,0.2196 1.61661,0.57679 0.17462,0.12964 0.2831,0.31221 0.3466,0.51594 0.27517,0.89429 0.46302,1.8071 0.50535,2.74637 0.0185,0.30427 -0.0212,0.59531 -0.16404,0.86254 z"
                    id="path732"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('25')"
                    d="m 147.80377,131.27176 c -0.21166,-0.26194 -0.37835,-0.52917 -0.36512,-0.889 0.0397,-1.06363 0.19579,-2.10873 0.43921,-3.14325 0.045,-0.1905 0.13229,-0.35983 0.29368,-0.47361 0.508,-0.36247 1.06363,-0.6006 1.69863,-0.60325 0.6059,-0.003 1.13771,0.21961 1.6166,0.5768 0.17463,0.12964 0.28311,0.3122 0.34661,0.51593 0.27516,0.8943 0.46302,1.80711 0.50535,2.74638 0.0132,0.29898 -0.0265,0.59002 -0.16933,0.85725 -0.10054,0.1905 -0.24871,0.33073 -0.47361,0.43127 -0.0106,-0.24871 -0.0159,-0.46567 -0.0317,-0.67998 -0.0106,-0.15346 -0.0212,-0.30956 -0.0529,-0.46037 -0.0397,-0.1905 -0.20902,-0.27253 -0.36513,-0.19315 -0.10318,0.0529 -0.13493,0.14552 -0.12435,0.28575 0.0291,0.37835 0.0476,0.75406 0.0714,1.13242 0.0132,0.19579 -0.0582,0.34395 -0.20638,0.47889 -0.39158,0.35719 -0.82285,0.65617 -1.29646,0.89165 -0.10318,0.0503 -0.19843,0.0609 -0.30427,0.0212 -0.39158,-0.14022 -0.73289,-0.35454 -0.99483,-0.68262 -0.037,-0.045 -0.0609,-0.11113 -0.0635,-0.16933 -0.005,-0.27252 -0.003,-0.54769 -0.003,-0.82021 0,-0.0423 0.0106,-0.0847 0.008,-0.127 -0.005,-0.13494 -0.0926,-0.23019 -0.21696,-0.24606 -0.11112,-0.0132 -0.22489,0.0556 -0.25664,0.17462 -0.0265,0.127 -0.037,0.25135 -0.0556,0.37571 z"
                    id="path765"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('25')"
                    id="text805"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="147.62968"
                    y="122"
                  >
                    25
                  </text>
                </g>
                <g id="g96">
                  <path
                    [attr.fill]="getTextColorForVisual('24')"
                    d="m 144.55998,126.3849 c -0.0132,-0.0264 -0.0159,-0.0609 -0.0185,-0.0926 -0.0317,-0.037 -0.0608,-0.0714 -0.0952,-0.10848 0.17727,0.19844 -0.1561,-0.13229 -0.1905,-0.16404 0.0767,0.0635 -0.21696,-0.1561 -0.17992,-0.12965 -0.0291,-0.0212 -0.0556,-0.0423 -0.0847,-0.0661 0,0.0132 0,0.0265 0.003,0.0423 -1.10066,-0.49477 -2.16693,-0.45508 -3.24379,0.005 0,0 0,0 0,0.003 -0.12435,0.16139 -0.30427,0.27517 -0.47096,0.38629 -0.0291,0.0212 -0.0582,0.0397 -0.09,0.0609 -0.0265,0.0767 -0.0609,0.14288 -0.10319,0.20373 -0.09,0.29369 -0.20638,0.57944 -0.29104,0.87577 -0.30163,1.04511 -0.47096,2.10873 -0.508,3.19617 -0.008,0.25929 0.0529,0.49213 0.25135,0.66675 0.1614,0.14288 0.32544,0.29104 0.508,0.40746 0.14817,0.0926 0.26194,0.20108 0.34925,0.3519 0.27252,0.4736 0.63765,0.87312 1.05833,1.21708 0.28046,0.22754 0.59267,0.27781 0.92869,0.13758 1.07156,-0.44979 2.00554,-1.09537 2.80194,-1.94469 0.16933,-0.17991 0.24077,-0.38629 0.23812,-0.63235 -0.005,-0.74083 -0.0741,-1.47373 -0.22225,-2.19869 -0.16404,-0.74877 -0.31485,-1.50812 -0.64029,-2.21721 z m 0.082,4.88421 c -0.22225,0.23284 -0.4736,0.43392 -0.74877,0.68527 -0.0741,-0.36777 -0.13758,-0.67468 -0.19844,-0.98425 -0.0159,-0.0767 -0.0265,-0.15345 -0.0529,-0.22489 -0.0423,-0.127 -0.15081,-0.18521 -0.28311,-0.16404 -0.127,0.0212 -0.20108,0.11641 -0.1905,0.25929 0.005,0.0688 0.0238,0.13758 0.037,0.20637 0.0767,0.39952 0.1561,0.7964 0.23547,1.19592 -0.0423,0.0317 -0.0661,0.0582 -0.0952,0.0741 -0.37041,0.19844 -0.74347,0.39423 -1.11654,0.58738 -0.17462,0.09 -0.33602,0.0635 -0.48683,-0.0661 -0.39952,-0.34131 -0.74348,-0.72496 -0.99219,-1.19062 -0.0344,-0.0635 -0.0529,-0.14552 -0.0556,-0.21696 -0.0106,-0.42333 0.0608,-0.83873 0.14817,-1.25148 0.0106,-0.0556 0.0265,-0.11113 0.0265,-0.16669 0,-0.11641 -0.0741,-0.20637 -0.17991,-0.22754 -0.12965,-0.0265 -0.23548,0.0106 -0.28046,0.127 -0.0397,0.10319 -0.0661,0.21431 -0.0847,0.32544 -0.0503,0.30427 -0.0926,0.60854 -0.14287,0.93133 -0.14288,-0.0873 -0.26194,-0.18521 -0.34131,-0.31485 -0.0476,-0.0794 -0.0688,-0.18786 -0.0609,-0.27782 0.0503,-0.55827 0.0952,-1.11918 0.17727,-1.67481 0.10054,-0.66675 0.28311,-1.31498 0.48419,-1.96056 0.10054,-0.3175 0.29104,-0.52917 0.6006,-0.65617 0.85725,-0.3466 1.7145,-0.38893 2.58234,-0.0344 0.32014,0.12964 0.52916,0.35189 0.63235,0.68527 0.3519,1.12977 0.60061,2.28071 0.65352,3.46604 0.003,0.0635 0.003,0.127 0.003,0.1905 0,0.49477 0.0503,0.34131 -0.26988,0.67733 z"
                    id="path725"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('24')"
                    d="m 143.89059,131.95438 c -0.0741,-0.36777 -0.13759,-0.67468 -0.19844,-0.98425 -0.0159,-0.0767 -0.0265,-0.15345 -0.0529,-0.22489 -0.0423,-0.127 -0.15081,-0.18521 -0.2831,-0.16404 -0.127,0.0212 -0.20109,0.11641 -0.1905,0.25929 0.005,0.0688 0.0238,0.13758 0.037,0.20637 0.0767,0.39952 0.1561,0.7964 0.23548,1.19592 -0.0423,0.0317 -0.0661,0.0582 -0.0953,0.0741 -0.37042,0.19844 -0.74348,0.39423 -1.11654,0.58738 -0.17463,0.09 -0.33602,0.0635 -0.48684,-0.0661 -0.39952,-0.34131 -0.74348,-0.72496 -0.99218,-1.19062 -0.0344,-0.0635 -0.0529,-0.14552 -0.0556,-0.21696 -0.0106,-0.42333 0.0609,-0.83873 0.14817,-1.25148 0.0106,-0.0556 0.0265,-0.11113 0.0265,-0.16669 0,-0.11641 -0.0741,-0.20637 -0.17992,-0.22754 -0.12964,-0.0265 -0.23548,0.0106 -0.28046,0.127 -0.0397,0.10319 -0.0661,0.21431 -0.0847,0.32544 -0.0503,0.30427 -0.0926,0.60854 -0.14288,0.93133 -0.14287,-0.0873 -0.26194,-0.18521 -0.34131,-0.31485 -0.0476,-0.0794 -0.0688,-0.18786 -0.0608,-0.27782 0.0503,-0.55827 0.0952,-1.11918 0.17727,-1.67481 0.10054,-0.66675 0.2831,-1.31498 0.48418,-1.96056 0.10055,-0.3175 0.29105,-0.52917 0.60061,-0.65617 0.85725,-0.3466 1.7145,-0.38893 2.58233,-0.0344 0.32015,0.12964 0.52917,0.35189 0.63236,0.68527 0.35189,1.12977 0.6006,2.28071 0.65352,3.46604 0.003,0.0635 0.003,0.127 0.003,0.1905 -0.003,0.49742 0.0476,0.34396 -0.27252,0.67998 -0.21696,0.23019 -0.46831,0.43392 -0.74612,0.68262 z"
                    id="path757"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('24')"
                    id="text806"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="140.31125"
                    y="122"
                  >
                    24
                  </text>
                </g>
                <g id="g95">
                  <path
                    [attr.fill]="getTextColorForVisual('23')"
                    d="m 137.19134,127.68136 c -0.16669,-0.43127 -0.35455,-0.8546 -0.55298,-1.27264 -0.037,-0.0767 -0.0688,-0.15082 -0.0979,-0.22754 -0.11377,-0.0794 -0.21696,-0.17198 -0.29633,-0.30957 -0.0132,-0.0238 -0.0185,-0.0476 -0.0291,-0.0688 -0.0635,-0.0476 -0.127,-0.0979 -0.17991,-0.14817 -0.0423,-0.0397 -0.0847,-0.082 -0.12171,-0.12435 0.005,0.0265 0.008,0.0503 0.0132,0.0794 -1.10331,-0.80169 -2.15106,-0.75407 -3.19881,0.0556 -0.003,-0.0159 -0.005,-0.0265 -0.008,-0.037 -0.1614,0.18256 -0.40746,0.3175 -0.51329,0.51064 -0.0159,0.0265 -0.0344,0.0476 -0.0503,0.0741 0,0.0106 -0.003,0.0185 -0.003,0.0291 -0.005,0.0688 -0.0185,0.14287 -0.0503,0.20108 -0.1614,0.29104 -0.254,0.60854 -0.33338,0.92869 -0.22225,0.89429 -0.39952,1.79652 -0.4392,2.71992 -0.0132,0.43127 0.0847,0.79639 0.3175,1.18268 0.4736,0.78317 1.08743,1.44463 1.78064,2.0373 0.21961,0.18785 0.43392,0.22489 0.69586,0.10848 0.381,-0.16669 0.74083,-0.37042 1.08214,-0.6059 0.1614,-0.11113 0.31486,-0.23813 0.48948,-0.33073 0.82815,-0.44185 1.41817,-1.11654 1.8706,-1.92087 0.17728,-0.3175 0.21961,-0.66146 0.15082,-1.0213 -0.12436,-0.635 -0.29634,-1.25677 -0.52652,-1.86002 z m -0.12436,2.75696 c -0.41275,0.67998 -0.92604,1.25148 -1.64041,1.62719 -0.1905,0.10054 -0.35984,0.24342 -0.53975,0.36512 -0.32544,0.22225 -0.66411,0.41805 -1.0504,0.56886 -0.73025,-0.60325 -1.3626,-1.27794 -1.82827,-2.0955 -0.15081,-0.26459 -0.19315,-0.55298 -0.17992,-0.85461 0.0238,-0.58473 0.11377,-1.16152 0.23284,-1.73037 0.0741,-0.34925 0.15345,-0.6985 0.24606,-1.04511 0.19844,-0.74347 0.64294,-1.28587 1.35466,-1.59543 0.48419,-0.21167 0.97103,-0.20373 1.44728,0.0238 0.58472,0.28046 1.02658,0.70115 1.28322,1.30969 0.34925,0.82285 0.635,1.66423 0.82021,2.54264 0.0688,0.31486 0.0265,0.60325 -0.14552,0.88371 z"
                    id="path738"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('23')"
                    d="m 133.83642,132.99684 c -0.73025,-0.60325 -1.3626,-1.27794 -1.82827,-2.0955 -0.15081,-0.26458 -0.19315,-0.55298 -0.17992,-0.8546 0.0238,-0.58473 0.11377,-1.16152 0.23284,-1.73038 0.0741,-0.34925 0.15345,-0.6985 0.24606,-1.0451 0.19844,-0.74348 0.64294,-1.28588 1.35466,-1.59544 0.48419,-0.21167 0.97103,-0.20373 1.44728,0.0238 0.58472,0.28046 1.02658,0.70115 1.28322,1.30969 0.34925,0.82286 0.635,1.66423 0.82021,2.54265 0.0688,0.32014 0.0238,0.60854 -0.14552,0.88635 -0.41275,0.67998 -0.92604,1.25148 -1.64041,1.62719 -0.1905,0.10054 -0.35984,0.24342 -0.53975,0.36512 -0.32544,0.21961 -0.66411,0.4154 -1.0504,0.56621 z m -0.8255,-4.02696 c 0.0423,0.55298 0.082,1.18534 0.14287,1.81505 0.0397,0.41804 0.10584,0.83608 0.16934,1.25412 0.0265,0.17992 0.13229,0.26194 0.28575,0.24077 0.14816,-0.0185 0.22754,-0.13229 0.20637,-0.30956 -0.0132,-0.11113 -0.0344,-0.22225 -0.0503,-0.33338 -0.18256,-1.23825 -0.29633,-2.48179 -0.21696,-3.73856 0.003,-0.0291 0.008,-0.0556 0.003,-0.0847 -0.0185,-0.12964 -0.11377,-0.2196 -0.23813,-0.22489 -0.12964,-0.003 -0.22225,0.0741 -0.2487,0.20902 -0.005,0.0344 -0.008,0.0688 -0.008,0.10583 -0.0159,0.33073 -0.0291,0.65882 -0.045,1.06627 z"
                    id="path771"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('23')"
                    d="m 133.01092,128.96988 c 0.0159,-0.40745 0.0291,-0.73818 0.0423,-1.06627 0.003,-0.0344 0.003,-0.0714 0.008,-0.10583 0.0265,-0.13494 0.11906,-0.21167 0.24871,-0.20902 0.12435,0.003 0.22225,0.0926 0.23812,0.22489 0.003,0.0265 -0.003,0.0556 -0.003,0.0847 -0.0794,1.25413 0.0318,2.49767 0.21696,3.73856 0.0159,0.11113 0.037,0.22225 0.0503,0.33338 0.0185,0.17727 -0.0582,0.29104 -0.20638,0.30956 -0.15081,0.0185 -0.25929,-0.0635 -0.28575,-0.24077 -0.0609,-0.41804 -0.127,-0.83344 -0.16933,-1.25412 -0.0582,-0.62971 -0.0979,-1.25942 -0.14023,-1.81505 z"
                    id="path787"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('23')"
                    id="text807"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="132.76959"
                    y="122"
                  >
                    23
                  </text>
                </g>
                <g id="g94">
                  <path
                    [attr.fill]="getTextColorForVisual('22')"
                    d="m 128.98396,127.67607 c -0.0608,-0.0741 -0.11642,-0.1561 -0.16139,-0.25929 -0.0106,-0.0265 -0.0423,-0.13758 -0.0688,-0.24342 -0.0476,-0.0529 -0.0873,-0.10848 -0.1217,-0.17198 -0.10584,-0.0847 -0.1958,-0.18785 -0.254,-0.3122 -0.045,-0.0423 -0.09,-0.0873 -0.12965,-0.127 -0.0106,0.003 -0.0185,0.005 -0.0291,0.008 -0.0953,-0.082 -0.18786,-0.16668 -0.28575,-0.24341 -0.30692,-0.24077 -0.64559,-0.39423 -1.04511,-0.38365 -0.30427,0.008 -0.58208,0.10319 -0.8255,0.28046 -0.19844,0.14287 -0.38629,0.30692 -0.58473,0.4736 -0.0661,0.11642 -0.1561,0.21432 -0.26987,0.29104 -0.0556,0.0952 -0.11113,0.1905 -0.17198,0.28046 -0.0423,0.0635 -0.0952,0.12436 -0.14288,0.18521 -0.0238,0.09 -0.0582,0.17727 -0.10583,0.25665 -0.008,0.045 -0.0159,0.09 -0.0318,0.13229 -0.35983,0.92869 -0.51594,1.89177 -0.53975,3.00302 0.0185,0.26987 0.0344,0.65617 0.0794,1.03981 0.0556,0.47625 0.34396,0.78581 0.76994,0.97896 0.29898,0.13494 0.61648,0.18521 0.93663,0.23548 0.50535,0.0794 1.00541,0.0847 1.50812,-0.0238 0.33602,-0.0714 0.67204,-0.13494 1.00806,-0.20902 0.12171,-0.0265 0.24607,-0.0609 0.35719,-0.11642 0.66411,-0.32808 0.93663,-0.91017 0.92075,-1.60602 -0.0291,-1.14829 -0.30427,-2.25161 -0.75141,-3.30994 -0.0238,-0.0529 -0.0423,-0.10583 -0.0609,-0.15875 z m 0.15346,4.1619 c -0.16669,0.31221 -0.41804,0.50271 -0.80433,0.56091 0.0132,-0.14816 0.0291,-0.27252 0.0344,-0.39687 0.0212,-0.57679 0.0185,-1.15094 -0.0688,-1.72244 -0.005,-0.0265 -0.005,-0.0556 -0.0106,-0.0847 -0.0344,-0.13758 -0.14552,-0.21431 -0.28046,-0.19579 -0.12965,0.0185 -0.21961,0.13494 -0.20638,0.27252 0.0132,0.1323 0.037,0.26459 0.0476,0.39688 0.0556,0.59531 0.0556,1.19062 -0.0238,1.78064 -0.45773,0.23813 -1.35732,0.26988 -1.83886,0.127 -0.0106,-0.1852 -0.0291,-0.37835 -0.0318,-0.57414 -0.008,-0.44186 0.0212,-0.88371 0.0979,-1.32027 0.0106,-0.0556 0.0185,-0.11113 0.0185,-0.16669 0.003,-0.13758 -0.0741,-0.23548 -0.19844,-0.25929 -0.12964,-0.0238 -0.25664,0.0503 -0.28046,0.19314 -0.0503,0.3175 -0.10054,0.6403 -0.11906,0.96044 -0.0212,0.34925 -0.005,0.70115 -0.005,1.05304 -0.40217,-0.0582 -0.63765,-0.30427 -0.69056,-0.70114 -0.15082,-1.14829 -0.0344,-2.27013 0.30691,-3.37079 0.18521,-0.59532 0.50271,-1.11125 0.96573,-1.53194 0.10319,-0.0926 0.21696,-0.17727 0.33602,-0.25136 0.37307,-0.22754 0.74613,-0.21431 1.10861,0.0238 0.26987,0.17462 0.47625,0.41275 0.66675,0.66675 0.30162,0.40481 0.49212,0.86254 0.65352,1.33614 0.26723,0.78846 0.43391,1.59809 0.48419,2.42888 0.0185,0.27516 -0.0318,0.53446 -0.1614,0.77523 z"
                    id="path729"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('22')"
                    d="m 128.33309,132.39888 c 0.0132,-0.14816 0.0291,-0.27252 0.0344,-0.39687 0.0212,-0.57679 0.0185,-1.15094 -0.0688,-1.72244 -0.005,-0.0265 -0.005,-0.0556 -0.0106,-0.0847 -0.0344,-0.13758 -0.14552,-0.21431 -0.28046,-0.19579 -0.12965,0.0185 -0.21961,0.13494 -0.20638,0.27252 0.0132,0.1323 0.037,0.26459 0.0476,0.39688 0.0556,0.59531 0.0556,1.19062 -0.0238,1.78064 -0.45773,0.23813 -1.35732,0.26988 -1.83886,0.127 -0.0106,-0.1852 -0.0291,-0.37835 -0.0318,-0.57414 -0.008,-0.4445 0.0212,-0.88371 0.0979,-1.32027 0.0106,-0.0556 0.0185,-0.11113 0.0185,-0.16669 0.003,-0.13758 -0.0741,-0.23548 -0.19844,-0.25929 -0.12964,-0.0238 -0.25664,0.0503 -0.28046,0.19314 -0.0503,0.3175 -0.10054,0.6403 -0.11906,0.96044 -0.0212,0.34925 -0.005,0.70115 -0.005,1.05304 -0.40217,-0.0582 -0.63765,-0.30427 -0.69056,-0.70114 -0.15082,-1.14829 -0.0344,-2.27013 0.30691,-3.37079 0.18521,-0.59532 0.50271,-1.11125 0.96573,-1.53194 0.10319,-0.0926 0.21696,-0.17727 0.33602,-0.25136 0.37307,-0.22754 0.74613,-0.21431 1.10861,0.0238 0.26987,0.17462 0.47625,0.41275 0.66675,0.66675 0.30162,0.40481 0.49212,0.86254 0.65352,1.33614 0.26723,0.78846 0.43391,1.59809 0.48419,2.42888 0.0159,0.27252 -0.0344,0.53181 -0.16405,0.77258 -0.16404,0.31486 -0.41539,0.50536 -0.80168,0.56356 z"
                    id="path761"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('22')"
                    id="text808"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="124.96232"
                    y="122"
                  >
                    22
                  </text>
                </g>
                <g id="g93">
                  <path
                    [attr.fill]="getTextColorForVisual('21')"
                    d="m 122.55459,127.53584 c -0.0953,-0.48683 -0.24342,-0.9525 -0.60061,-1.32291 -0.0132,-0.0132 -0.0185,-0.0318 -0.0265,-0.0476 -0.23283,-0.10583 -0.43656,-0.24077 -0.61648,-0.39952 -1.23031,-0.70644 -2.40506,-0.47625 -3.56393,0.0952 -0.008,-0.0132 -0.0159,-0.0212 -0.0212,-0.0291 -0.0847,0.0609 -0.17992,0.11112 -0.28046,0.15081 0.0847,-0.0344 0.0714,-0.0238 -0.037,0.0344 0.0529,-0.0529 0.0423,-0.0423 -0.0397,0.0344 -0.0582,0.0529 -0.11906,0.0953 -0.17991,0.13229 -0.008,0.0529 -0.0291,0.10848 -0.0582,0.15081 -0.15346,0.23284 -0.24871,0.48684 -0.31221,0.75407 -0.1905,0.78845 -0.17992,1.59014 -0.10319,2.38918 0.0476,0.49477 0.13229,0.98955 0.20373,1.48167 0.0688,0.4736 0.17727,0.93927 0.33073,1.39171 0.10319,0.30692 0.32015,0.50006 0.63765,0.54504 0.18256,0.0265 0.37835,0 0.56091,-0.0291 0.13229,-0.0212 0.25665,-0.0397 0.39423,-0.0132 0.48948,0.0979 0.98161,0.10054 1.4605,-0.0476 0.25136,-0.0767 0.49477,-0.12171 0.762,-0.10848 0.55827,0.0238 1.04246,-0.30956 1.24884,-0.83079 0.0476,-0.11642 0.0847,-0.23812 0.11906,-0.35983 0.20108,-0.73025 0.26458,-1.47638 0.24871,-2.22515 0.008,-0.59002 -0.0159,-1.1721 -0.127,-1.74625 z m -0.46567,3.20146 c -0.0556,0.30427 -0.12435,0.6059 -0.2196,0.89694 -0.11907,0.36248 -0.40746,0.56091 -0.77523,0.56091 0.0106,-0.32279 0.0291,-0.6297 0.0265,-0.93662 -0.003,-0.33073 -0.0159,-0.65881 -0.0397,-0.98954 -0.0106,-0.17198 -0.12436,-0.254 -0.28311,-0.23284 -0.13758,0.0185 -0.20108,0.11907 -0.19843,0.29634 0.008,0.49741 0.0106,0.99748 0.0132,1.49489 0,0.09 -0.003,0.18521 -0.0238,0.27252 -0.0106,0.045 -0.0476,0.10584 -0.09,0.12171 -0.47889,0.1905 -0.97366,0.25929 -1.48695,0.16669 -0.0476,-0.008 -0.0953,-0.0265 -0.15082,-0.0423 -0.0873,-0.51329 -0.127,-1.02923 -0.11112,-1.55046 0.005,-0.15346 0.0212,-0.30692 0.0344,-0.46302 0.0132,-0.17463 -0.0714,-0.2884 -0.22225,-0.29898 -0.15875,-0.0132 -0.25135,0.0714 -0.27252,0.25135 -0.0714,0.56886 -0.0423,1.13507 0.0212,1.70392 0.0132,0.12435 0.0291,0.24871 0.0423,0.37042 -0.34925,0.15875 -0.5662,0.0635 -0.67468,-0.28311 -0.14288,-0.44979 -0.24077,-0.91016 -0.29898,-1.37583 -0.0741,-0.57679 -0.1614,-1.15623 -0.20638,-1.73567 -0.0476,-0.61912 -0.0185,-1.2356 0.14817,-1.83885 0.0397,-0.14023 0.0979,-0.27781 0.15875,-0.41011 0.0741,-0.1561 0.19579,-0.26723 0.35454,-0.34395 0.4789,-0.24078 0.96837,-0.44715 1.50548,-0.52123 0.60589,-0.0847 1.17475,0.0212 1.69862,0.34131 0.09,0.0556 0.17463,0.11906 0.26723,0.16669 0.32015,0.16668 0.50271,0.4392 0.62177,0.76729 0.14817,0.40746 0.21432,0.83344 0.23284,1.25941 0.0344,0.78053 0.0688,1.57163 -0.0714,2.35215 z"
                    id="path731"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('21')"
                    d="m 121.09409,132.19515 c 0.0106,-0.32279 0.0291,-0.6297 0.0265,-0.93662 -0.003,-0.33073 -0.0159,-0.65881 -0.0397,-0.98954 -0.0106,-0.17198 -0.12436,-0.254 -0.28311,-0.23284 -0.13758,0.0185 -0.20108,0.11907 -0.19843,0.29634 0.008,0.49741 0.0106,0.99748 0.0132,1.49489 0,0.09 -0.003,0.18521 -0.0238,0.27252 -0.0106,0.045 -0.0476,0.10584 -0.09,0.12171 -0.47889,0.1905 -0.97366,0.25929 -1.48695,0.16669 -0.0476,-0.008 -0.0953,-0.0265 -0.15082,-0.0423 -0.0873,-0.51329 -0.127,-1.02923 -0.11112,-1.55046 0.005,-0.15346 0.0212,-0.30692 0.0344,-0.46302 0.0132,-0.17463 -0.0714,-0.2884 -0.22225,-0.29898 -0.15875,-0.0132 -0.25135,0.0714 -0.27252,0.25135 -0.0714,0.56886 -0.0423,1.13507 0.0212,1.70392 0.0132,0.12435 0.0291,0.24871 0.0423,0.37042 -0.34925,0.15875 -0.5662,0.0635 -0.67468,-0.28311 -0.14288,-0.44979 -0.24077,-0.91016 -0.29898,-1.37583 -0.0741,-0.57679 -0.1614,-1.15623 -0.20638,-1.73567 -0.0476,-0.61912 -0.0185,-1.2356 0.14817,-1.83885 0.0397,-0.14023 0.0979,-0.27781 0.15875,-0.41011 0.0741,-0.1561 0.19579,-0.26723 0.35454,-0.34395 0.4789,-0.24078 0.96837,-0.44715 1.50548,-0.52123 0.60589,-0.0847 1.17475,0.0212 1.69862,0.34131 0.09,0.0556 0.17463,0.11906 0.26723,0.16669 0.32015,0.16668 0.50271,0.4392 0.62177,0.76729 0.14817,0.40746 0.21432,0.83344 0.23284,1.25941 0.0344,0.78582 0.0661,1.57428 -0.0741,2.3548 -0.0556,0.30427 -0.12435,0.60589 -0.2196,0.89693 -0.11906,0.35984 -0.40481,0.55563 -0.77258,0.55827 z"
                    id="path764"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('21')"
                    id="text809"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="117.41963"
                    y="122"
                  >
                    21
                  </text>
                </g>
                <g id="g100">
                  <path
                    [attr.fill]="getTextColorForVisual('28')"
                    d="m 182.72613,127.32418 c -0.11642,-0.3228 -0.23548,-0.64823 -0.38894,-0.95515 -0.0344,-0.0661 -0.0556,-0.13229 -0.0714,-0.19579 -0.16404,-0.14552 -0.3175,-0.31221 -0.48154,-0.46038 -0.0159,-0.0132 -0.0265,-0.0291 -0.0423,-0.0423 -0.003,0.0159 -0.008,0.0344 -0.0132,0.0635 -0.58208,-0.28046 -1.19063,-0.24077 -1.79123,-0.25665 -0.82285,-0.0212 -1.64306,0.0423 -2.45533,0.17727 -0.14817,0.0238 -0.29634,0.0714 -0.45244,0.11642 -0.0132,0.008 -0.0265,0.0159 -0.037,0.0238 -0.10584,0.045 -0.21432,0.09 -0.32015,0.13494 -0.0714,0.0503 -0.14287,0.0979 -0.20902,0.14552 0,0.0873 -0.0212,0.15611 -0.0714,0.23284 -0.09,0.14022 -0.17727,0.29104 -0.22754,0.44714 -0.42598,1.3044 -0.73819,2.63525 -0.9525,3.98992 -0.0847,0.5371 0.0767,0.99483 0.45773,1.38377 0.36777,0.37571 0.80433,0.65352 1.25413,0.9181 0.32543,0.1905 0.64293,0.19844 0.98425,0.0476 0.61912,-0.27252 1.21179,-0.59002 1.75947,-0.9869 0.24607,-0.17727 0.34661,-0.16669 0.57415,0.0291 0.16404,0.14287 0.33338,0.28045 0.51065,0.40745 0.21166,0.15346 0.45243,0.1905 0.70114,0.11642 0.55563,-0.16404 1.08479,-0.39423 1.55046,-0.74348 0.46038,-0.34396 0.65881,-0.81491 0.56885,-1.38641 -0.17462,-1.09273 -0.46831,-2.16165 -0.84666,-3.20675 z m -0.0609,4.23068 c -0.39423,0.27517 -0.83079,0.46567 -1.28587,0.61913 -0.14288,0.0476 -0.27517,0.0344 -0.39688,-0.0609 -0.10318,-0.0847 -0.20637,-0.16668 -0.3122,-0.2487 -0.16405,-0.127 -0.33073,-0.254 -0.52388,-0.40217 0,-0.0847 0.008,-0.21167 -0.003,-0.33602 -0.0264,-0.38365 -0.0582,-0.76994 -0.0873,-1.15359 -0.008,-0.11112 -0.0476,-0.20637 -0.15875,-0.25135 -0.1905,-0.0767 -0.35719,0.0714 -0.33602,0.29369 0.0291,0.28575 0.0635,0.5715 0.0873,0.85989 0.0132,0.17463 0.0159,0.3519 0.0185,0.52652 0,0.0688 -0.005,0.1323 -0.0794,0.18257 -0.45508,0.30162 -0.90752,0.61383 -1.40494,0.84931 -0.18256,0.0873 -0.37041,0.16669 -0.55562,0.25135 -0.10584,0.0476 -0.21696,0.0661 -0.32544,0.0106 -0.48683,-0.254 -0.95515,-0.53975 -1.32556,-0.9525 -0.23548,-0.26194 -0.32809,-0.55563 -0.27252,-0.91017 0.20637,-1.30704 0.51593,-2.58762 0.91016,-3.84969 0.14552,-0.46566 0.45773,-0.75671 0.94192,-0.82285 0.51329,-0.0714 1.03187,-0.12436 1.54781,-0.1614 0.63236,-0.045 1.26471,-0.0265 1.89442,0.0397 0.46567,0.0476 0.80962,0.29104 0.98425,0.72231 0.50271,1.23825 0.88106,2.51619 1.10331,3.83911 0.0635,0.39158 -0.082,0.71966 -0.42069,0.95514 z"
                    id="path718"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('28')"
                    d="m 180.14644,131.46226 c 0,-0.0847 0.008,-0.21167 -0.003,-0.33602 -0.0264,-0.38365 -0.0582,-0.76994 -0.0873,-1.15359 -0.008,-0.11112 -0.0476,-0.20637 -0.15875,-0.25135 -0.1905,-0.0767 -0.35719,0.0714 -0.33602,0.29369 0.0291,0.28575 0.0635,0.5715 0.0873,0.85989 0.0132,0.17463 0.0159,0.3519 0.0185,0.52652 0,0.0688 -0.005,0.1323 -0.0794,0.18257 -0.45508,0.30162 -0.90752,0.61383 -1.40494,0.84931 -0.18256,0.0873 -0.37041,0.16669 -0.55562,0.25135 -0.10584,0.0476 -0.21696,0.0661 -0.32544,0.0106 -0.48683,-0.254 -0.95515,-0.53975 -1.32556,-0.9525 -0.23548,-0.26194 -0.32809,-0.55563 -0.27252,-0.91017 0.20637,-1.30704 0.51593,-2.58762 0.91016,-3.84969 0.14552,-0.46566 0.45773,-0.75671 0.94192,-0.82285 0.51329,-0.0714 1.03187,-0.12436 1.54781,-0.1614 0.63236,-0.045 1.26471,-0.0265 1.89442,0.0397 0.46567,0.0476 0.80962,0.29104 0.98425,0.72231 0.50271,1.23825 0.88106,2.51619 1.10331,3.83911 0.0688,0.40481 -0.0794,0.73289 -0.41539,0.96837 -0.39423,0.27517 -0.8308,0.46567 -1.28588,0.61913 -0.14287,0.0476 -0.27517,0.0344 -0.39687,-0.0609 -0.10319,-0.0847 -0.20638,-0.16668 -0.31221,-0.24871 -0.16934,-0.14287 -0.33602,-0.26722 -0.52917,-0.41539 z"
                    id="path750"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('28')"
                    id="text810"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="177.36067"
                    y="122"
                  >
                    28
                  </text>
                </g>
                <g id="g99">
                  <path
                    [attr.fill]="getTextColorForVisual('27')"
                    d="m 172.82013,127.41413 c -0.12436,-0.34925 -0.25665,-0.6985 -0.4154,-1.03452 -0.0397,-0.082 -0.0714,-0.16139 -0.09,-0.24077 -0.0529,-0.0344 -0.10318,-0.0714 -0.15345,-0.11906 -0.0503,-0.045 -0.0952,-0.0979 -0.13759,-0.15081 -0.0344,-0.037 -0.0661,-0.0741 -0.0979,-0.11113 -0.045,-0.0238 -0.0847,-0.0556 -0.12436,-0.0873 -0.003,0.0212 -0.005,0.037 -0.008,0.0582 -0.1217,-0.045 -0.23018,-0.0926 -0.34131,-0.12436 -0.35454,-0.10848 -0.72231,-0.10318 -1.08479,-0.11641 -0.3175,-0.0132 -0.635,-0.0132 -0.9525,-0.005 -0.0265,0 -0.0529,0.003 -0.082,0.003 -0.39952,0.0132 -0.79904,0.0397 -1.19592,0.09 -0.37571,0.0476 -0.75671,0.0688 -1.12448,0.24606 0,0 0,0 0,-0.003 -0.0688,0.0688 -0.14287,0.13229 -0.22754,0.1905 -0.0767,0.0529 -0.20637,0.127 -0.25664,0.16933 -0.005,0.0318 -0.0185,0.0635 -0.045,0.0953 -0.14817,0.18256 -0.23548,0.39687 -0.30427,0.62177 -0.37307,1.20915 -0.65882,2.43946 -0.88371,3.683 -0.11113,0.61383 0.008,1.14035 0.45508,1.58485 0.41804,0.4154 0.90488,0.73555 1.43404,0.98955 0.21696,0.10583 0.44979,0.0873 0.67469,-0.005 0.65352,-0.26458 1.26735,-0.60325 1.8415,-1.0107 0.28575,-0.20373 0.36513,-0.1958 0.62177,0.0317 0.15346,0.13493 0.31221,0.26193 0.47625,0.381 0.21696,0.1561 0.46302,0.19843 0.72231,0.11906 0.52652,-0.15875 1.02659,-0.381 1.47902,-0.69586 0.52653,-0.36777 0.72496,-0.87577 0.61913,-1.50283 -0.17198,-1.04775 -0.44715,-2.0611 -0.79904,-3.05594 z m -0.0476,4.10634 c -0.4101,0.30691 -0.87577,0.50271 -1.35731,0.6641 -0.127,0.0423 -0.24871,0.0265 -0.35719,-0.0635 -0.10848,-0.09 -0.2196,-0.17462 -0.33073,-0.26194 -0.15875,-0.12435 -0.3175,-0.2487 -0.49477,-0.38629 -0.0159,-0.28839 -0.0265,-0.61119 -0.0476,-0.93133 -0.0159,-0.20373 -0.0397,-0.40481 -0.0741,-0.6059 -0.0291,-0.17991 -0.13758,-0.25664 -0.28839,-0.23018 -0.13758,0.0238 -0.20373,0.127 -0.1905,0.30162 0.0317,0.44715 0.0608,0.89694 0.0926,1.34408 0.003,0.0556 0,0.11113 0,0.1614 -0.61383,0.44979 -1.25412,0.83608 -1.94733,1.13506 -0.19844,0.0847 -0.36777,0.0794 -0.55563,-0.0318 -0.3757,-0.22225 -0.74347,-0.45244 -1.06097,-0.75406 -0.34132,-0.32279 -0.45509,-0.69056 -0.37307,-1.16152 0.21167,-1.22767 0.49477,-2.43417 0.8599,-3.62479 0.0132,-0.0476 0.0265,-0.0952 0.045,-0.14023 0.15081,-0.42334 0.43921,-0.70909 0.889,-0.77523 0.51329,-0.0767 1.03187,-0.12965 1.54781,-0.16669 0.63765,-0.0476 1.27794,-0.0291 1.91558,0.0344 0.48419,0.0476 0.82815,0.29633 1.01071,0.74612 0.38629,0.9525 0.69586,1.92881 0.91811,2.93159 0.0688,0.30956 0.12964,0.61912 0.17727,0.93133 0.0476,0.36248 -0.0847,0.6641 -0.37836,0.88371 z"
                    id="path719"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('27')"
                    d="m 170.22986,131.47284 c -0.0159,-0.28839 -0.0265,-0.61119 -0.0476,-0.93133 -0.0159,-0.20373 -0.0397,-0.40481 -0.0741,-0.6059 -0.0291,-0.17991 -0.13758,-0.25664 -0.2884,-0.23018 -0.13758,0.0238 -0.20373,0.127 -0.1905,0.30162 0.0317,0.44715 0.0609,0.89694 0.0926,1.34408 0.003,0.0556 0,0.11113 0,0.1614 -0.61384,0.44979 -1.25413,0.83608 -1.94734,1.13506 -0.19843,0.0847 -0.36777,0.0794 -0.55562,-0.0318 -0.37571,-0.22225 -0.74348,-0.45244 -1.06098,-0.75406 -0.34131,-0.32279 -0.45508,-0.69056 -0.37306,-1.16152 0.21166,-1.22767 0.49477,-2.43417 0.85989,-3.62479 0.0132,-0.0476 0.0265,-0.0952 0.045,-0.14023 0.15081,-0.42334 0.43921,-0.70909 0.889,-0.77523 0.51329,-0.0767 1.03188,-0.12965 1.54781,-0.16669 0.63765,-0.0476 1.27794,-0.0291 1.91559,0.0344 0.48419,0.0476 0.82814,0.29633 1.01071,0.74612 0.38629,0.9525 0.69585,1.92881 0.9181,2.93159 0.0688,0.30956 0.12965,0.61912 0.17727,0.93133 0.0556,0.36512 -0.0794,0.66675 -0.37042,0.88635 -0.4101,0.30692 -0.87577,0.50271 -1.35731,0.66411 -0.127,0.0423 -0.24871,0.0265 -0.35719,-0.0635 -0.10847,-0.09 -0.2196,-0.17463 -0.33072,-0.26194 -0.16405,-0.127 -0.3228,-0.25135 -0.50271,-0.38894 z"
                    id="path751"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('27')"
                    id="text811"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="166.72462"
                    y="122"
                  >
                    27
                  </text>
                </g>
                <g id="g98">
                  <path
                    [attr.fill]="getTextColorForVisual('26')"
                    d="m 162.32146,126.58334 c -0.16139,-0.24606 -0.34131,-0.48419 -0.53975,-0.6985 -0.0688,-0.0741 -0.10319,-0.13758 -0.11112,-0.21431 -0.12436,-0.0688 -0.24077,-0.14552 -0.34661,-0.23813 -0.0397,-0.0185 -0.0794,-0.037 -0.11641,-0.0582 -0.005,0.0159 -0.008,0.0344 -0.0132,0.0503 -1.65894,-0.49477 -3.30465,-0.39688 -4.97417,-0.005 -0.003,-0.005 -0.005,-0.0159 -0.008,-0.0212 -0.037,0.0476 -0.0741,0.10054 -0.11906,0.14287 -0.10319,0.0979 -0.20638,0.15875 -0.32015,0.21432 0.003,0.005 0.003,0.0132 0.005,0.0185 -0.0582,0.0767 -0.14023,0.17462 -0.20638,0.28046 -0.0662,0.10847 -0.12171,0.22225 -0.16404,0.34131 -0.45773,1.24089 -0.82286,2.50825 -1.01336,3.82058 -0.09,0.61913 0.0794,1.15358 0.51594,1.60073 0.46038,0.47096 0.99748,0.84138 1.56898,1.16417 0.29633,0.16668 0.61383,0.19314 0.93663,0.0767 0.59531,-0.21167 1.143,-0.50271 1.61131,-0.93134 0.23548,-0.21696 0.4101,-0.20902 0.67469,-0.0212 0.30691,0.2196 0.62177,0.43127 0.9472,0.62706 0.40217,0.24077 0.81228,0.22225 1.21709,-0.0159 0.76464,-0.44979 1.32291,-1.0795 1.67746,-1.89177 0.18256,-0.41804 0.2196,-0.8546 0.11112,-1.2991 -0.26194,-1.06627 -0.73554,-2.03465 -1.3335,-2.94217 z m 0.72761,4.1275 c -0.3175,0.67469 -0.7964,1.19856 -1.43934,1.57692 -0.24077,0.14287 -0.47889,0.15875 -0.71437,0.0106 -0.27517,-0.16933 -0.5424,-0.34925 -0.81227,-0.52652 -0.16934,-0.11112 -0.33867,-0.2196 -0.52652,-0.34396 0,-0.2196 0.0159,-0.4736 -0.003,-0.72496 -0.0291,-0.34925 -0.0794,-0.69585 -0.12965,-1.0451 -0.0265,-0.17198 -0.15081,-0.26458 -0.28839,-0.23812 -0.15081,0.0291 -0.22225,0.15875 -0.19579,0.33866 0.045,0.32544 0.0979,0.65352 0.12435,0.98161 0.0185,0.22225 -0.008,0.44979 -0.0106,0.67204 0,0.0714 -0.0344,0.11112 -0.0952,0.14816 -0.09,0.0529 -0.17463,0.11642 -0.254,0.18521 -0.41804,0.37571 -0.90223,0.64029 -1.4314,0.82815 -0.19579,0.0714 -0.38629,0.0582 -0.56621,-0.0476 -0.51064,-0.29898 -0.99483,-0.63235 -1.41816,-1.05039 -0.3519,-0.34925 -0.47096,-0.76465 -0.39423,-1.25148 0.1905,-1.21179 0.51593,-2.38654 0.93398,-3.53483 0.0318,-0.0847 0.0609,-0.17198 0.10054,-0.254 0.17991,-0.36778 0.47889,-0.57944 0.87577,-0.65353 0.55827,-0.10583 1.12448,-0.17197 1.69333,-0.19843 0.6694,-0.0318 1.3335,0.0238 1.98967,0.15346 0.46567,0.0926 0.85989,0.3175 1.14035,0.70379 0.68792,0.9525 1.22767,1.97908 1.53459,3.11943 0.10054,0.40482 0.0609,0.78053 -0.11377,1.15094 z"
                    id="path715"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('26')"
                    d="m 159.55392,131.42786 c 0,-0.2196 0.0159,-0.4736 -0.003,-0.72496 -0.0291,-0.34925 -0.0794,-0.69585 -0.12964,-1.0451 -0.0265,-0.17198 -0.15081,-0.26458 -0.2884,-0.23812 -0.15081,0.0291 -0.22225,0.15875 -0.19579,0.33866 0.045,0.32544 0.0979,0.65352 0.12435,0.98161 0.0185,0.22225 -0.008,0.44979 -0.0106,0.67204 0,0.0714 -0.0344,0.11112 -0.0952,0.14816 -0.09,0.0529 -0.17462,0.11642 -0.254,0.18521 -0.41804,0.37571 -0.90223,0.64029 -1.43139,0.82815 -0.1958,0.0714 -0.3863,0.0582 -0.56621,-0.0476 -0.51065,-0.29898 -0.99484,-0.63235 -1.41817,-1.05039 -0.3519,-0.34925 -0.47096,-0.76465 -0.39423,-1.25148 0.1905,-1.21179 0.51594,-2.38654 0.93398,-3.53483 0.0317,-0.0847 0.0608,-0.17198 0.10054,-0.254 0.17992,-0.36778 0.4789,-0.57944 0.87577,-0.65353 0.55827,-0.10583 1.12448,-0.17197 1.69334,-0.19843 0.66939,-0.0318 1.3335,0.0238 1.98966,0.15346 0.46567,0.0926 0.8599,0.3175 1.14036,0.70379 0.68791,0.9525 1.22766,1.97908 1.53458,3.11943 0.10848,0.39953 0.0661,0.77523 -0.10848,1.14565 -0.3175,0.67469 -0.79639,1.19856 -1.43933,1.57692 -0.24077,0.14287 -0.4789,0.15875 -0.71438,0.0106 -0.27516,-0.16933 -0.54239,-0.34925 -0.81227,-0.52652 -0.17462,-0.10319 -0.34396,-0.21431 -0.53181,-0.33867 z"
                    id="path747"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('26')"
                    id="text812"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="156.61414"
                    y="122"
                  >
                    26
                  </text>
                </g>
                <g id="g104">
                  <path
                    [attr.fill]="getTextColorForVisual('35')"
                    d="m 152.08738,141.56405 c -0.25665,-0.15081 -0.52652,-0.26458 -0.81492,-0.33867 -0.31485,-0.0794 -0.57944,-0.24077 -0.82021,-0.45508 -0.19314,-0.17198 -0.39952,-0.33338 -0.61118,-0.48154 -0.46832,-0.33073 -0.93663,-0.3175 -1.40759,0.005 -0.64294,0.43921 -1.21444,0.95515 -1.74889,1.51606 -0.28575,0.29898 -0.39159,0.66411 -0.32809,1.06892 0.21432,1.38906 0.50271,2.76225 0.94457,4.10104 0.008,0.0212 0.008,0.0423 0.0106,0.0661 0.0635,0.0741 0.12435,0.15081 0.17727,0.23548 0.008,0.0106 0.008,0.0159 0.0106,0.0212 0.0132,0.008 0.0238,0.0132 0.045,0.0265 0.14552,0.0873 0.254,0.19315 0.32809,0.30956 0,-0.0106 0,-0.0185 0,-0.0291 0.95514,0.43921 1.90764,0.59002 2.90247,0.15081 0.0159,-0.0159 0.0291,-0.0318 0.045,-0.0476 0.0609,-0.0582 0.127,-0.10848 0.19315,-0.1614 0.045,-0.037 0.31221,-0.24342 0.24871,-0.19315 0.0503,-0.0397 0.10054,-0.082 0.15081,-0.12435 0.0132,-0.0106 0.0185,-0.0159 0.0291,-0.0212 0.003,-0.003 0.003,-0.008 0.005,-0.0106 0.0106,-0.0159 0.0212,-0.0238 0.0317,-0.0397 0.0106,-0.10583 0.0265,-0.20637 0.0635,-0.29898 0.38893,-0.92339 0.65881,-1.88118 0.81756,-2.87073 0.0847,-0.53445 0.13758,-1.07156 0.18521,-1.61131 0.0318,-0.36777 -0.14552,-0.635 -0.45773,-0.81756 z m -0.40217,3.2729 c -0.14817,0.62177 -0.35454,1.22502 -0.59796,1.81768 -0.21166,0.51594 -0.59266,0.78052 -1.13241,0.84932 -0.6403,0.082 -1.24355,-0.0423 -1.81505,-0.33338 -0.23283,-0.11906 -0.36777,-0.31221 -0.44185,-0.56092 -0.25135,-0.84137 -0.46831,-1.69068 -0.63235,-2.55323 -0.082,-0.42862 -0.14817,-0.85725 -0.21696,-1.28587 -0.0397,-0.23813 0.0344,-0.44715 0.19844,-0.61913 0.49477,-0.51858 1.02129,-1.00277 1.6166,-1.41022 0.0582,-0.0397 0.11642,-0.0767 0.17727,-0.11378 0.20638,-0.11906 0.41804,-0.1217 0.61913,0.005 0.17727,0.11112 0.34925,0.23548 0.51329,0.36777 0.15875,0.127 0.30427,0.26723 0.47096,0.41539 -0.005,0.0556 -0.005,0.127 -0.0238,0.19315 -0.10054,0.35719 -0.20902,0.71437 -0.31485,1.06892 -0.005,0.0212 -0.0159,0.0397 -0.0238,0.0582 -0.0503,0.15082 0.003,0.28311 0.12964,0.33338 0.12965,0.0503 0.26194,0 0.32544,-0.14817 0.0741,-0.16669 0.14287,-0.33602 0.19315,-0.51064 0.0741,-0.24871 0.13229,-0.50007 0.19843,-0.75936 0.30957,0.0582 0.60061,0.16669 0.87842,0.32015 0.17992,0.10054 0.25665,0.24077 0.24342,0.44714 -0.0556,0.82021 -0.17463,1.62455 -0.36513,2.4183 z"
                    id="path712"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('35')"
                    d="m 150.44432,141.41588 c -0.005,0.0556 -0.005,0.127 -0.0238,0.19315 -0.10318,0.35719 -0.20902,0.71437 -0.31485,1.06892 -0.005,0.0212 -0.0159,0.0397 -0.0238,0.0582 -0.0503,0.15082 0.003,0.28311 0.12964,0.33338 0.12965,0.0503 0.26194,0 0.32544,-0.14817 0.0741,-0.16669 0.14287,-0.33602 0.19315,-0.51064 0.0741,-0.24871 0.13229,-0.50007 0.19843,-0.75936 0.30957,0.0582 0.60061,0.16669 0.87842,0.32015 0.17992,0.10054 0.25665,0.24077 0.24342,0.44714 -0.0582,0.81492 -0.17727,1.61925 -0.36777,2.413 -0.14817,0.62177 -0.35455,1.22502 -0.59796,1.81769 -0.21167,0.51594 -0.59267,0.78052 -1.13242,0.84931 -0.64029,0.082 -1.24354,-0.0423 -1.81504,-0.33337 -0.23283,-0.11906 -0.36777,-0.31221 -0.44186,-0.56092 -0.25135,-0.84137 -0.46831,-1.69069 -0.63235,-2.55323 -0.082,-0.42862 -0.14817,-0.85725 -0.21696,-1.28587 -0.0397,-0.23813 0.0344,-0.44715 0.19844,-0.61913 0.49477,-0.51858 1.02129,-1.00277 1.6166,-1.41023 0.0582,-0.0397 0.11642,-0.0767 0.17727,-0.11377 0.20638,-0.11906 0.41805,-0.12171 0.61913,0.005 0.17727,0.11113 0.34925,0.23548 0.51329,0.36778 0.1614,0.13229 0.30692,0.27516 0.47361,0.42068 z"
                    id="path744"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('35')"
                    id="text813"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="147.67307"
                    y="153.5"
                  >
                    35
                  </text>
                </g>
                <g id="g105">
                  <path
                    [attr.fill]="getTextColorForVisual('34')"
                    d="m 143.4355,147.01711 c 0.005,-0.003 0.0132,-0.003 0.0397,-0.005 0,0.005 0,0.0106 0,0.0185 0.13229,-0.28046 0.3175,-0.5371 0.57415,-0.75406 0.0238,-0.13229 0.0608,-0.26194 0.127,-0.38894 0.0264,-0.0476 0.0397,-0.10583 0.0503,-0.16139 0.09,-0.46832 0.19579,-0.93398 0.25929,-1.40759 0.0873,-0.64558 0.14023,-1.2991 0.20902,-1.94733 -0.005,0 -0.0132,-0.003 -0.0185,-0.003 0.005,-0.09 0.0106,-0.18256 0.0185,-0.27252 0.0291,-0.40216 -0.14817,-0.68527 -0.50271,-0.87312 -0.33867,-0.17992 -0.69056,-0.3175 -1.06892,-0.36777 -0.23812,-0.0318 -0.44185,-0.11907 -0.64293,-0.24342 -0.3519,-0.2196 -0.73554,-0.3466 -1.15359,-0.35454 -0.49477,-0.0106 -0.94191,0.15346 -1.33614,0.44185 -0.32544,0.23813 -0.66146,0.4445 -1.02394,0.62177 -0.49742,0.24077 -0.73554,0.77259 -0.6006,1.30969 0.14287,0.5715 0.29633,1.143 0.47095,1.70392 0.20373,0.65616 0.43128,1.30704 0.80698,1.89441 0.0132,0.0185 0.0159,0.045 0.0212,0.0688 0.18256,0.14816 0.33867,0.29633 0.45773,0.48947 0.082,0.0503 0.15346,0.11642 0.21431,0.18786 0.0212,0.0132 0.0397,0.0265 0.0582,0.0397 0.37306,0.27252 0.77788,0.47095 1.2409,0.54239 0.61118,0.0952 1.15093,-0.0767 1.6457,-0.42862 0.0529,-0.037 0.10319,-0.0741 0.15346,-0.11113 z m -0.83079,-0.0714 c -0.6006,0.26723 -1.16946,0.13494 -1.70656,-0.19314 -0.48683,-0.29898 -0.84402,-0.71438 -1.08215,-1.23296 -0.36512,-0.79375 -0.61912,-1.62719 -0.84137,-2.47121 -0.0397,-0.14816 -0.0741,-0.29898 -0.11113,-0.44979 -0.10318,-0.43921 0.0344,-0.71437 0.4445,-0.90223 0.0503,-0.0238 0.10054,-0.0423 0.16934,-0.0714 0.005,0.59532 0.10318,1.14565 0.28575,1.68011 0.0529,0.1561 0.17462,0.2196 0.30956,0.17991 0.13229,-0.0397 0.19314,-0.16139 0.15875,-0.32279 -0.0767,-0.36248 -0.15875,-0.72496 -0.23548,-1.09008 -0.0132,-0.0688 -0.0238,-0.14023 -0.0185,-0.20902 0.008,-0.17463 -0.0476,-0.30427 -0.24871,-0.35983 0.39952,-0.2884 0.74613,-0.61648 1.23031,-0.72232 0.51065,-0.11112 0.95779,0.0423 1.37319,0.32544 0.045,0.0291 0.0661,0.11906 0.0688,0.18256 0.0159,0.5424 -0.0397,1.0795 -0.16404,1.60867 -0.0132,0.0609 -0.0344,0.12435 -0.037,0.18521 -0.008,0.12964 0.0635,0.22225 0.17727,0.25135 0.12965,0.0317 0.24342,-0.0185 0.29104,-0.14552 0.0397,-0.11112 0.0662,-0.23019 0.09,-0.3466 0.09,-0.44186 0.14287,-0.88636 0.14023,-1.33879 0,-0.0476 0.005,-0.0979 0.008,-0.15611 0.0476,-0.003 0.0873,-0.0106 0.127,-0.005 0.35983,0.0529 0.6932,0.17727 1.00277,0.36248 0.127,0.0767 0.17727,0.1905 0.16668,0.33867 -0.0344,0.46831 -0.0556,0.93927 -0.10054,1.40758 -0.0661,0.69321 -0.16668,1.38112 -0.32808,2.05846 -0.16404,0.66675 -0.5424,1.15887 -1.16946,1.43668 z"
                    id="path726"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('34')"
                    d="m 139.47998,141.6302 c 0.005,0.59531 0.10319,1.14564 0.28575,1.6801 0.0529,0.1561 0.17463,0.2196 0.30956,0.17992 0.1323,-0.0397 0.19315,-0.1614 0.15875,-0.3228 -0.0767,-0.36247 -0.15875,-0.72495 -0.23547,-1.09008 -0.0132,-0.0688 -0.0238,-0.14023 -0.0185,-0.20902 0.008,-0.17462 -0.0476,-0.30427 -0.2487,-0.35983 0.39952,-0.2884 0.74612,-0.61648 1.23031,-0.72232 0.51064,-0.11112 0.95779,0.0423 1.37319,0.32544 0.045,0.0291 0.0661,0.11906 0.0688,0.18256 0.0159,0.5424 -0.0397,1.0795 -0.16404,1.60867 -0.0132,0.0609 -0.0344,0.12436 -0.037,0.18521 -0.008,0.12965 0.0635,0.22225 0.17728,0.25135 0.12964,0.0317 0.24341,-0.0185 0.29104,-0.14552 0.0397,-0.11112 0.0661,-0.23018 0.09,-0.3466 0.09,-0.44186 0.14287,-0.88636 0.14022,-1.33879 0,-0.0476 0.005,-0.0979 0.008,-0.15611 0.0476,-0.003 0.0873,-0.0106 0.127,-0.005 0.35984,0.0529 0.69321,0.17727 1.00277,0.36248 0.127,0.0767 0.17727,0.1905 0.16669,0.33867 -0.0344,0.46831 -0.0556,0.93927 -0.10054,1.40758 -0.0661,0.69321 -0.16669,1.38113 -0.32808,2.05846 -0.15875,0.6641 -0.53711,1.15623 -1.16417,1.43404 -0.60061,0.26723 -1.16946,0.13494 -1.70656,-0.19315 -0.48684,-0.29897 -0.84402,-0.71437 -1.08215,-1.23295 -0.36512,-0.79375 -0.61912,-1.62719 -0.84137,-2.47121 -0.0397,-0.14817 -0.0741,-0.29898 -0.11113,-0.44979 -0.10319,-0.43921 0.0344,-0.71438 0.4445,-0.90223 0.045,-0.0212 0.0952,-0.0423 0.16404,-0.0688 z"
                    id="path758"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('34')"
                    id="text814"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="140.35414"
                    y="153.5"
                  >
                    34
                  </text>
                </g>
                <g id="g106">
                  <path
                    [attr.fill]="getTextColorForVisual('33')"
                    d="m 131.61657,145.87147 c 0.0556,0.15081 0.10847,0.30162 0.12964,0.45773 0.23019,0.42597 0.47096,0.84137 0.66146,1.28322 -0.005,-0.0344 -0.0106,-0.0635 -0.0159,-0.0979 0.47361,0.49742 1.00013,0.78317 1.651,0.74612 0.63236,-0.0344 1.09538,-0.37835 1.49225,-0.88106 0.0926,-0.18256 0.21432,-0.35189 0.35719,-0.51858 0.0609,-0.254 0.127,-0.50006 0.24871,-0.73025 0.003,-0.13494 0.0106,-0.26988 0.0503,-0.40217 0.26723,-0.90752 0.40481,-1.83621 0.48948,-2.77548 0.0185,-0.21696 -0.0132,-0.42069 -0.14817,-0.59796 -0.64823,-0.85195 -1.39964,-1.59279 -2.29393,-2.18545 -0.22225,-0.14817 -0.44186,-0.1614 -0.67469,-0.0291 -0.0556,0.0317 -0.10848,0.0661 -0.16404,0.0979 -0.73554,0.42598 -1.37584,0.97102 -1.97379,1.56898 -0.1614,0.16139 -0.29898,0.35454 -0.43392,0.54239 -0.11113,0.15346 -0.15081,0.33338 -0.11906,0.52123 0.17991,1.016 0.39158,2.02671 0.74348,3.00038 z m -0.16669,-3.31523 c 0.0926,-0.11377 0.17198,-0.24077 0.27516,-0.34396 0.6059,-0.60854 1.25413,-1.16681 2.00555,-1.59279 0.0476,-0.0265 0.0979,-0.0503 0.17462,-0.09 0.29369,0.22754 0.60325,0.44979 0.889,0.69321 0.47625,0.40746 0.89958,0.86783 1.28588,1.3626 0.0794,0.10054 0.11112,0.20108 0.10054,0.33073 -0.10848,1.30175 -0.3519,2.57175 -0.84667,3.78619 -0.10848,0.26458 -0.26723,0.49212 -0.47625,0.68527 -0.50006,0.45508 -1.13506,0.508 -1.70392,0.13758 -0.29368,-0.1905 -0.50535,-0.44979 -0.63764,-0.76464 -0.20108,-0.48419 -0.40481,-0.97102 -0.5715,-1.46844 -0.26723,-0.78581 -0.42333,-1.60073 -0.56886,-2.41565 -0.0185,-0.12171 0,-0.22489 0.0741,-0.32014 z"
                    id="path714"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('33')"
                    d="m 133.90786,140.52953 c 0.29368,0.22754 0.60325,0.44979 0.889,0.69321 0.47625,0.40746 0.89958,0.86783 1.28587,1.3626 0.0794,0.10054 0.11113,0.20108 0.10054,0.33073 -0.10848,1.30175 -0.35189,2.57175 -0.84666,3.78619 -0.10848,0.26458 -0.26723,0.49212 -0.47625,0.68527 -0.50007,0.45508 -1.13507,0.508 -1.70392,0.13758 -0.29369,-0.1905 -0.50535,-0.44979 -0.63765,-0.76464 -0.20108,-0.48419 -0.40481,-0.97102 -0.5715,-1.46844 -0.26722,-0.78581 -0.42333,-1.60073 -0.56885,-2.41565 -0.0212,-0.11906 -0.003,-0.22225 0.0741,-0.31485 0.0926,-0.11377 0.17198,-0.24077 0.27517,-0.34396 0.6059,-0.60854 1.25413,-1.16681 2.00554,-1.59279 0.0476,-0.0344 0.0979,-0.0582 0.17463,-0.0952 z m -0.9234,2.85221 c 0.0423,0.54504 0.0714,1.09802 0.127,1.651 0.0344,0.34131 0.10583,0.67733 0.17198,1.016 0.0397,0.20637 0.15346,0.28575 0.32015,0.24606 0.15081,-0.037 0.20373,-0.15081 0.16668,-0.35454 -0.0159,-0.09 -0.037,-0.17727 -0.0556,-0.26723 -0.21696,-1.12977 -0.26458,-2.26748 -0.16139,-3.41313 0.0212,-0.23018 0.0503,-0.46037 0.0661,-0.69056 0.0106,-0.15081 -0.0767,-0.25135 -0.20902,-0.26458 -0.13758,-0.0159 -0.23548,0.0582 -0.26987,0.20637 -0.0132,0.0556 -0.0238,0.11113 -0.0265,0.16669 -0.0476,0.56092 -0.0873,1.12713 -0.12965,1.70392 z"
                    id="path746"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('33')"
                    d="m 132.98446,143.38174 c 0.0423,-0.57679 0.0847,-1.143 0.127,-1.70921 0.005,-0.0556 0.0159,-0.11113 0.0265,-0.16669 0.0344,-0.14552 0.13229,-0.2196 0.26987,-0.20637 0.1323,0.0132 0.21961,0.11377 0.20903,0.26458 -0.0159,0.23019 -0.045,0.46037 -0.0661,0.69056 -0.10054,1.14565 -0.0556,2.28336 0.1614,3.41313 0.0159,0.09 0.0397,0.17727 0.0556,0.26723 0.037,0.20373 -0.0185,0.3175 -0.16669,0.35454 -0.16404,0.0397 -0.28046,-0.0423 -0.32015,-0.24606 -0.0635,-0.33603 -0.13493,-0.67469 -0.17197,-1.016 -0.0556,-0.54769 -0.0847,-1.10067 -0.12436,-1.64571 z"
                    id="path775"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('33')"
                    id="text815"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="132.813"
                    y="153.5"
                  >
                    33
                  </text>
                </g>
                <g id="g107">
                  <path
                    [attr.fill]="getTextColorForVisual('32')"
                    d="m 127.83832,147.48278 c 0.0106,0.003 0.0238,0.005 0.0344,0.008 0.082,-0.11377 0.16669,-0.2249 0.24606,-0.33867 0.0317,-0.0767 0.0714,-0.14817 0.12965,-0.20902 0.0503,-0.11113 0.0979,-0.2249 0.127,-0.35983 0.0185,-0.0767 0.0423,-0.14553 0.0714,-0.20903 0.005,-0.0529 0.008,-0.10847 0.0106,-0.16139 0.003,-0.0476 0.0159,-0.0979 0.0318,-0.14288 0.26194,-0.71437 0.44715,-1.44727 0.57679,-2.19604 0.15081,-0.86254 0.20109,-1.72773 0.10848,-2.60085 -0.0423,-0.39688 -0.33073,-0.69586 -0.72496,-0.72496 -0.51858,-0.037 -1.03716,-0.0608 -1.41023,-0.082 -0.93927,0.0185 -1.73302,0.0582 -2.51883,0.16933 -0.43921,0.0609 -0.72496,0.37571 -0.71967,0.82021 0.005,0.42069 0.0318,0.84138 0.0556,1.26206 0.0503,0.97632 0.21431,1.9394 0.40481,2.89719 0.0397,0.19844 0.10848,0.39423 0.10848,0.59531 0.037,0.0741 0.0688,0.15082 0.0873,0.24342 0.0132,0.0688 0.0185,0.14023 0.0291,0.20902 0.0635,0.1561 0.12436,0.31221 0.1905,0.46567 0.0291,0.0661 0.0132,0.003 0.0529,0.11377 0.0212,0.0291 0.045,0.0609 0.0661,0.09 0.0159,0.0185 0.0265,0.0317 0.0291,0.0397 0.0318,0.045 0.0635,0.0873 0.09,0.12965 0,-0.0317 0,-0.0608 0,-0.10054 0.0582,0.0794 0.0873,0.12171 0.11642,0.16404 0.11641,0.15875 0.21695,0.33073 0.35189,0.47096 0.55034,0.5715 1.30175,0.61383 1.91029,0.10319 0.15875,-0.1323 0.28311,-0.30957 0.42069,-0.46832 0.0503,-0.0556 0.0847,-0.12435 0.12436,-0.18785 z m -1.00278,0.37571 c -0.36512,0.2196 -0.68527,0.17991 -1.00806,-0.0873 -0.11112,-0.0926 -0.20373,-0.21166 -0.28575,-0.33602 -0.46302,-0.70379 -0.74083,-1.47902 -0.87048,-2.30716 -0.10318,-0.64559 -0.20902,-1.28852 -0.27781,-1.93675 -0.0609,-0.55827 -0.0767,-1.11919 -0.10054,-1.68011 -0.0106,-0.24341 0.0847,-0.34925 0.32014,-0.38364 0.75936,-0.11377 1.52136,-0.15611 2.48973,-0.16404 0.26723,0.0159 0.73819,0.0344 1.2065,0.0688 0.2884,0.0212 0.3519,0.09 0.38365,0.37306 0.0529,0.47625 0.0529,0.9525 0.0106,1.42875 -0.11112,1.23031 -0.38364,2.42623 -0.88635,3.55865 -0.14817,0.33337 -0.32544,0.65352 -0.50006,0.97366 -0.11113,0.20902 -0.27782,0.37042 -0.48155,0.49213 z"
                    id="path737"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('32')"
                    d="m 127.10277,140.96345 c 0.26723,0.0159 0.73819,0.0344 1.2065,0.0688 0.2884,0.0212 0.3519,0.09 0.38365,0.37306 0.0529,0.47625 0.0556,0.95515 0.0106,1.42875 -0.11112,1.23031 -0.38364,2.42623 -0.88635,3.55865 -0.14817,0.33337 -0.32544,0.65352 -0.50006,0.97366 -0.11377,0.20638 -0.27782,0.36777 -0.48155,0.48948 -0.36512,0.21961 -0.68527,0.17992 -1.00806,-0.0873 -0.11112,-0.0926 -0.20373,-0.21167 -0.28575,-0.33602 -0.46302,-0.70379 -0.74083,-1.47902 -0.87048,-2.30717 -0.10318,-0.64558 -0.20902,-1.28852 -0.27781,-1.93675 -0.0609,-0.55827 -0.0767,-1.11919 -0.10054,-1.6801 -0.0106,-0.24342 0.0847,-0.34925 0.32014,-0.38365 0.75936,-0.11112 1.52136,-0.15346 2.48973,-0.16139 z m 0.60855,1.82827 c 0,-0.15346 0.0106,-0.30957 -0.003,-0.46302 -0.0132,-0.13494 -0.12435,-0.20638 -0.254,-0.19844 -0.12171,0.008 -0.20638,0.0873 -0.22225,0.21431 -0.005,0.0423 -0.003,0.0847 -0.003,0.127 0.0132,0.50271 -0.0503,0.99483 -0.17991,1.47902 -0.0132,0.0476 -0.0238,0.0952 -0.0238,0.14552 0,0.11642 0.0688,0.20373 0.17728,0.23284 0.10318,0.0265 0.2196,-0.0159 0.27252,-0.10848 0.0238,-0.0423 0.037,-0.09 0.0503,-0.13759 0.11641,-0.42598 0.18256,-0.8546 0.18521,-1.29116 z m -2.56911,-0.58738 c -0.005,0 -0.0106,0.003 -0.0159,0.003 0.0423,0.36777 0.0794,0.73818 0.127,1.10596 0.0106,0.0714 0.0476,0.14816 0.0979,0.19843 0.0741,0.0741 0.17463,0.0794 0.27252,0.0238 0.0979,-0.0582 0.14288,-0.15082 0.11907,-0.2884 -0.09,-0.52123 -0.1323,-1.04246 -0.0794,-1.56898 0.0159,-0.17727 -0.0688,-0.2884 -0.21431,-0.30692 -0.1614,-0.0185 -0.26459,0.0767 -0.27781,0.26723 -0.0132,0.18786 -0.0185,0.37836 -0.0291,0.56621 z"
                    id="path770"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('32')"
                    d="m 127.71132,142.79172 c -0.003,0.43656 -0.0688,0.86518 -0.18257,1.28852 -0.0132,0.0476 -0.0265,0.0952 -0.0503,0.13758 -0.0556,0.0926 -0.16933,0.13758 -0.27252,0.10848 -0.10583,-0.0291 -0.17727,-0.11642 -0.17727,-0.23283 0,-0.0476 0.0106,-0.0979 0.0238,-0.14552 0.127,-0.48419 0.19315,-0.97632 0.17992,-1.47903 0,-0.0423 -0.003,-0.0847 0.003,-0.127 0.0159,-0.12435 0.10054,-0.20372 0.22225,-0.21431 0.12964,-0.0106 0.24077,0.0635 0.254,0.19844 0.0106,0.1561 0,0.31221 0,0.46567 z"
                    id="path785"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('32')"
                    d="m 125.14221,142.20434 c 0.008,-0.18785 0.0132,-0.37835 0.0265,-0.56621 0.0132,-0.18785 0.11642,-0.2831 0.27781,-0.26723 0.14552,0.0159 0.23019,0.12965 0.21431,0.30692 -0.0503,0.52652 -0.0106,1.0504 0.0794,1.56898 0.0238,0.13758 -0.0185,0.23283 -0.11906,0.2884 -0.0979,0.0556 -0.19844,0.0503 -0.27252,-0.0238 -0.0503,-0.0503 -0.0873,-0.12964 -0.0979,-0.19843 -0.0476,-0.36778 -0.0847,-0.73819 -0.127,-1.10596 0.008,0 0.0132,0 0.0185,-0.003 z"
                    id="path786"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('32')"
                    id="text816"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="125.00521"
                    y="153.5"
                  >
                    32
                  </text>
                </g>
                <g id="g108">
                  <path
                    [attr.fill]="getTextColorForVisual('31')"
                    d="m 120.39559,147.98284 c 0.11112,-0.11377 0.19579,-0.254 0.29104,-0.38629 0.0344,-0.045 0.0661,-0.0926 0.11906,-0.127 0.0979,-0.21431 0.17727,-0.44185 0.29633,-0.64558 0.0423,-0.0688 0.09,-0.1323 0.13494,-0.19844 0.0423,-0.10319 0.09,-0.20638 0.13758,-0.30692 0.003,-0.0344 0.003,-0.0688 0.005,-0.10319 0.003,-0.0476 0.0159,-0.0952 0.0344,-0.14022 0.37042,-1.00807 0.60061,-2.04788 0.70115,-3.11415 0.0529,-0.57415 0.0582,-1.15094 -0.0185,-1.72508 -0.0529,-0.38365 -0.33073,-0.66146 -0.71173,-0.68792 -0.52388,-0.0397 -1.0504,-0.0608 -1.57692,-0.0926 0,0.008 0,0.0159 0,0.0264 -0.15346,0 -0.30956,-0.0106 -0.46302,0.003 -0.63765,0.0476 -1.27529,0.0979 -1.91029,0.1561 -0.19315,0.0185 -0.35983,0.10848 -0.49477,0.254 -0.15081,0.16405 -0.22225,0.35455 -0.21167,0.5768 0.0265,0.53975 0.0476,1.0795 0.0873,1.61925 0.0714,0.97631 0.23548,1.93675 0.46303,2.8866 0.0132,0.0608 0.0212,0.12171 0.0212,0.18521 0,0.0397 -0.003,0.0767 -0.005,0.11641 0.0714,0.11642 0.13229,0.24342 0.18256,0.37307 0.0238,0.0608 0.0503,0.127 0.0767,0.19314 0.0238,0.0397 0.0476,0.0794 0.0714,0.11907 0.0582,0.0952 0.11906,0.18785 0.16669,0.28839 0.0291,0.0609 0.0529,0.11906 0.0741,0.17727 0.003,0 0.003,0 0.005,0 0.082,0.12965 0.1614,0.26194 0.25136,0.38629 0.2487,0.3519 0.57414,0.59796 1.0107,0.66146 0.51065,0.0741 0.91546,-0.14552 1.26207,-0.49477 z m -1.73832,-0.31221 c -0.21166,-0.23812 -0.36777,-0.52916 -0.51593,-0.81491 -0.29369,-0.5715 -0.46567,-1.18798 -0.55827,-1.82298 -0.0979,-0.66675 -0.20373,-1.33086 -0.27517,-2.00025 -0.0529,-0.50271 -0.0662,-1.00807 -0.0847,-1.51342 -0.0106,-0.26194 0.0767,-0.3519 0.33602,-0.39158 0.17198,-0.0265 0.34661,-0.0556 0.52123,-0.0661 0.58209,-0.0423 1.16152,-0.0767 1.6854,-0.10848 0.52916,0.0291 1.00012,0.0476 1.46844,0.082 0.29633,0.0238 0.36777,0.11642 0.39422,0.41275 0.11113,1.16946 -0.0661,2.30982 -0.35454,3.43694 -0.20902,0.82021 -0.51858,1.60073 -0.93662,2.33892 -0.11906,0.20902 -0.24871,0.40746 -0.4445,0.55562 -0.43921,0.32015 -0.8599,0.31221 -1.23561,-0.10848 z"
                    id="path734"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('31')"
                    d="m 119.76323,140.94757 c 0.52917,0.0291 1.00013,0.0476 1.46844,0.082 0.29633,0.0238 0.36777,0.11642 0.39423,0.41275 0.11112,1.16946 -0.0662,2.30981 -0.35454,3.43694 -0.20902,0.82021 -0.51859,1.60073 -0.93663,2.33892 -0.11906,0.20902 -0.24871,0.40745 -0.4445,0.55562 -0.43656,0.32544 -0.85725,0.32015 -1.2356,-0.10319 -0.21167,-0.23812 -0.36777,-0.52916 -0.51594,-0.81491 -0.29369,-0.5715 -0.46567,-1.18798 -0.56092,-1.82298 -0.0979,-0.66675 -0.20372,-1.33086 -0.27516,-2.00025 -0.0529,-0.50271 -0.0662,-1.00807 -0.0847,-1.51342 -0.0106,-0.26194 0.0767,-0.3519 0.33602,-0.39158 0.17198,-0.0265 0.34661,-0.0556 0.52123,-0.0661 0.58208,-0.045 1.16417,-0.0794 1.68804,-0.11377 z m 0.88636,1.7436 c 0,-0.0899 0.003,-0.18256 0,-0.27252 -0.008,-0.18785 -0.10848,-0.29368 -0.26194,-0.28575 -0.14552,0.008 -0.24077,0.11642 -0.23283,0.29369 0.0238,0.53181 -0.0503,1.0504 -0.18257,1.56104 -0.045,0.17198 0.0159,0.29369 0.15611,0.33602 0.14023,0.0423 0.26458,-0.0344 0.3175,-0.19843 0.0159,-0.0529 0.0291,-0.10848 0.0423,-0.16405 0.10054,-0.41539 0.1561,-0.83872 0.1614,-1.27 z m -2.1008,-0.52122 c 0.0132,0 0.0265,0 0.0371,-0.003 0,-0.18785 0.005,-0.37835 -0.003,-0.56621 -0.005,-0.127 -0.09,-0.21167 -0.20637,-0.22754 -0.12965,-0.0185 -0.23284,0.0476 -0.26988,0.17727 -0.0132,0.045 -0.0185,0.0953 -0.0212,0.14552 -0.0318,0.53446 -0.008,1.06363 0.082,1.59015 0.008,0.0423 0.0159,0.0847 0.0291,0.12171 0.0476,0.11641 0.15346,0.17991 0.26458,0.16139 0.12436,-0.0212 0.20373,-0.11642 0.20373,-0.254 0,-0.0476 -0.0106,-0.0979 -0.0159,-0.14552 -0.0291,-0.33337 -0.0661,-0.66675 -0.10055,-1.00012 z"
                    id="path767"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('31')"
                    d="m 120.64959,142.69117 c -0.005,0.42863 -0.0609,0.85461 -0.16405,1.27 -0.0132,0.0556 -0.0238,0.10848 -0.0423,0.16405 -0.0529,0.16139 -0.17727,0.23812 -0.3175,0.19843 -0.14023,-0.0423 -0.20108,-0.16404 -0.1561,-0.33602 0.13493,-0.51329 0.20637,-1.03187 0.18256,-1.56104 -0.008,-0.17727 0.0873,-0.28575 0.23283,-0.29369 0.15611,-0.008 0.254,0.0979 0.26194,0.28575 0.005,0.09 0.003,0.18257 0.003,0.27252 z"
                    id="path779"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('31')"
                    d="m 118.54879,142.16995 c 0.0344,0.33337 0.0688,0.66675 0.10584,1.00277 0.005,0.0476 0.0159,0.0979 0.0159,0.14552 0,0.13493 -0.0794,0.23283 -0.20373,0.254 -0.11112,0.0185 -0.21695,-0.045 -0.26458,-0.1614 -0.0159,-0.0397 -0.0238,-0.0794 -0.0291,-0.12171 -0.09,-0.52652 -0.11377,-1.05833 -0.082,-1.59014 0.003,-0.0476 0.008,-0.0979 0.0212,-0.14552 0.0397,-0.12965 0.14288,-0.1958 0.26988,-0.17727 0.11641,0.0159 0.20108,0.10318 0.20637,0.22754 0.005,0.18785 0.003,0.37835 0.003,0.56621 -0.0159,-0.003 -0.0291,0 -0.0423,0 z"
                    id="path780"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('31')"
                    id="text817"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="117.46252"
                    y="153.5"
                  >
                    31
                  </text>
                </g>
                <g id="g101">
                  <path
                    [attr.fill]="getTextColorForVisual('38')"
                    d="m 175.83638,145.53545 c 0.10848,0.30956 0.23548,0.61647 0.37835,0.91281 0.0212,0.0476 0.037,0.09 0.045,0.13229 0.18786,0.0953 0.34396,0.22225 0.48419,0.37571 0.92604,0.28046 1.86267,0.33337 2.80987,0.29633 0.90752,-0.0344 1.79123,-0.2196 2.67759,-0.49212 0.0847,-0.0661 0.17462,-0.12436 0.26987,-0.17463 0.0106,-0.005 0.0238,-0.0132 0.0344,-0.0185 0.0159,-0.0185 0.0318,-0.0397 0.0476,-0.0582 0.0953,-0.10319 0.20638,-0.19314 0.32544,-0.27252 0.0661,-0.11377 0.127,-0.23019 0.16669,-0.35454 0.21696,-0.64029 0.34396,-1.3044 0.43127,-1.97379 0.0661,-0.50271 0.10848,-1.00542 0.0979,-1.51342 -0.005,-0.33602 -0.16139,-0.59796 -0.42333,-0.78581 -0.45773,-0.33073 -0.94456,-0.60854 -1.47902,-0.79904 -0.65617,-0.23548 -1.31498,-0.2884 -1.96321,0.0397 -0.18785,0.0952 -0.39423,0.0979 -0.59796,0.0582 -0.10318,-0.0185 -0.20108,-0.0635 -0.30162,-0.0926 -1.1139,-0.33338 -2.14048,-0.17992 -3.05858,0.55298 -0.51859,0.41539 -0.71438,0.96837 -0.60325,1.61396 0.15345,0.87048 0.36512,1.72243 0.65881,2.55323 z m 0.37041,-3.86292 c 0.75142,-0.53446 1.56369,-0.65088 2.44211,-0.39423 0.0873,0.0265 0.17462,0.0556 0.26194,0.082 0.35718,0.11113 0.71173,0.10583 1.0451,-0.0608 0.4789,-0.23813 0.96308,-0.21961 1.45256,-0.0635 0.53446,0.16933 1.01336,0.44979 1.46844,0.76729 0.17992,0.12435 0.26988,0.30691 0.25665,0.52652 -0.0609,1.09008 -0.19315,2.16694 -0.52917,3.21204 -0.0926,0.29104 -0.27781,0.47625 -0.5715,0.56621 -0.86254,0.26458 -1.74096,0.43392 -2.64583,0.46302 -0.10584,0.003 -0.20902,0.0106 -0.29105,0.0159 -0.635,-0.0212 -1.24089,-0.0688 -1.8415,-0.19579 -0.36247,-0.0767 -0.60325,-0.28046 -0.73554,-0.61912 -0.25929,-0.6694 -0.47096,-1.35202 -0.635,-2.04788 -0.0741,-0.30691 -0.13758,-0.61648 -0.20108,-0.92604 -0.11377,-0.55827 0.0609,-0.99483 0.52387,-1.32556 z"
                    id="path722"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('38')"
                    d="m 179.09604,146.78428 c -0.635,-0.0212 -1.24089,-0.0688 -1.8415,-0.19579 -0.36247,-0.0767 -0.60325,-0.28046 -0.73554,-0.61913 -0.25929,-0.66939 -0.47096,-1.35202 -0.635,-2.04787 -0.0741,-0.30692 -0.13758,-0.61648 -0.20108,-0.92604 -0.11377,-0.55298 0.0609,-0.98955 0.52387,-1.32028 0.75142,-0.53445 1.56369,-0.65087 2.44211,-0.39422 0.0873,0.0265 0.17462,0.0556 0.26194,0.082 0.35718,0.11112 0.71173,0.10583 1.0451,-0.0609 0.4789,-0.23812 0.96308,-0.2196 1.45256,-0.0635 0.53446,0.16934 1.01336,0.44979 1.46844,0.76729 0.17992,0.12436 0.26988,0.30692 0.25665,0.52652 -0.0609,1.09009 -0.19315,2.16694 -0.52917,3.21205 -0.0926,0.29104 -0.27781,0.47625 -0.5715,0.5662 -0.86254,0.26459 -1.74096,0.43392 -2.64583,0.46303 -0.10319,-0.003 -0.20902,0.005 -0.29105,0.0106 z m 0.0503,-3.98463 c 0.0212,0.17198 0.0608,0.47096 0.10054,0.76994 0.0132,0.10583 0.0661,0.18521 0.16933,0.21961 0.17992,0.0582 0.33602,-0.0714 0.3175,-0.27253 -0.0185,-0.18785 -0.0529,-0.3757 -0.0741,-0.56356 -0.0423,-0.38629 -0.045,-0.76994 0.11377,-1.13771 0.0423,-0.10054 0.0291,-0.19314 -0.0397,-0.27516 -0.0688,-0.0794 -0.15875,-0.082 -0.25135,-0.0662 -0.10055,0.0185 -0.14552,0.10054 -0.18257,0.18521 -0.14023,0.32544 -0.15875,0.66675 -0.15345,1.14035 z"
                    id="path754"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('38')"
                    d="m 179.14632,142.79965 c -0.003,-0.4736 0.0159,-0.81491 0.15081,-1.14035 0.037,-0.0873 0.082,-0.16669 0.18256,-0.18521 0.0926,-0.0159 0.18256,-0.0132 0.25135,0.0662 0.0714,0.082 0.082,0.17462 0.0397,0.27516 -0.15875,0.36777 -0.1561,0.75142 -0.11377,1.13771 0.0212,0.18786 0.0556,0.37571 0.0741,0.56356 0.0185,0.20109 -0.13493,0.33073 -0.3175,0.27253 -0.10318,-0.0344 -0.1561,-0.11378 -0.16933,-0.21961 -0.037,-0.29898 -0.0767,-0.59796 -0.0979,-0.76994 z"
                    id="path777"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('38')"
                    id="text818"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="177.40408"
                    y="153.5"
                  >
                    38
                  </text>
                </g>
                <g id="g102">
                  <path
                    [attr.fill]="getTextColorForVisual('37')"
                    d="m 169.42552,147.25259 c 0.94457,-0.037 1.86267,-0.23019 2.78871,-0.52123 0,0 0,0 0,0 0.0662,-0.0317 0.13494,-0.0608 0.21431,-0.0794 0.005,-0.003 0.005,-0.003 0.0106,-0.003 0.0132,-0.008 0.0238,-0.0132 0.037,-0.0212 0.0714,-0.0582 0.14552,-0.10583 0.22225,-0.14816 0,0 0,0 0,0 0.005,-0.0529 0.0212,-0.10584 0.045,-0.15611 0.0661,-0.14552 0.16139,-0.28045 0.21167,-0.43127 0.35718,-1.09802 0.50006,-2.23043 0.55297,-3.37873 0.0185,-0.36512 -0.13229,-0.67998 -0.43127,-0.89429 -0.52652,-0.37835 -1.08743,-0.69585 -1.71714,-0.87841 -0.58738,-0.17198 -1.16152,-0.17728 -1.72244,0.10583 -0.19579,0.10054 -0.40746,0.10319 -0.61912,0.0635 -0.0952,-0.0185 -0.18786,-0.0582 -0.28311,-0.0873 -1.10331,-0.33867 -2.1246,-0.19315 -3.04535,0.52387 -0.52123,0.40746 -0.74613,0.9525 -0.63765,1.60073 0.17727,1.05569 0.45508,2.08492 0.83608,3.08504 0.0556,0.14288 0.11642,0.2884 0.19844,0.4154 0.0397,0.0608 0.0556,0.11641 0.0556,0.17462 0.13494,0.0582 0.2593,0.13229 0.37042,0.23813 0.0265,0.0344 0.0529,0.0688 0.082,0.10319 0.003,-0.005 0.003,-0.0106 0.005,-0.0159 0.93398,0.2884 1.8759,0.34131 2.82575,0.30427 z m -3.01625,-1.25942 c -0.39423,-0.99483 -0.66675,-2.02406 -0.85989,-3.0771 -0.09,-0.49477 0.0794,-0.89429 0.48154,-1.20121 0.45508,-0.3466 0.96573,-0.54239 1.53458,-0.56885 0.36777,-0.0185 0.73025,0.045 1.07686,0.17198 0.45508,0.16668 0.889,0.14552 1.32291,-0.0688 0.37836,-0.18521 0.77788,-0.15875 1.17475,-0.0556 0.59796,0.15875 1.12713,0.46567 1.62719,0.81757 0.17727,0.12435 0.26194,0.3122 0.24342,0.53181 -0.0397,0.48154 -0.0741,0.96573 -0.13494,1.44727 -0.0714,0.55827 -0.20108,1.10331 -0.35454,1.64571 -0.10848,0.38629 -0.33602,0.59796 -0.71967,0.70908 -0.92869,0.26988 -1.87325,0.42333 -2.91306,0.43656 -0.55563,-0.0159 -1.1774,-0.0635 -1.78858,-0.20108 -0.33602,-0.0741 -0.56621,-0.26988 -0.69057,-0.58738 z"
                    id="path721"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('37')"
                    d="m 168.88842,146.78163 c -0.55563,-0.0159 -1.1774,-0.0635 -1.78858,-0.20108 -0.33602,-0.0741 -0.56357,-0.26988 -0.69057,-0.58738 -0.39423,-0.99483 -0.66675,-2.02406 -0.85989,-3.0771 -0.09,-0.49477 0.0794,-0.89429 0.48154,-1.20121 0.45508,-0.3466 0.96573,-0.54239 1.53458,-0.56885 0.36777,-0.0185 0.73025,0.045 1.07686,0.17198 0.45508,0.16668 0.889,0.14552 1.32291,-0.0688 0.37836,-0.18521 0.77788,-0.15875 1.17475,-0.0556 0.59796,0.15875 1.12713,0.46567 1.62719,0.81757 0.17727,0.12435 0.26194,0.3122 0.24342,0.53181 -0.0397,0.48154 -0.0741,0.96573 -0.13494,1.44727 -0.0688,0.55827 -0.20108,1.10331 -0.35454,1.64571 -0.10848,0.38629 -0.33602,0.59796 -0.71967,0.70908 -0.93133,0.26723 -1.87589,0.42069 -2.91306,0.43656 z m 0.11112,-4.18306 c 0.0476,0.36248 0.082,0.68263 0.1323,1.00013 0.0238,0.14816 0.13493,0.21431 0.27516,0.19843 0.13229,-0.0159 0.21432,-0.11641 0.20373,-0.26987 -0.005,-0.09 -0.0265,-0.17992 -0.037,-0.26988 -0.0476,-0.36248 -0.0952,-0.72496 -0.0238,-1.08743 0.0238,-0.12965 0.0767,-0.254 0.11112,-0.381 0.037,-0.12436 -0.0185,-0.254 -0.12435,-0.30163 -0.10848,-0.0476 -0.25136,-0.0132 -0.31486,0.0926 -0.0423,0.0714 -0.082,0.15082 -0.0952,0.23284 -0.0503,0.26987 -0.09,0.54504 -0.127,0.78581 z"
                    id="path753"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getTextColorForVisual('37')"
                    d="m 168.99954,142.59857 c 0.037,-0.24077 0.0767,-0.51594 0.127,-0.7911 0.0159,-0.0794 0.0529,-0.1614 0.0952,-0.23284 0.0635,-0.10583 0.20638,-0.14287 0.31486,-0.0926 0.10583,0.0476 0.16139,0.17727 0.12435,0.30162 -0.037,0.127 -0.0873,0.25136 -0.11112,0.381 -0.0714,0.36248 -0.0238,0.72496 0.0238,1.08744 0.0132,0.09 0.0317,0.17992 0.037,0.26988 0.0106,0.15345 -0.0714,0.254 -0.20373,0.26987 -0.14023,0.0159 -0.25135,-0.0476 -0.27516,-0.19844 -0.0503,-0.3122 -0.0847,-0.63235 -0.1323,-0.99483 z"
                    id="path776"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('37')"
                    id="text819"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="166.76805"
                    y="153.5"
                  >
                    37
                  </text>
                </g>
                <g id="g103">
                  <path
                    [attr.fill]="getTextColorForVisual('36')"
                    d="m 161.01177,147.06209 c 0,0.003 0,0.005 0.003,0.008 0.0529,-0.0265 0.10583,-0.0503 0.1561,-0.0767 0.12436,-0.0688 0.18257,-0.11377 0.20373,-0.12435 0.045,-0.0609 0.0926,-0.12171 0.14288,-0.18257 0.0159,-0.0767 0.0397,-0.1561 0.082,-0.24077 0.635,-1.2356 1.08214,-2.54529 1.34673,-3.91054 0.0609,-0.30956 0.13494,-0.61912 0.10848,-0.93927 -0.0582,-0.71438 -0.66675,-1.26735 -1.36261,-1.21444 -0.16668,0.0132 -0.33337,0.0556 -0.48948,0.11377 -0.26193,0.0926 -0.5027,0.082 -0.74877,-0.0529 -0.34396,-0.18786 -0.71966,-0.27252 -1.11389,-0.26988 -0.48684,0.005 -0.94721,0.12436 -1.38377,0.32279 -0.26723,0.12171 -0.5133,0.12171 -0.75936,-0.045 -0.0529,-0.0344 -0.10848,-0.0635 -0.16404,-0.0926 -0.43921,-0.22754 -0.89958,-0.34925 -1.39965,-0.28046 -0.92604,0.127 -1.5531,0.96838 -1.41287,1.89177 0.11906,0.78581 0.33867,1.53723 0.71702,2.23573 0.28046,0.51858 0.45244,1.07156 0.59531,1.63777 0.0582,0.22225 0.13229,0.44715 0.15082,0.67469 0.10847,0.0847 0.20637,0.18521 0.28045,0.30427 0.10319,0.16669 0.0397,0.16669 0.21696,0.24606 0.008,0.003 0.0106,0.008 0.0185,0.0106 1.60338,0.3757 3.19882,0.36777 4.81277,-0.0159 z m -4.47675,-0.4101 c -0.23018,-0.0476 -0.36777,-0.17198 -0.41275,-0.41275 -0.10583,-0.55827 -0.24606,-1.11125 -0.45243,-1.64307 -0.0635,-0.16404 -0.13494,-0.32543 -0.21961,-0.47625 -0.37835,-0.68527 -0.61648,-1.41552 -0.73554,-2.18545 -0.14552,-0.93663 0.63235,-1.4658 1.37319,-1.37584 0.2831,0.0344 0.54239,0.14023 0.7911,0.27782 0.13494,0.0741 0.27252,0.14552 0.43392,0.23283 -0.12436,0.45244 -0.14552,0.91281 -0.11906,1.37583 0.005,0.0979 0.0185,0.19579 0.037,0.29104 0.0317,0.1614 0.13229,0.23813 0.27781,0.22225 0.14288,-0.0185 0.22754,-0.1217 0.20638,-0.28839 -0.0423,-0.32809 -0.0609,-0.65617 -0.0132,-0.9869 0.0291,-0.20108 0.0661,-0.39952 0.10054,-0.60854 0.27252,-0.0979 0.54504,-0.20637 0.82285,-0.29104 0.57944,-0.17992 1.14829,-0.16404 1.69334,0.14023 0.0952,0.0529 0.20637,0.0847 0.3175,0.127 0.1217,0.58737 0.10318,1.16946 -0.0344,1.75154 -0.0106,0.0397 -0.0238,0.082 -0.0318,0.12171 -0.0344,0.18521 0.0212,0.29633 0.16933,0.33073 0.15346,0.0344 0.26723,-0.0291 0.30427,-0.20902 0.0635,-0.30163 0.12965,-0.6059 0.15082,-0.91282 0.0212,-0.29898 -0.0159,-0.60325 -0.0291,-0.90223 -0.003,-0.0609 -0.005,-0.12435 -0.0106,-0.19579 0.12435,-0.0423 0.24342,-0.09 0.36248,-0.12435 0.49477,-0.14023 0.94985,0.14023 1.03187,0.65087 0.0238,0.14817 0.0159,0.30957 -0.0106,0.46038 -0.24342,1.45785 -0.70379,2.84427 -1.35467,4.17248 -0.12964,0.26194 -0.32808,0.4101 -0.60854,0.46302 -0.70644,0.13758 -1.41552,0.2196 -2.13519,0.20902 -0.64293,-0.0106 -1.27529,-0.0847 -1.905,-0.21431 z"
                    id="path708"
                    style="stroke-width: 0.264583"
                  />
                  <path
                    [attr.fill]="getToothColorForVisual('36')"
                    d="m 157.31025,141.06928 c -0.12435,0.45244 -0.14552,0.91281 -0.11906,1.37583 0.005,0.0979 0.0185,0.19579 0.037,0.29104 0.0318,0.1614 0.13229,0.23813 0.27781,0.22225 0.14288,-0.0185 0.22755,-0.1217 0.20638,-0.28839 -0.0423,-0.32809 -0.0609,-0.65617 -0.0132,-0.9869 0.0291,-0.20108 0.0662,-0.39952 0.10054,-0.60854 0.27252,-0.0979 0.54504,-0.20637 0.82286,-0.29104 0.57943,-0.17992 1.14829,-0.16404 1.69333,0.14023 0.0952,0.0529 0.20637,0.0847 0.3175,0.127 0.12171,0.58737 0.10319,1.16946 -0.0344,1.75154 -0.0106,0.0397 -0.0238,0.082 -0.0317,0.12171 -0.0344,0.18521 0.0212,0.29633 0.16934,0.33073 0.15346,0.0344 0.26723,-0.0291 0.30427,-0.20902 0.0635,-0.30163 0.12964,-0.6059 0.15081,-0.91282 0.0212,-0.29898 -0.0159,-0.60325 -0.0291,-0.90223 -0.003,-0.0609 -0.005,-0.12435 -0.0106,-0.19579 0.12436,-0.0423 0.24342,-0.09 0.36248,-0.12435 0.49477,-0.14023 0.94986,0.14023 1.03188,0.65087 0.0238,0.14817 0.0159,0.30957 -0.0106,0.46038 -0.24341,1.45785 -0.70379,2.84427 -1.35466,4.17248 -0.12965,0.26194 -0.32809,0.4101 -0.60854,0.46302 -0.70644,0.13758 -1.41553,0.2196 -2.13519,0.20902 -0.64029,-0.0106 -1.27529,-0.0847 -1.90236,-0.21167 -0.23018,-0.0476 -0.36777,-0.17198 -0.41275,-0.41275 -0.10583,-0.55827 -0.24606,-1.11125 -0.45243,-1.64306 -0.0635,-0.16404 -0.13494,-0.32544 -0.21961,-0.47625 -0.37835,-0.68527 -0.61648,-1.41552 -0.73554,-2.18546 -0.14552,-0.93662 0.63235,-1.46579 1.37319,-1.37583 0.2831,0.0344 0.54239,0.14023 0.7911,0.27781 0.13229,0.0714 0.26723,0.14288 0.43127,0.23019 z"
                    id="path740"
                    style="stroke-width: 0.264583"
                  />
                  <text
                    [attr.fill]="getTextColorForVisual('36')"
                    id="text820"
                    style="
                      font-size: 3.87916px;
                      font-family: MyriadPro-Regular;
                      stroke-width: 0.264583;
                    "
                    x="156.65701"
                    y="153.5"
                  >
                    36
                  </text>
                </g>

                <rect
                  *ngIf="showBridge(18, 17)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="18-17"
                  width="7.6778064"
                  height="1"
                  x="53.470276"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(26, 27)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="26-27"
                  width="7.6778064"
                  height="1"
                  x="160.45844"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(27, 28)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.504208;
                    cursor: pointer;
                  "
                  id="27-28"
                  width="8.6141243"
                  height="1"
                  x="170.60757"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(25, 26)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="25-26"
                  width="7.6778064"
                  height="1"
                  x="151.28252"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(24, 25)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="24-25"
                  width="7.6778064"
                  height="1"
                  x="143.23018"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(23, 24)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="23-24"
                  width="7.6778064"
                  height="1"
                  x="134.80333"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(22, 23)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="22-23"
                  width="7.6778064"
                  height="1"
                  x="126.75099"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(21, 22)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="21-22"
                  width="7.6778064"
                  height="1"
                  x="119.07318"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(11, 21)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="11-21"
                  width="7.6778064"
                  height="1"
                  x="111.95717"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(12, 11)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="12-11"
                  width="7.6778064"
                  height="1"
                  x="104.65389"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(13, 12)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="13-12"
                  width="7.6778064"
                  height="1"
                  x="97.725136"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(14, 13)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="14-13"
                  width="7.6778064"
                  height="1"
                  x="90.42186"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(15, 14)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="15-14"
                  width="7.6778064"
                  height="1"
                  x="82.93132"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(16, 15)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="16-15"
                  width="7.6778064"
                  height="1"
                  x="74.691719"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(17, 16)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.498697;
                    cursor: pointer;
                  "
                  id="17-16"
                  width="8.4268608"
                  height="1"
                  x="63.830437"
                  y="123"
                />
                <rect
                  *ngIf="showBridge(48, 47)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.492162;
                    cursor: pointer;
                  "
                  id="48-47"
                  width="8.207468"
                  height="1"
                  x="53.244179"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(36, 37)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="36-37"
                  width="7.6778064"
                  height="1"
                  x="160.23233"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(37, 38)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.504208;
                    cursor: pointer;
                  "
                  id="37-38"
                  width="8.6141243"
                  height="1"
                  x="170.38147"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(35, 36)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="35-36"
                  width="7.6778064"
                  height="1"
                  x="151.05641"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(34, 35)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="34-35"
                  width="7.6778064"
                  height="1"
                  x="143.00407"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(33, 34)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="33-34"
                  width="7.6778064"
                  height="1"
                  x="134.57722"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(32, 33)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="32-33"
                  width="7.6778064"
                  height="1"
                  x="126.52489"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(31, 32)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="31-32"
                  width="7.6778064"
                  height="1"
                  x="118.84708"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(41, 31)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="41-31"
                  width="7.6778064"
                  height="1"
                  x="111.73107"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(42, 41)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="42-41"
                  width="7.6778064"
                  height="1"
                  x="104.42779"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(43, 42)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="43-42"
                  width="7.6778064"
                  height="1"
                  x="97.499031"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(44, 43)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="44-43"
                  width="7.6778064"
                  height="1"
                  x="90.19577"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(45, 44)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="45-44"
                  width="7.6778064"
                  height="1"
                  x="82.705231"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(46, 45)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.476017;
                    cursor: pointer;
                  "
                  id="46-45"
                  width="7.6778064"
                  height="1"
                  x="74.46563"
                  y="149"
                />
                <rect
                  *ngIf="showBridge(47, 46)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.498697;
                    cursor: pointer;
                  "
                  id="47-46"
                  width="8.4268608"
                  height="1"
                  x="63.60434"
                  y="149"
                />

                <rect
                  *ngIf="showBridgeDot(18)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="18"
                  width="3.3707445"
                  height="1"
                  x="51.025078"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(28)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="28"
                  width="3.3707445"
                  height="1"
                  x="178.31471"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(27)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="27"
                  width="3.3707445"
                  height="1"
                  x="167.7121"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(26)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="26"
                  width="3.3707445"
                  height="1"
                  x="157.45137"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(25)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="25"
                  width="3.3707445"
                  height="1"
                  x="148.6235"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(24)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="24"
                  width="3.3707445"
                  height="1"
                  x="141.19585"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(23)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="23"
                  width="3.3707445"
                  height="1"
                  x="133.58093"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(22)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="22"
                  width="3.3707445"
                  height="1"
                  x="125.62411"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(21)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="21"
                  width="3.3707445"
                  height="1"
                  x="117.85455"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(11)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="11"
                  width="3.3707445"
                  height="1"
                  x="110.76881"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(12)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="12"
                  width="3.3707445"
                  height="1"
                  x="103.71569"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(13)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="13"
                  width="3.3707445"
                  height="1"
                  x="96.100792"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(14)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="14"
                  width="3.3707445"
                  height="1"
                  x="88.331245"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(15)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="15"
                  width="3.3707445"
                  height="1"
                  x="80.716339"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(16)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="16"
                  width="3.3707445"
                  height="1"
                  x="71.701202"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(17)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="17"
                  width="3.3707445"
                  height="1"
                  x="61.098557"
                  y="123"
                />
                <rect
                  *ngIf="showBridgeDot(48)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="48"
                  width="3.3707445"
                  height="1"
                  x="51.049202"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(38)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="38"
                  width="3.3707445"
                  height="1"
                  x="178.3398"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(37)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="37"
                  width="3.3707445"
                  height="1"
                  x="167.54991"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(36)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="36"
                  width="3.3707445"
                  height="1"
                  x="157.66373"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(35)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="35"
                  width="3.3707445"
                  height="1"
                  x="148.46132"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(34)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="34"
                  width="3.3707445"
                  height="1"
                  x="141.22093"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(33)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="33"
                  width="3.3707445"
                  height="1"
                  x="133.60602"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(32)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="32"
                  width="3.3707445"
                  height="1"
                  x="125.83643"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(31)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="31"
                  width="3.3707445"
                  height="1"
                  x="118.0668"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(41)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="41"
                  width="3.3707445"
                  height="1"
                  x="110.98098"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(42)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="42"
                  width="3.3707445"
                  height="1"
                  x="103.74052"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(43)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="43"
                  width="3.3707445"
                  height="1"
                  x="96.31279"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(44)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="44"
                  width="3.3707445"
                  height="1"
                  x="88.543091"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(45)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="45"
                  width="3.3707445"
                  height="1"
                  x="80.92807"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(46)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="46"
                  width="3.3707445"
                  height="1"
                  x="71.725525"
                  y="149"
                />
                <rect
                  *ngIf="showBridgeDot(47)"
                  style="
                    fill: #39ac50;
                    fill-opacity: 1;
                    stroke-width: 0.315404;
                    cursor: pointer;
                  "
                  id="47"
                  width="3.3707445"
                  height="1"
                  x="60.935486"
                  y="149"
                />

                <line
                  class="st79"
                  x1="49.567719"
                  y1="136.95912"
                  x2="182.66287"
                  y2="136.73552"
                  id="line789"
                  style="
                    fill: #ffffff;
                    stroke: #000000;
                    stroke-width: 0.23242;
                    stroke-miterlimit: 10;
                  "
                />
                <line
                  class="st79"
                  x1="115.94901"
                  y1="121.5068"
                  x2="115.94901"
                  y2="150.85704"
                  id="line788"
                  style="
                    fill: #ffffff;
                    stroke: #000000;
                    stroke-width: 0.165524;
                    stroke-miterlimit: 10;
                  "
                />
              </g>
            </svg>
          </div>
        </div>

        <div
          class="d-flex column-gap-4 row-gap-2 p-2 flex-wrap"
          style="font-size: small"
        >
          <div
            *ngIf="isAnatomyCrownSelected"
            class="d-flex gap-2 align-items-center"
          >
            <span
              style="
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #397eac;
              "
            ></span
            ><span>Anatomic Crown</span>
          </div>
          <div
            *ngIf="isAnatomyPonticSelected"
            class="d-flex gap-2 align-items-center"
          >
            <span
              style="
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #3939ac;
              "
            ></span
            ><span>Anatomic Pontic</span>
          </div>
          <div
            *ngIf="isAnatomyInlayOnlaySelected"
            class="d-flex gap-2 align-items-center"
          >
            <span
              style="
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #7e39ac;
              "
            ></span
            ><span>Anatomic Inlay/Onlay</span>
          </div>
          <div
            *ngIf="isAnatomyVeneerSelected"
            class="d-flex gap-2 align-items-center"
          >
            <span
              style="
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #ac3995;
              "
            ></span
            ><span>Anatomic Veneer</span>
          </div>

          <div
            *ngIf="isFrameCrownSelected"
            class="d-flex gap-2 align-items-center"
          >
            <span
              style="
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #397eac;
              "
            ></span
            ><span>Frame Crown</span>
          </div>
          <div
            *ngIf="isFramePonticSelected"
            class="d-flex gap-2 align-items-center"
          >
            <span
              style="
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #3939ac;
              "
            ></span
            ><span>Frame Pontic</span>
          </div>
          <div
            *ngIf="isFrameInlayOnlaySelected"
            class="d-flex gap-2 align-items-center"
          >
            <span
              style="
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #7e39ac;
              "
            ></span
            ><span>Frame Inlay/Onlay</span>
          </div>
          <div
            *ngIf="isFrameVeneerSelected"
            class="d-flex gap-2 align-items-center"
          >
            <span
              style="
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #ac3995;
              "
            ></span
            ><span>Frame Veneer</span>
          </div>

          <div *ngIf="isBridgeSelected" class="d-flex gap-2 align-items-center">
            <span
              style="
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                background: #39ac50;
              "
            ></span
            ><span>Bridge</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-4 px-4">
      <div class="info-card">
        <div class="info-row">
          <div class="info-label">Case/Patient</div>
          <div class="info-value">{{ orderDetailsNew.refNum }}</div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Units</div>
          <div class="info-value">{{ getAllToothCountFromOrderDetails }}</div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row" *ngIf="orderDetailsNew.showHuman">
          <div class="info-label">Design Level</div>
          <div class="info-value">{{ orderDetailsNew.tier }}</div>
        </div>
        <div class="info-divider" *ngIf="orderDetailsNew.showHuman"></div>

        <div class="info-row">
          <div class="info-label">Designer</div>
          <div class="info-value">{{ orderDetailsNew.designer }}</div>
        </div>
        <div class="info-divider"></div>
        <div class="info-row">
          <div class="info-label">Software</div>
          <div class="info-value">{{ orderDetailsNew.software }}</div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Bite Type</div>
          <div class="info-value">
            <img
              style="height: 30px; width: auto"
              src="/Asset_Image_Gity/Bite_Type_Selection/{{
                orderDetailsNew.biteType.replace(' ', '-')
              }}.png"
            />
            &nbsp;&nbsp;
            {{ orderDetailsNew.biteType.replace("-", " ") | titlecase }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-4 px-4">
      <div class="info-card">
        <div class="info-row">
          <div class="info-label">Articulator Setting:</div>
          <div class="info-value">
            {{ orderDetailsNew.articulationDetails.articulator }}
          </div>
        </div>
        <div class="info-divider"></div>

        <div
          *ngFor="
            let articulationDetail of articulationDetailsWithNonDefaultValues;
            let last = last
          "
        >
          <div class="info-row">
            <div class="info-label" style="color: #f16a70">
              {{ articulationDetail.key }}
            </div>
            <div class="info-value">{{ articulationDetail.value }}</div>
          </div>
          <div class="info-divider" *ngIf="!last"></div>
        </div>

        <div
          *ngFor="
            let articulationDetail of articulationDetailsWithDefaultValues;
            let last = last
          "
        >
          <div class="info-row">
            <div class="info-label">{{ articulationDetail.key }}</div>
            <div class="info-value">{{ articulationDetail.value }}</div>
          </div>
          <div class="info-divider" *ngIf="!last"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mx-2 mt-4">
    <div class="col p-0">
      <h6 class="mb-1">Tooth Details</h6>
    </div>
  </div>

  <div class="row m-2 border rounded">
    <div class="col-4 px-4" *ngFor="let toothData of getNonBridgeToothData">
      <div class="info-card">
        <div class="info-row">
          <div class="info-label">Material</div>
          <div class="info-value">
            {{ toothData.props["Material"] }}
            <span style="font-size: small; color: #707070"
              >(for teeth {{ toothData.teeth }})</span
            >
          </div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Minimal Thickness</div>
          <div class="info-value">{{ toothData.minimalThickness }} mm</div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Cement Gap</div>
          <div class="info-value">{{ toothData.cementGap }} mm</div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Margin Gap</div>
          <div class="info-value">{{ toothData.marginGap }} mm</div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Horizontal Border</div>
          <div class="info-value">{{ toothData.horizontalBorder }} mm</div>
        </div>
      </div>
    </div>

    <div class="col-4 px-4" *ngFor="let toothData of getBridgeToothData">
      <div class="info-card">
        <div class="info-row">
          <div class="info-label">Material</div>
          <div class="info-value">
            {{ toothData.material }}
            <span style="font-size: small; color: #707070"
              >(for teeth {{ toothData.teeth }})</span
            >
          </div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Minimal Thickness</div>
          <div class="info-value">{{ toothData.minimalThickness }} mm</div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Cement Gap</div>
          <div class="info-value">{{ toothData.cementGap }} mm</div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Margin Gap</div>
          <div class="info-value">{{ toothData.marginGap }} mm</div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Horizontal Border</div>
          <div class="info-value">{{ toothData.horizontalBorder }} mm</div>
        </div>
        <div class="info-divider"></div>

        <div class="info-row">
          <div class="info-label">Radius Compensation</div>
          <div class="info-value">{{ toothData.radiusCompensation }} mm</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mx-2 mt-4">
    <div class="col p-0">
      <h6 class="mb-1">Instructions</h6>
    </div>
  </div>

  <!-- <div class="row m-2" *ngIf="orderDetailsNew.showAi">
    <div class="col">
      <img style="height: 50px; width: auto;" src="ai-short.svg" />
      <span style="vertical-align: bottom;" style="color: #205567;">powered design generation (approx. 10h). The AI can generate up to 6 units per order. Price: € 3.85 per unit.</span>
    </div>
  </div> -->

  <div class="row border rounded m-2 pt-3 pb-3">
    <!-- Instructions -->
    <div class="col-12 mb-4">
      <div class="row mt-3">
        <div class="col-12">
          <div class="card shadow-sm">
            <!-- <div class="card-header fw-semibold" style="background:#f5f7fa;">
        Instructions
      </div> -->

            <div class="card-body">
              <!-- EDITABLE (Create Task) -->
              <textarea
                *ngIf="fromSummary"
                class="form-control"
                rows="6"
                placeholder="Write instructions here..."
                [(ngModel)]="orderDetailsNew.instructions"
              >
              </textarea>

              <!-- READ ONLY (Summary / Task Details) -->
              <div
                *ngIf="!fromSummary"
                class="border rounded p-3 bg-light"
                style="min-height: 120px"
              >
                {{
                  orderDetailsNew.instructions || "No instructions provided."
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>

    <ng-container *ngIf="anteriorTeethForAnatomy.length > 0">
      <div class="col-4 mb-3">
        <app-prop-a
          [readonly]="true"
          [orderDetailsNew]="orderDetailsNew"
          [teeth]="anteriorTeethForAnatomy"
          [anterior]="true"
        ></app-prop-a>
        <!-- Mesiale und Distale -->
      </div>
    </ng-container>
    <ng-container *ngIf="posteriorTeethForAnatomy.length > 0">
      <div class="col-4 mb-3">
        <app-prop-a
          [readonly]="true"
          [orderDetailsNew]="orderDetailsNew"
          [teeth]="posteriorTeethForAnatomy"
          [anterior]="false"
        ></app-prop-a>
        <!-- Mesiale und Distale -->
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        (isFrameCrownSelected || isFramePonticSelected) &&
        orderDetailsNew.props['collars'] !== ''
      "
    >
      <!-- collars -->
      <div class="col-4 mb-3">
        <app-prop-collars
          [readonly]="true"
          [orderDetailsNew]="orderDetailsNew"
          [anterior]="false"
        ></app-prop-collars>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        (isFrameCrownSelected || isFramePonticSelected) &&
        orderDetailsNew.props['cutback'] !== ''
      "
    >
      <!-- cutback -->
      <div class="col-4 mb-3">
        <app-prop-cutback
          [readonly]="true"
          [orderDetailsNew]="orderDetailsNew"
          [anterior]="false"
        ></app-prop-cutback>
      </div>
    </ng-container>

    <ng-container
      *ngIf="orderDetailsNew.showHuman && anteriorTeethForFrame_1.length > 0"
    >
      <!-- frame bridge ceramic veneering space -->
      <div class="col-4 mb-3">
        <div
          class="accordion-item info-card m-0 p-0"
          *ngIf="
            orderDetailsNew.showHuman && anteriorTeethForFrame_1.length > 0
          "
        >
          <h2 class="accordion-header m-0">
            <button
              class="accordion-button collapsed p-0 p-3"
              style="background-color: #faf9f9; font-size: 14px"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#ceramic-veneering-anterior"
            >
              <!-- Connection Types and Strength Levels -->
              Space Requirement for Ceramic Veneering on Single Crowns
              &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for tooth
                {{
                  dataService.rearrangedTeethOrder(anteriorTeethForFrame_1)
                }})</span
              >
            </button>
          </h2>

          <div id="ceramic-veneering-anterior" class="accordion">
            <div class="accordion-body container text-center p-3">
              <div
                class="row"
                *ngIf="
                  orderDetailsNew.showHuman &&
                  anteriorTeethForFrame_1.length > 0
                "
              >
                <div class="col text-center">
                  <img
                    width="250"
                    height="auto"
                    src="Asset_Image_Gity_V3/Copping_Space_requirements/for_front_tooth_11_12_13/Space_for_Ceramic_Single_Crowns_2.png"
                  />
                </div>
                <div class="col text-center">
                  <div class="info-row">
                    <div class="info-label">Space for Ceramic</div>
                    <div class="info-value">
                      {{ orderDetailsNew.props["ceramic-veneering-anterior"] }}
                    </div>
                  </div>

                  <!-- <div class="col text-start mt-4">
                      <p class="ms-1" style="color: #205567;">Space for Ceramic (mm)</p>
                      <mat-slider [min]="-.60" [max]="5" [step]=".01" [discrete]="true" style="width: 100%;">
                      <input matSliderThumb [(ngModel)]="orderDetailsNew.props['ceramic-veneering-anterior']" #slider>
                      </mat-slider>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        orderDetailsNew.showHuman && anteriorBridgedTeethFrame_1.length > 0
      "
    >
      <!-- frame bridge ceramic veneering space -->
      <div class="col-4 mb-3">
        <div
          class="accordion-item info-card m-0 p-0"
          *ngIf="
            orderDetailsNew.showHuman && anteriorBridgedTeethFrame_1.length > 0
          "
        >
          <h2 class="accordion-header m-0">
            <button
              class="accordion-button collapsed p-0 p-3"
              style="background-color: #faf9f9; font-size: 14px"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#ceramic-veneering-anterior"
            >
              <!-- Connection Types and Strength Levels -->
              Space Requirement for Ceramic Veneering on Single Crowns
              &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for tooth
                {{
                  dataService.rearrangedTeethOrder(anteriorBridgedTeethFrame_1)
                }})</span
              >
            </button>
          </h2>

          <div id="ceramic-veneering-anterior" class="accordion">
            <div class="accordion-body container text-center p-3">
              <div
                class="row"
                *ngIf="
                  orderDetailsNew.showHuman &&
                  anteriorBridgedTeethFrame_1.length > 0
                "
              >
                <div class="col text-center">
                  <img
                    width="250"
                    height="auto"
                    src="Asset_Image_Gity_V3/Copping_Space_requirements/for_front_tooth_11_12_13/Space_for_Ceramic_Bridge_Crowns_2.png"
                  />
                </div>
                <div class="col text-center">
                  <div class="info-row">
                    <div class="info-label">Space for Ceramic</div>
                    <div class="info-value">
                      {{ orderDetailsNew.props["ceramic-veneering-anterior"] }}
                    </div>
                  </div>

                  <!-- <div class="col text-start mt-4">
                      <p class="ms-1" style="color: #205567;">Space for Ceramic (mm)</p>
                      <mat-slider [min]="-.60" [max]="5" [step]=".01" [discrete]="true" style="width: 100%;">
                      <input matSliderThumb [(ngModel)]="orderDetailsNew.props['ceramic-veneering-anterior']" #slider>
                      </mat-slider>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="orderDetailsNew.showHuman && posteriorTeethForFrame_1.length > 0"
    >
      <div class="col-4 mb-3">
        <div
          class="accordion-item info-card m-0 p-0"
          *ngIf="
            orderDetailsNew.showHuman && posteriorTeethForFrame_1.length > 0
          "
        >
          <h2 class="accordion-header m-0">
            <button
              class="accordion-button collapsed p-0 p-3"
              style="background-color: #faf9f9; font-size: 14px"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#ceramic-veneering-posterior"
            >
              <!-- Connection Types and Strength Levels -->
              Space Requirement for Ceramic Veneering on Single Crowns
              &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for tooth
                {{
                  dataService.rearrangedTeethOrder(posteriorTeethForFrame_1)
                }})</span
              >
            </button>
          </h2>

          <div id="ceramic-veneering-posterior" class="accordion">
            <div class="accordion-body container text-center p-3">
              <div
                class="row"
                *ngIf="
                  orderDetailsNew.showHuman &&
                  posteriorTeethForFrame_1.length > 0
                "
              >
                <div class="col text-center">
                  <img
                    width="250"
                    height="auto"
                    src="Asset_Image_Gity_V3/Copping_Space_requirements/for_side_tooth_14, 15, 16, 17, 18/Space_for_Ceramic_Single_Crowns.png"
                  />
                </div>
                <div class="col text-center">
                  <div class="info-row">
                    <div class="info-label">Space for Ceramic</div>
                    <div class="info-value">
                      {{ orderDetailsNew.props["ceramic-veneering-posterior"] }}
                    </div>
                  </div>

                  <!-- <div class="col text-start mt-4">
                      <p class="ms-1" style="color: #205567;">Space for Ceramic (mm)</p>
                      <mat-slider [min]="-.60" [max]="5" [step]=".01" [discrete]="true" style="width: 100%;">
                      <input matSliderThumb [(ngModel)]="orderDetailsNew.props['ceramic-veneering-posterior']" #slider>
                      </mat-slider>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        orderDetailsNew.showHuman && posteriorBridgedTeethFrame_1.length > 0
      "
    >
      <div class="col-4 mb-3">
        <div
          class="accordion-item info-card m-0 p-0"
          *ngIf="
            orderDetailsNew.showHuman && posteriorBridgedTeethFrame_1.length > 0
          "
        >
          <h2 class="accordion-header m-0">
            <button
              class="accordion-button collapsed p-0 p-3"
              style="background-color: #faf9f9; font-size: 14px"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#ceramic-veneering-posterior"
            >
              <!-- Connection Types and Strength Levels -->
              Space Requirement for Ceramic Veneering on Single Crowns
              &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for tooth
                {{
                  dataService.rearrangedTeethOrder(
                    posteriorBridgedTeethFrame_1
                  )
                }})</span
              >
            </button>
          </h2>

          <div id="ceramic-veneering-posterior" class="accordion">
            <div class="accordion-body container text-center p-3">
              <div
                class="row"
                *ngIf="
                  orderDetailsNew.showHuman &&
                  posteriorBridgedTeethFrame_1.length > 0
                "
              >
                <div class="col text-center">
                  <img
                    width="250"
                    height="auto"
                    src="Asset_Image_Gity_V3/Copping_Space_requirements/for_side_tooth_14, 15, 16, 17, 18/Space_for_Ceramic_Bridge_Crowns.png"
                  />
                </div>
                <div class="col text-center">
                  <div class="info-row">
                    <div class="info-label">Space for Ceramic</div>
                    <div class="info-value">
                      {{ orderDetailsNew.props["ceramic-veneering-posterior"] }}
                    </div>
                  </div>

                  <!-- <div class="col text-start mt-4">
                      <p class="ms-1" style="color: #205567;">Space for Ceramic (mm)</p>
                      <mat-slider [min]="-.60" [max]="5" [step]=".01" [discrete]="true" style="width: 100%;">
                      <input matSliderThumb [(ngModel)]="orderDetailsNew.props['ceramic-veneering-posterior']" #slider>
                      </mat-slider>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- <ng-container *ngIf="orderDetailsNew.showHuman && bridgedTeethFrame.length > 0">
    <div class="col-4 mb-3" >
      <div class="accordion-item info-card m-0 p-0" *ngIf="orderDetailsNew.showHuman && bridgedTeethFrame.length > 0">
          <h2 class="accordion-header m-0">
            <button class="accordion-button collapsed p-0 p-3" style="background-color: #FAF9F9; font-size: 14px;" type="button" data-bs-toggle="collapse" data-bs-target="#ceramic-veneering-bridge">
                Space Requirement for Ceramic Veneering on Bridge Crowns &nbsp;&nbsp; <span style="font-size: small; color: #707070;">(for tooth {{dataService.rearrangedTeethOrder(bridgedTeethFrame)}})</span>
            </button>
          </h2>

          <div id="ceramic-veneering-bridge" class="accordion" >
            <div class="accordion-body container text-center p-3" >

              <div class="row" *ngIf="orderDetailsNew.showHuman && bridgedTeethFrame.length > 0">
                <div class="col text-center" >
                    <img width="200" height="auto" src="ceramic-veneering-bridge.png" />
                </div>
                <div class="col text-center" >
                  <div class="info-row">
                      <div class="info-label">Space for Ceramic</div><div class="info-value">{{orderDetailsNew.props['ceramic-veneering-bridge']}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    </ng-container> -->

    <ng-container *ngFor="let data of orderDetailsNew.bridges; let i = index">
      <!-- frame bridge connection type -->
      <div
        class="col-4 mb-3"
        *ngIf="
          orderDetailsNew.showHuman &&
          anteriorBridgedTeethFrame(data.bridgedTeeth).length > 0
        "
      >
        <div
          class="accordion-item info-card m-0 p-0"
          *ngIf="
            orderDetailsNew.showHuman &&
            anteriorBridgedTeethFrame(data.bridgedTeeth).length > 0
          "
        >
          <h2 class="accordion-header m-0">
            <button
              class="accordion-button collapsed p-0 p-3"
              style="background-color: #faf9f9; font-size: 14px"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#bridge-anterior-11-' + i"
            >
              <!-- Connection Types and Strength Levels -->
              Frame Connection Type and Strength Levels &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for tooth
                {{ dataService.rearrangedTeethOrder(data.bridgedTeeth) }})</span
              >
            </button>
          </h2>

          <!-- data-bs-parent="#toothTypeAccordion" -->
          <div id="bridge-anterior-11-{{ i }}" class="accordion">
            <div
              class="accordion-body container text-center px-3"
              style="min-height: 12rem"
            >
              <div class="row">
                <div class="col text-center">
                  <div class="radio-cards-container" style="max-width: 51rem">
                    <label
                      style="width: 100%"
                      class="radio-card-label"
                      *ngIf="
                        orderDetailsNew.props[
                          'bridgeConnectionType-anterior-frame-' + i
                        ] == 'Anatomical connection'
                      "
                    >
                      <input
                        type="radio"
                        name="bridge-anterior-0-{{ i }}"
                        [(ngModel)]="
                          orderDetailsNew.props[
                            'bridgeConnectionType-anterior-frame-' + i
                          ]
                        "
                        value="Anatomical connection"
                        class="hidden-radio-input"
                      />
                      <div
                        class="custom-radio-indicator"
                        data-html2canvas-ignore
                      >
                        <div class="custom-radio-indicator-dot"></div>
                      </div>
                      <div class="card-icon">
                        <app-magnifier
                          [contentTemplate]="apppropahtml155"
                        ></app-magnifier>
                        <ng-template #apppropahtml155>
                          <div class="magnify-content">
                            <img
                              width="100"
                              height="auto"
                              style="margin-left: 10px"
                              src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Copping/for_front_tooth_11_12_13/anatomical_ connection_2_C.png"
                            />
                            <div class="card-text">Anatomical connection</div>
                          </div>
                        </ng-template>
                      </div>
                      <div class="radio-card-overlay"></div>
                    </label>
                    <label
                      style="width: 100%"
                      class="radio-card-label"
                      *ngIf="
                        orderDetailsNew.props[
                          'bridgeConnectionType-anterior-frame-' + i
                        ] == 'Strong connection'
                      "
                    >
                      <input
                        type="radio"
                        name="bridge-anterior-0-{{ i }}"
                        [(ngModel)]="
                          orderDetailsNew.props[
                            'bridgeConnectionType-anterior-frame-' + i
                          ]
                        "
                        value="Strong connection"
                        class="hidden-radio-input"
                      />
                      <div
                        class="custom-radio-indicator"
                        data-html2canvas-ignore
                      >
                        <div class="custom-radio-indicator-dot"></div>
                      </div>
                      <div class="card-icon">
                        <app-magnifier
                          [contentTemplate]="apppropahtml156"
                        ></app-magnifier>
                        <ng-template #apppropahtml156>
                          <div class="magnify-content">
                            <img
                              width="100"
                              height="auto"
                              style="margin-left: 10px"
                              src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Copping/for_front_tooth_11_12_13/strong_ connection_2_C.png"
                            />
                            <div class="card-text">Strong connection</div>
                          </div>
                        </ng-template>
                      </div>
                      <div class="radio-card-overlay"></div>
                    </label>
                    <label
                      style="width: 100%"
                      class="radio-card-label"
                      *ngIf="
                        orderDetailsNew.props[
                          'bridgeConnectionType-anterior-frame-' + i
                        ] == 'Very strong connection'
                      "
                    >
                      <input
                        type="radio"
                        name="bridge-anterior-0-{{ i }}"
                        [(ngModel)]="
                          orderDetailsNew.props[
                            'bridgeConnectionType-anterior-frame-' + i
                          ]
                        "
                        value="Very strong connection"
                        class="hidden-radio-input"
                      />
                      <div
                        class="custom-radio-indicator"
                        data-html2canvas-ignore
                      >
                        <div class="custom-radio-indicator-dot"></div>
                      </div>
                      <div class="card-icon">
                        <app-magnifier
                          [contentTemplate]="apppropahtml157"
                        ></app-magnifier>
                        <ng-template #apppropahtml157>
                          <div class="magnify-content">
                            <img
                              width="100"
                              height="auto"
                              style="margin-left: 10px"
                              src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Copping/for_front_tooth_11_12_13/very_strong_ connection_2_C.png"
                            />
                            <div class="card-text">Very strong connection</div>
                          </div>
                        </ng-template>
                      </div>
                      <div class="radio-card-overlay"></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-4 mb-3"
        *ngIf="
          orderDetailsNew.showHuman &&
          posteriorBridgedTeethFrame(data.bridgedTeeth).length > 0
        "
      >
        <div
          class="accordion-item info-card m-0 p-0"
          *ngIf="
            orderDetailsNew.showHuman &&
            posteriorBridgedTeethFrame(data.bridgedTeeth).length > 0
          "
        >
          <h2 class="accordion-header m-0">
            <button
              class="accordion-button collapsed p-0 p-3"
              style="background-color: #faf9f9; font-size: 14px"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#bridge-posterior-11-' + i"
            >
              <!-- Connection Types and Strength Levels -->
              Frame Connection Type and Strength Levels &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for tooth
                {{ dataService.rearrangedTeethOrder(data.bridgedTeeth) }})</span
              >
            </button>
          </h2>

          <!-- data-bs-parent="#toothTypeAccordion" -->
          <div id="bridge-posterior-11-{{ i }}" class="accordion">
            <div
              class="accordion-body container text-center px-3"
              style="min-height: 12rem"
            >
              <div class="row">
                <div class="col text-center">
                  <div class="radio-cards-container" style="max-width: 51rem">
                    <label
                      style="width: 100%"
                      class="radio-card-label"
                      *ngIf="
                        orderDetailsNew.props[
                          'bridgeConnectionType-posterior-frame-' + i
                        ] == 'Anatomical connection'
                      "
                    >
                      <input
                        type="radio"
                        name="frame-bridge-posterior-1-{{ i }}"
                        [(ngModel)]="
                          orderDetailsNew.props[
                            'bridgeConnectionType-posterior-frame-' + i
                          ]
                        "
                        value="Anatomical connection"
                        class="hidden-radio-input"
                      />
                      <div
                        class="custom-radio-indicator"
                        data-html2canvas-ignore
                      >
                        <div class="custom-radio-indicator-dot"></div>
                      </div>
                      <div class="card-icon">
                        <app-magnifier
                          [contentTemplate]="apppropahtml158"
                        ></app-magnifier>
                        <ng-template #apppropahtml158>
                          <div class="magnify-content">
                            <img
                              width="100"
                              height="auto"
                              style="margin-left: 10px"
                              src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Copping/for_side_tooth_14, 15, 16, 17, 18/anatomical_ connection_C_.png"
                            />
                            <div class="card-text">Anatomical connection</div>
                          </div>
                        </ng-template>
                      </div>
                      <div class="radio-card-overlay"></div>
                    </label>
                    <label
                      style="width: 100%"
                      class="radio-card-label"
                      *ngIf="
                        orderDetailsNew.props[
                          'bridgeConnectionType-posterior-frame-' + i
                        ] == 'Strong connection'
                      "
                    >
                      <input
                        type="radio"
                        name="frame-bridge-posterior-1-{{ i }}"
                        [(ngModel)]="
                          orderDetailsNew.props[
                            'bridgeConnectionType-posterior-frame-' + i
                          ]
                        "
                        value="Strong connection"
                        class="hidden-radio-input"
                      />
                      <div
                        class="custom-radio-indicator"
                        data-html2canvas-ignore
                      >
                        <div class="custom-radio-indicator-dot"></div>
                      </div>
                      <div class="card-icon">
                        <app-magnifier
                          [contentTemplate]="apppropahtml159"
                        ></app-magnifier>
                        <ng-template #apppropahtml159>
                          <div class="magnify-content">
                            <img
                              width="100"
                              height="auto"
                              style="margin-left: 10px"
                              src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Copping/for_side_tooth_14, 15, 16, 17, 18/strong_ connection_C_.png"
                            />
                            <div class="card-text">Strong connection</div>
                          </div>
                        </ng-template>
                      </div>
                      <div class="radio-card-overlay"></div>
                    </label>
                    <label
                      style="width: 100%"
                      class="radio-card-label"
                      *ngIf="
                        orderDetailsNew.props[
                          'bridgeConnectionType-posterior-frame-' + i
                        ] == 'Very strong connection'
                      "
                    >
                      <input
                        type="radio"
                        name="frame-bridge-posterior-1-{{ i }}"
                        [(ngModel)]="
                          orderDetailsNew.props[
                            'bridgeConnectionType-posterior-frame-' + i
                          ]
                        "
                        value="Very strong connection"
                        class="hidden-radio-input"
                      />
                      <div
                        class="custom-radio-indicator"
                        data-html2canvas-ignore
                      >
                        <div class="custom-radio-indicator-dot"></div>
                      </div>
                      <div class="card-icon">
                        <app-magnifier
                          [contentTemplate]="apppropahtml160"
                        ></app-magnifier>
                        <ng-template #apppropahtml160>
                          <div class="magnify-content">
                            <img
                              width="100"
                              height="auto"
                              style="margin-left: 10px"
                              src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Copping/for_side_tooth_14, 15, 16, 17, 18/very_strong_ connection_C_.png"
                            />
                            <div class="card-text">Very strong connection</div>
                          </div>
                        </ng-template>
                      </div>
                      <div class="radio-card-overlay"></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="orderDetailsNew.showAi">
      <div class="col-4 mb-3">
        <div class="accordion-item info-card m-0 p-0">
          <h2 class="accordion-header m-0">
            <button
              style="font-size: 14px; background-color: #faf9f9"
              class="accordion-button collapsed p-0 p-3"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#undercut"
            >
              Undercuts &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for tooth
                {{
                  dataService.rearrangedTeethOrderByOrderDetails(
                    orderDetailsNew
                  )
                }})</span
              >
            </button>
          </h2>

          <div id="undercut" class="accordion">
            <div class="accordion-body container text-center px-3 pt-2">
              <div
                class="radio-cards-container"
                style="
                  max-width: 25rem;
                  max-height: 12rem;
                  min-height: 6rem;
                  background-color: #faf9f9;
                "
              >
                <label
                  class="radio-card-label"
                  style="width: 100%"
                  *ngIf="orderDetailsNew.props['undercuts'] == 'Yes'"
                >
                  <input
                    [disabled]="true"
                    type="radio"
                    name="undercut-dtls"
                    [(ngModel)]="orderDetailsNew.props['undercuts']"
                    value="Yes"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-text">Yes</div>
                  <div class="radio-card-overlay"></div>
                </label>
                <label
                  class="radio-card-label"
                  style="width: 100%"
                  *ngIf="orderDetailsNew.props['undercuts'] == 'No'"
                >
                  <input
                    [disabled]="true"
                    type="radio"
                    name="undercut-dtls"
                    [(ngModel)]="orderDetailsNew.props['undercuts']"
                    value="No"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-text">No</div>
                  <div class="radio-card-overlay"></div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngFor="let data of orderDetailsNew.bridges; let i = index">
      <div
        class="col-4 mb-3"
        *ngIf="
          orderDetailsNew.showHuman &&
          anteriorBridgedTeeth(data.bridgedTeeth).length > 0
        "
      >
        <div class="accordion-item info-card m-0 p-0">
          <h2 class="accordion-header m-0">
            <button
              style="font-size: 14px; background-color: #faf9f9"
              class="accordion-button collapsed p-0 p-3"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#bridge-anterior-2-' + i"
            >
              Connection Type &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for tooth
                {{ dataService.rearrangedTeethOrder(data.bridgedTeeth) }})</span
              >
            </button>
          </h2>

          <div id="bridge-anterior-2-{{ i }}" class="accordion">
            <div class="accordion-body container text-center px-3 pt-2">
              <div
                class="radio-cards-container"
                style="max-width: 51rem; background-color: #faf9f9"
              >
                <label
                  style="width: 100%"
                  class="radio-card-label"
                  *ngIf="
                    orderDetailsNew.props[
                      'bridgeConnectionType-anterior-' + i
                    ] == 'Anatomical connection'
                  "
                >
                  <input
                    type="radio"
                    name="bridge-anterior-00-{{ i }}"
                    [(ngModel)]="
                      orderDetailsNew.props[
                        'bridgeConnectionType-anterior-' + i
                      ]
                    "
                    value="Anatomical connection"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <app-magnifier
                      [contentTemplate]="apppropahtml332"
                    ></app-magnifier>
                    <ng-template #apppropahtml332>
                      <div class="magnify-content">
                        <img
                          width="100"
                          height="80"
                          style="margin-left: 10px"
                          src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Anatomie/for_front_tooth_11_12_13/anatomical_ connection_2_A.png"
                        />
                        <div class="card-text">Anatomical connection</div>
                      </div>
                    </ng-template>
                  </div>
                  <div class="radio-card-overlay"></div>
                </label>
                <label
                  style="width: 100%"
                  class="radio-card-label"
                  *ngIf="
                    orderDetailsNew.props[
                      'bridgeConnectionType-anterior-' + i
                    ] == 'Strong connection'
                  "
                >
                  <input
                    type="radio"
                    name="bridge-anterior-00-{{ i }}"
                    [(ngModel)]="
                      orderDetailsNew.props[
                        'bridgeConnectionType-anterior-' + i
                      ]
                    "
                    value="Strong connection"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <app-magnifier
                      [contentTemplate]="apppropahtml333"
                    ></app-magnifier>
                    <ng-template #apppropahtml333>
                      <div class="magnify-content">
                        <img
                          width="100"
                          height="80"
                          style="margin-left: 10px"
                          src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Anatomie/for_front_tooth_11_12_13/strong_ connection_2_A.png"
                        />
                        <div class="card-text">Strong connection</div>
                      </div>
                    </ng-template>
                  </div>
                  <div class="radio-card-overlay"></div>
                </label>
                <label
                  style="width: 100%"
                  class="radio-card-label"
                  *ngIf="
                    orderDetailsNew.props[
                      'bridgeConnectionType-anterior-' + i
                    ] == 'Very strong connection'
                  "
                >
                  <input
                    type="radio"
                    name="bridge-anterior-00-{{ i }}"
                    [(ngModel)]="
                      orderDetailsNew.props[
                        'bridgeConnectionType-anterior-' + i
                      ]
                    "
                    value="Very strong connection"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <app-magnifier
                      [contentTemplate]="apppropahtml334"
                    ></app-magnifier>
                    <ng-template #apppropahtml334>
                      <div class="magnify-content">
                        <img
                          width="100"
                          height="80"
                          style="margin-left: 10px"
                          src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Anatomie/for_front_tooth_11_12_13/very_strong_ connection_2_A.png"
                        />
                        <div class="card-text">Very strong connection</div>
                      </div>
                    </ng-template>
                  </div>
                  <div class="radio-card-overlay"></div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-4 mb-3"
        *ngIf="
          orderDetailsNew.showHuman &&
          posteriorBridgedTeeth(data.bridgedTeeth).length > 0
        "
      >
        <div class="accordion-item info-card m-0 p-0">
          <h2 class="accordion-header m-0">
            <button
              style="font-size: 14px; background-color: #faf9f9"
              class="accordion-button collapsed p-0 p-3"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#bridge-posterior-2-' + i"
            >
              Connection Type &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for tooth
                {{ dataService.rearrangedTeethOrder(data.bridgedTeeth) }})</span
              >
            </button>
          </h2>

          <div id="bridge-posterior-2-{{ i }}" class="accordion">
            <div class="accordion-body container text-center px-3 pt-2">
              <div
                class="radio-cards-container"
                style="max-width: 51rem; background-color: #faf9f9"
              >
                <label
                  style="width: 100%"
                  class="radio-card-label"
                  *ngIf="
                    orderDetailsNew.props[
                      'bridgeConnectionType-posterior-' + i
                    ] == 'Anatomical connection'
                  "
                >
                  <input
                    type="radio"
                    name="bridge-posterior-11-{{ i }}"
                    [(ngModel)]="
                      orderDetailsNew.props[
                        'bridgeConnectionType-posterior-' + i
                      ]
                    "
                    value="Anatomical connection"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <app-magnifier
                      [contentTemplate]="apppropahtml335"
                    ></app-magnifier>
                    <ng-template #apppropahtml335>
                      <img
                        width="100"
                        height="80"
                        style="margin-left: 10px"
                        src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Anatomie/for_side_tooth_14, 15, 16, 17, 18/anatomical_ connection_A.png"
                      />
                    </ng-template>
                  </div>
                  <div class="card-text">Anatomical connection</div>
                  <div class="radio-card-overlay"></div>
                </label>
                <label
                  style="width: 100%"
                  class="radio-card-label"
                  *ngIf="
                    orderDetailsNew.props[
                      'bridgeConnectionType-posterior-' + i
                    ] == 'Strong connection'
                  "
                >
                  <input
                    type="radio"
                    name="bridge-posterior-11-{{ i }}"
                    [(ngModel)]="
                      orderDetailsNew.props[
                        'bridgeConnectionType-posterior-' + i
                      ]
                    "
                    value="Strong connection"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <app-magnifier
                      [contentTemplate]="apppropahtml336"
                    ></app-magnifier>
                    <ng-template #apppropahtml336>
                      <div class="magnify-content">
                        <img
                          width="100"
                          height="80"
                          style="margin-left: 10px"
                          src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Anatomie/for_side_tooth_14, 15, 16, 17, 18/strong_ connection_A.png"
                        />
                        <div class="card-text">Strong connection</div>
                      </div>
                    </ng-template>
                  </div>
                  <div class="radio-card-overlay"></div>
                </label>
                <label
                  style="width: 100%"
                  class="radio-card-label"
                  *ngIf="
                    orderDetailsNew.props[
                      'bridgeConnectionType-posterior-' + i
                    ] == 'Very strong connection'
                  "
                >
                  <input
                    type="radio"
                    name="bridge-posterior-11-{{ i }}"
                    [(ngModel)]="
                      orderDetailsNew.props[
                        'bridgeConnectionType-posterior-' + i
                      ]
                    "
                    value="Very strong connection"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <app-magnifier
                      [contentTemplate]="apppropahtml337"
                    ></app-magnifier>
                    <ng-template #apppropahtml337>
                      <div class="magnify-content">
                        <img
                          width="100"
                          height="80"
                          style="margin-left: 10px"
                          src="Asset_Image_Gity_V3/Connection_Type_and Strenght_Levels/Anatomie/for_side_tooth_14, 15, 16, 17, 18/very_strong_ connection_A.png"
                        />
                        <div class="card-text">Very strong connection</div>
                      </div>
                    </ng-template>
                  </div>
                  <div class="radio-card-overlay"></div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        orderDetailsNew.toothData.length > 0 &&
        orderDetailsNew.showHuman &&
        anteriorTeethForCrownOrPontic.length > 0
      "
    >
      <div class="col-4 mb-3">
        <app-prop-p
          [orderDetailsNew]="orderDetailsNew"
          [anterior]="true"
          [readonly]="true"
          [teeth]="anteriorTeethForCrownOrPontic"
        ></app-prop-p>
        <!-- interdental papilla anterior -->
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        orderDetailsNew.toothData.length > 0 &&
        orderDetailsNew.showHuman &&
        posteriorTeethForCrownOrPontic.length > 0
      "
    >
      <div class="col-4 mb-3">
        <app-prop-p
          [orderDetailsNew]="orderDetailsNew"
          [anterior]="false"
          [readonly]="true"
          [teeth]="posteriorTeethForCrownOrPontic"
        ></app-prop-p>
        <!-- interdental papilla posterior -->
      </div>
    </ng-container>

    <ng-container *ngFor="let data of orderDetailsNew.bridges; let i = index">
      <div
        class="col-4 mb-3"
        *ngIf="
          orderDetailsNew.toothData.length > 0 &&
          orderDetailsNew.showHuman &&
          anteriorTeethForCrownOrPonticFrame(data.bridgedTeeth).length > 0
        "
      >
        <app-prop-p-frame
          [orderDetailsNew]="orderDetailsNew"
          [anterior]="true"
          [readonly]="true"
          [teeth]="anteriorTeethForCrownOrPonticFrame(data.bridgedTeeth)"
          [i]="i"
        ></app-prop-p-frame>
        <!-- interdental papilla anterior -->
      </div>
      <div
        class="col-4 mb-3"
        *ngIf="
          orderDetailsNew.toothData.length > 0 &&
          orderDetailsNew.showHuman &&
          posteriorTeethForCrownOrPonticFrame(data.bridgedTeeth).length > 0
        "
      >
        <app-prop-p-frame
          [orderDetailsNew]="orderDetailsNew"
          [anterior]="false"
          [readonly]="true"
          [teeth]="posteriorTeethForCrownOrPonticFrame(data.bridgedTeeth)"
          [i]="i"
        ></app-prop-p-frame>
        <!-- interdental papilla posterior -->
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        anteriorTeethForAnatomy.length > 0 ||
        posteriorTeethForAnatomy.length > 0
      "
    >
      <div class="col-4 mb-3">
        <app-prop-h
          [readonly]="true"
          [orderDetailsNew]="orderDetailsNew"
        ></app-prop-h>
        <!-- occlusion contact -->
      </div>
    </ng-container>

    <ng-container *ngIf="anteriorTeethForAnatomy.length > 0">
      <div class="col-4">
        <div class="accordion-item info-card m-0 p-0">
          <h2 class="accordion-header m-0">
            <button
              style="font-size: 14px; background-color: #faf9f9"
              class="accordion-button collapsed p-0 p-3"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#os-f-1"
            >
              Occlusion Style &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for front tooth
                {{
                  dataService.rearrangedTeethOrder(anteriorTeethForAnatomy)
                }})</span
              >
            </button>
          </h2>

          <div id="os-f-1" class="accordion">
            <div class="accordion-body container text-center px-3 pt-2">
              <div
                class="radio-cards-container"
                style="
                  max-width: 51rem;
                  max-height: 10rem;
                  background-color: #faf9f9;
                "
              >
                <label
                  style="width: 100%"
                  class="radio-card-label mb-4"
                  *ngIf="
                    orderDetailsNew.props['Crown wear-front'] == 'Youthful'
                  "
                >
                  <input
                    disabled="true"
                    type="radio"
                    name="os-f-1"
                    [(ngModel)]="orderDetailsNew.props['Crown wear-front']"
                    value="Youthful"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <img
                      class="p-3"
                      width="150"
                      height="130"
                      src="Asset_Image_Gity/Occlusion_Style_Selection/for_front_tooth_11_12_13/Occlusion_2-Style_Youthful.png"
                    />
                  </div>
                  <div class="card-text">1. Youthful</div>
                  <div class="radio-card-overlay"></div>
                </label>
                <label
                  style="width: 100%"
                  class="radio-card-label mb-4"
                  *ngIf="orderDetailsNew.props['Crown wear-front'] == 'Regular'"
                >
                  <input
                    disabled="true"
                    type="radio"
                    name="os-f-1"
                    [(ngModel)]="orderDetailsNew.props['Crown wear-front']"
                    value="Regular"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <img
                      class="p-3"
                      width="150"
                      height="130"
                      src="Asset_Image_Gity/Occlusion_Style_Selection/for_front_tooth_11_12_13/Occlusion_2-Style_Regular.png"
                    />
                  </div>
                  <div class="card-text">2. Regular</div>
                  <div class="radio-card-overlay"></div>
                </label>
                <label
                  style="width: 100%"
                  class="radio-card-label mb-4"
                  *ngIf="orderDetailsNew.props['Crown wear-front'] == 'Mature'"
                >
                  <input
                    disabled="true"
                    type="radio"
                    name="os-f-1"
                    [(ngModel)]="orderDetailsNew.props['Crown wear-front']"
                    value="Mature"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <img
                      class="p-3"
                      width="150"
                      height="130"
                      src="Asset_Image_Gity/Occlusion_Style_Selection/for_front_tooth_11_12_13/Occlusion_2-Style_Mature.png"
                    />
                  </div>
                  <div class="card-text">3. Mature</div>
                  <div class="radio-card-overlay"></div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="posteriorTeethForAnatomy.length > 0">
      <div class="col-4">
        <div class="accordion-item info-card m-0 p-0">
          <h2 class="accordion-header m-0">
            <button
              style="font-size: 14px; background-color: #faf9f9"
              class="accordion-button collapsed p-0 p-3"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#os-s-1"
            >
              Occlusion Style &nbsp;&nbsp;
              <span style="font-size: small; color: #707070"
                >(for side tooth
                {{
                  dataService.rearrangedTeethOrder(posteriorTeethForAnatomy)
                }})</span
              >
            </button>
          </h2>

          <div id="os-s-1" class="accordion">
            <div class="accordion-body container text-center px-3 pt-2">
              <div
                class="radio-cards-container"
                style="
                  max-width: 51rem;
                  max-height: 10rem;
                  background-color: #faf9f9;
                "
              >
                <label
                  style="width: 100%"
                  class="radio-card-label mb-4"
                  *ngIf="orderDetailsNew.props['Crown wear-side'] == 'Youthful'"
                >
                  <input
                    disabled="true"
                    type="radio"
                    name="os-s-1"
                    [(ngModel)]="orderDetailsNew.props['Crown wear-side']"
                    value="Youthful"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <img
                      class="p-3"
                      width="170"
                      height="120"
                      src="Asset_Image_Gity/Occlusion_Style_Selection/for_side_tooth_14, 15, 16, 17, 18/Occlusion-Style_Youthful.png"
                    />
                  </div>
                  <div class="card-text">1. Youthful</div>
                  <div class="radio-card-overlay"></div>
                </label>
                <label
                  style="width: 100%"
                  class="radio-card-label mb-4"
                  *ngIf="orderDetailsNew.props['Crown wear-side'] == 'Regular'"
                >
                  <input
                    disabled="true"
                    type="radio"
                    name="os-s-1"
                    [(ngModel)]="orderDetailsNew.props['Crown wear-side']"
                    value="Regular"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <img
                      class="p-3"
                      width="170"
                      height="120"
                      src="Asset_Image_Gity/Occlusion_Style_Selection/for_side_tooth_14, 15, 16, 17, 18/Occlusion-Style_Regular.png"
                    />
                  </div>
                  <div class="card-text">2. Regular</div>
                  <div class="radio-card-overlay"></div>
                </label>
                <label
                  style="width: 100%"
                  class="radio-card-label mb-4"
                  *ngIf="orderDetailsNew.props['Crown wear-side'] == 'Mature'"
                >
                  <input
                    disabled="true"
                    type="radio"
                    name="os-s-1"
                    [(ngModel)]="orderDetailsNew.props['Crown wear-side']"
                    value="Mature"
                    class="hidden-radio-input"
                  />
                  <div class="custom-radio-indicator" data-html2canvas-ignore>
                    <div class="custom-radio-indicator-dot"></div>
                  </div>
                  <div class="card-icon">
                    <img
                      class="p-3"
                      width="170"
                      height="120"
                      src="Asset_Image_Gity/Occlusion_Style_Selection/for_side_tooth_14, 15, 16, 17, 18/Occlusion-Style_Mature.png"
                    />
                  </div>
                  <div class="card-text">3. Mature</div>
                  <div class="radio-card-overlay"></div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="anteriorPonticTeeth.length > 0 && orderDetailsNew.showHuman"
    >
      <div class="col-4 mb-3">
        <app-prop-pontic
          [readonly]="true"
          [orderDetailsNew]="orderDetailsNew"
          [teeth]="anteriorPonticTeeth"
          [anterior]="true"
        ></app-prop-pontic>
        <!-- Pontic Gestaltung Frontzahn -->
      </div>
    </ng-container>

    <ng-container
      *ngIf="posteriorPonticTeeth.length > 0 && orderDetailsNew.showHuman"
    >
      <div class="col-4 mb-3">
        <app-prop-pontic
          [readonly]="true"
          [orderDetailsNew]="orderDetailsNew"
          [teeth]="posteriorPonticTeeth"
          [anterior]="false"
        ></app-prop-pontic>
        <!-- Pontic Gestaltung Frontzahn -->
      </div>
    </ng-container>
  </div>

  <div *ngIf="fileDetailsImagesContent.length > 0">
    <div class="row border rounded m-2 py-4">
      <div class="row">
        <div class="col">
          <p *ngIf="fileDetailsImagesContent.length > 0" style="color: #205567">
            Images and Sketches:
          </p>
        </div>
      </div>

      <div class="row g-2">
        <div
          class="col-6"
          *ngFor="let imagesContent of fileDetailsImagesContent"
        >
          <img
            class="p-0"
            style="
              width: 590px;
              height: 390px;
              border: 2px solid #205567;
              border-radius: 1rem;
            "
            [src]="imagesContent"
          />
        </div>
      </div>
      <!-- <button style="display: inline !important;" class="customPreCreateTaskButtons m-3" (click)="generatePDF()">PDF </button> -->
    </div>
  </div>
</div>
<app-order-reiew-model
  #orderReviewModal
  *ngIf="showOrderReviewModal"
  [orderDetailsNew]="orderDetailsNew"
  [fileDetailsImagesContent]="fileDetailsImagesContent"
>
</app-order-reiew-model>
